const db = {
  "1h Blunt": {
    "870 1h Blunt Level 300": {
      name: "870 1h Blunt Level 300",
      min: 190,
      max: 220,
      type: "1h Blunt",
      blurb: "Generic baseline weapon for the 000 1h blunt flavor.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "140", quality: "" },
        maxDamage: { value: "440", quality: "" },
        critMod: { value: "240", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1200", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "1h Blunt": { value: "1501", quality: "" },
          Brawl: { value: "901", quality: "" },
          "Fast attack": { value: "751", quality: "" },
          Dimach: { value: "301", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 0,
      auno: "https://auno.org/ao/db.php?id=271077",
    },

    "Abandonment of the Xan": {
      versions: [
        {
          name: "Abandonment of the Xan",
          min: 190,
          max: 220,
          type: "1h Blunt",
          blurb:
            "Upgrade result from Lord of Abandonment. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "350", quality: "" },
            maxDamage: { value: "468", quality: "" },
            critMod: { value: "330", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1200", quality: "" },
            specials: { value: "Fast Attack, Brawl", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "" },
              "Title level": { value: "6", quality: "" },
              "1h Blunt": { value: "1800", quality: "" },
              "Fast attack": { value: "900", quality: "" },
              Brawl: { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280717",
          comparisons: ["870 1h Blunt Level 300"],
        },
        {
          name: "Abandonment of the Xan",
          min: 190,
          max: 220,
          type: "1h Blunt",
          blurb:
            "Upgrade result from Lord of Abandonment. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "350", quality: "" },
            maxDamage: { value: "468", quality: "" },
            critMod: { value: "330", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1200", quality: "" },
            specials: { value: "Fast Attack, Brawl", quality: "" },
            reqs: {
              "1h Blunt": { value: "1800", quality: "" },
              "Fast attack": { value: "900", quality: "" },
              Brawl: { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280717&patch=18000200",
        },
      ],
    },

    "Arctic Metaplast Mace": {
      name: "Arctic Metaplast Mace",
      min: 1,
      max: 200,
      type: "1h Blunt",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens. Extra attack bar gives it more potential than the usual 1h Blunt offerings.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "1.75s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "115", quality: "" },
        maxDamage: { value: "500", quality: "g" },
        critMod: { value: "290", quality: "" },
        attackCap: { value: "1800", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1050", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "1h Blunt": { value: "1101", quality: "" },
          "Fast attack": { value: "551", quality: "" },
          Brawl: { value: "661", quality: "" },
          "Martial arts (optional)": { value: "1499", quality: "r" },
        },
        mods: { "Max health": { value: "30", quality: "" } },
      },
      profs: ["Enforcer", "Meta-Physicist", "Trader"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=249035",
    },
    "Blood Bat": {
      name: "Blood Bat",
      min: 175,
      max: 220,
      type: "1h Blunt",
      blurb:
        "Drops from Ian Warr during the Mercenaries_Raid. Enforcer Only. An RK alternative to the Skull_of_Misery.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.75s", quality: "" },
        rSpeed: { value: "2.15s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "40", quality: "" },
        maxDamage: { value: "540", quality: "g" },
        critMod: { value: "225", quality: "" },
        attackCap: { value: "1200", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "914", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "g",
        },
        reqs: {
          Profession: { value: "Enforcer", quality: "r" },
          "1h Blunt": { value: "1101", quality: "" },
          "Sneak attack": { value: "551", quality: "" },
          "Fast attack": { value: "551", quality: "" },
          Brawl: { value: "661", quality: "" },
          Dimach: { value: "221", quality: "" },
        },
        mods: {
          "Max health": { value: "235", quality: "" },
          "Chemical AC": { value: "155", quality: "" },
          "Melee init": { value: "12", quality: "" },
        },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=165130",
    },
    "Blood Mace": {
      name: "Blood Mace",
      min: 175,
      max: 220,
      type: "1h Blunt",
      blurb: "Drops from Ian Warr during the Mercenaries_Raid.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.8s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "520", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1750", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "826", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          "1h Blunt": { value: "1151", quality: "" },
          "Fast attack": { value: "576", quality: "" },
          Brawl: { value: "691", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Poison AC": { value: "150", quality: "" },
          "Melee init": { value: "25", quality: "" },
        },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=165127",
    },
    "Corrupted Lord of Abandonment": {
      name: "Corrupted Lord of Abandonment",
      min: 205,
      max: 220,
      type: "1h Blunt",
      blurb: "Drops during the Home_Pyramid_raid.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "225", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1200", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "" },
          "Title level": { value: "7", quality: "" },
          "1h Blunt": { value: "2000", quality: "" },
          "Fast attack": { value: "900", quality: "" },
          Brawl: { value: "900", quality: "" },
        },
        mods: {
          "Max health": { value: "300", quality: "" },
          "Matter creation": { value: "30", quality: "" },
          "Offense modifier": { value: "15", quality: "" },
          "Defense modifier": { value: "15", quality: "" },
        },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302933",
    },
    "Dreadloch Enhanced Panther": {
      name: "Dreadloch Enhanced Panther",
      min: 190,
      max: 220,
      type: "1h Blunt",
      blurb:
        "Drops from Dreadloch_camps. Hits have a 5% chance to proc an AAD debuff.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "350", quality: "" },
        maxDamage: { value: "468", quality: "" },
        critMod: { value: "330", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1649", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "" },
          "1h Blunt": { value: "2201", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=267253",
    },

    "Howling Skull": {
      name: "Howling Skull",
      min: 30,
      max: 50,
      type: "1h Blunt",
      blurb:
        "Drops from named mobs in TOTW. Replaced by Skull_of_Lamentation & Skull_of_Woe.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "28", quality: "" },
        maxDamage: { value: "112", quality: "g" },
        critMod: { value: "6", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "112", quality: "g" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Blunt": { value: "305", quality: "g" },
          "Fast attack": { value: "116", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      auno: "https://auno.org/ao/db.php?id=204750",
      diff: 3,
    },
    "Illegally Modified Dreadloch Panther": {
      name: "Illegally Modified Dreadloch Panther",
      min: 210,
      max: 220,
      type: "1h Blunt",
      blurb:
        "Drops from Psion and Abmouth in the 18.8_Subway_raid. Hits have a 7% and 5% chance to proc an AAD debuff and runspeed debuff respectively.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "352", quality: "" },
        maxDamage: { value: "474", quality: "" },
        critMod: { value: "330", quality: "" },
        attackCap: { value: "2700", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1750", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          Level: { value: "210", quality: "" },
          "1h Blunt": { value: "2250", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305991",
    },
    "Improved Club": {
      name: "Improved Club",
      min: 1,
      max: 200,
      type: "1h Blunt",
      blurb: "One_of_the_mass_relocating_robot_tradeskills.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "110", quality: "" },
        maxDamage: { value: "364", quality: "" },
        critMod: { value: "120", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "827", quality: "" },
        specials: { value: "Brawl", quality: "" },
        reqs: {
          "1h Blunt": { value: "1117", quality: "" },
          Brawl: { value: "671", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=155860",
    },
    "Kur'Ush Mallet": {
      versions: [
        {
          name: "Kur'Ush Mallet",
          min: 190,
          max: 220,
          type: "1h Blunt",
          blurb: "One of the Xan_weapon_upgrades. Level locked from 190.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "369", quality: "" },
            maxDamage: { value: "468", quality: "" },
            critMod: { value: "330", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "" },
              "Title level": { value: "6", quality: "" },
              "1h Blunt": { value: "2251", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Biological metamorphosis": { value: "15", quality: "" },
              "Psychological modifications": { value: "15", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=281503",
        },
        {
          name: "Kur'Ush Mallet",
          min: 190,
          max: 220,
          type: "1h Blunt",
          blurb: "One of the Xan_weapon_upgrades. Level locked from 190.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "369", quality: "" },
            maxDamage: { value: "468", quality: "" },
            critMod: { value: "330", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
            reqs: {
              "1h Blunt": { value: "2251", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Biological metamorphosis": { value: "15", quality: "" },
              "Psychological modifications": { value: "15", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=281503&patch=18010000",
        },
      ],
    },
    "Kyr'Ozch Hammer": {
      name: "Kyr'Ozch Hammer",
      min: 1,
      max: 200,
      type: "1h Blunt",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "300", quality: "" },
        maxDamage: { value: "425", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "" },
          "1h Blunt": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254674",
    },
    "Mortiig Beater": {
      name: "Mortiig Beater",
      min: 100,
      max: 200,
      type: "1h Blunt",
      blurb:
        "Drops from Mortiig bosses in Elysium, Shadowlands. Enforcer only. Notable locations include Spade Beach and Eastfang.",
      stats: {
        ql: { value: "100-125", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "450", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "750", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "625", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Enforcer", quality: "r" },
          "1h Blunt": { value: "626", quality: "g" },
          "Fast attack": { value: "313", quality: "" },
          Brawl: { value: "376", quality: "" },
          Dimach: { value: "126", quality: "" },
        },
        mods: { "Body development": { value: "40", quality: "" } },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=246355",
    },
    "Ofab Panther": {
      name: "Ofab Panther",
      min: 1,
      max: 200,
      type: "1h Blunt",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "330", quality: "" },
        maxDamage: { value: "468", quality: "" },
        critMod: { value: "330", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1649", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "" },
          "1h Blunt": { value: "2201", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=264977",
    },
    "Schiacciamento Vento": {
      name: "Schiacciamento Vento",
      min: 1,
      max: 135,
      type: "1h Blunt",
      blurb:
        "Sold by Tsunayoshi_Smith. Model listed is QL 135 interpolation as it is the highest reported to be sold. The vendor sells variants of this weapon with different special attacks.",
      stats: {
        ql: { value: "1-135", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "17", quality: "" },
        maxDamage: { value: "277", quality: "" },
        critMod: { value: "115", quality: "" },
        attackCap: { value: "818", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "477", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "1h Blunt": { value: "677", quality: "" },
          "Fast attack": { value: "339", quality: "" },
          Brawl: { value: "406", quality: "" },
          Dimach: { value: "136", quality: "" },
        },
        mods: {
          Agility: { value: "2", quality: "" },
          Psychic: { value: "2", quality: "" },
          "Melee init": { value: "6", quality: "" },
        },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=164057&ql=135",
    },
    "Skull of Despair": {
      name: "Skull of Despair",
      min: 175,
      max: 220,
      type: "1h Blunt",
      blurb:
        "Drops in third floor IS. Right hand only. Compliments Skull_of_Misery.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "3s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "170", quality: "" },
        maxDamage: { value: "558", quality: "g" },
        critMod: { value: "33", quality: "" },
        attackCap: { value: "1200", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "904", quality: "" },
        specials: { value: "", quality: "" },
        reqs: { "1h Blunt": { value: "1049", quality: "r" } },
        mods: { "Max health": { value: "25", quality: "" } },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206060",
    },

    "Skull of Lamentation": {
      name: "Skull of Lamentation",
      min: 50,
      max: 110,
      type: "1h Blunt",
      blurb:
        "Drops from Lien the Memorystalker in TOTW. Right hand only. Typical upgrade from Howling_Skull. Compliments Skull_of_Woe.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "52", quality: "" },
        maxDamage: { value: "140", quality: "g" },
        critMod: { value: "10", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "112", quality: "g" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Blunt": { value: "417", quality: "" },
          "Fast attack": { value: "201", quality: "" },
        },
        mods: { "Max health": { value: "15", quality: "" } },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      auno: "https://auno.org/ao/db.php?id=204752",
      diff: 4,
    },
    "Skull of Misery": {
      name: "Skull of Misery",
      min: 175,
      max: 220,
      type: "1h Blunt",
      blurb:
        "Drops in third floor IS. Left hand only. Compliments Skull_of_Despair.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "2.2s", quality: "" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "120", quality: "" },
        maxDamage: { value: "506", quality: "g" },
        critMod: { value: "104", quality: "" },
        attackCap: { value: "1200", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "904", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Blunt": { value: "1049", quality: "r" },
          "Fast attack": { value: "809", quality: "" },
        },
        mods: { "Max health": { value: "25", quality: "" } },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      auno: "https://auno.org/ao/db.php?id=206059",
      diff: 6,
    },

    "Skull of Woe": {
      name: "Skull of Woe",
      min: 50,
      max: 110,
      type: "1h Blunt",
      blurb:
        "Drops from Lien the Memorystalker in TOTW. Left hand only. Typical upgrade from Howling_Skull. Compliments Skull_of_Lamentation.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "49", quality: "" },
        maxDamage: { value: "142", quality: "g" },
        critMod: { value: "11", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "112", quality: "g" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Blunt": { value: "417", quality: "" },
          "Fast attack": { value: "201", quality: "" },
        },
        mods: { "Max health": { value: "15", quality: "" } },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      auno: "https://auno.org/ao/db.php?id=204751",
      diff: 4,
    },
    "Special Edition Kyr'Ozch Hammer": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Hammer",
          min: 151,
          max: 200,
          type: "1h Blunt",
          blurb:
            "Drops from Sector_07_aliens. Enforcer and Meta-Physicist only. Level locked to 151. Hits have a 5+5% chance to proc an AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "236", quality: "" },
            maxDamage: { value: "306", quality: "" },
            critMod: { value: "220", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "" },
              Level: { value: "151", quality: "" },
              Profession: { value: "Enforcer or Meta-Physicist", quality: "" },
              "1h Blunt": { value: "700", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288292",
        },
        {
          name: "Special Edition Kyr'Ozch Hammer",
          min: 151,
          max: 200,
          type: "1h Blunt",
          blurb:
            "Drops from Sector_07_aliens. Enforcer and Meta-Physicist only. Hits have a 5+5% chance to proc an AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "236", quality: "" },
            maxDamage: { value: "306", quality: "" },
            critMod: { value: "220", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "" },
              Profession: { value: "Enforcer or Meta-Physicist", quality: "" },
              "1h Blunt": { value: "700", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288292",
        },
      ],
    },
  },

  "1h Edged": {
    "Blade of Aesthetic Rage": {
      name: "Blade of Aesthetic Rage",
      min: 40,
      max: 100,
      type: "1h Edged",
      blurb: "Drops from Dynas.",
      stats: {
        ql: { value: "70-75", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "2.3s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "150", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "455", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "1h Edged": { value: "343", quality: "" },
          "Fast attack": { value: "172", quality: "" },
          Brawl: { value: "206", quality: "" },
          Dimach: { value: "69", quality: "" },
        },
        mods: {
          "Melee init": { value: "12", quality: "" },
          Parry: { value: "8", quality: "" },
          "Evade close": { value: "12", quality: "" },
        },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208074",
    },
    "Ceremonial Blade": {
      name: "Ceremonial Blade",
      min: 201,
      max: 220,
      type: "1h Edged",
      blurb: "Drops from Nematet and Aztur in the 18.8_TOTW_raid.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "295", quality: "" },
        maxDamage: { value: "365", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2650", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack", quality: "" },
        reqs: {
          Level: { value: "201", quality: "" },
          "1h Edged": { value: "2150", quality: "" },
          "Sneak attack": { value: "1050", quality: "" },
          "Fast attack": { value: "1050", quality: "" },
        },
        mods: { Concealment: { value: "50", quality: "" } },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305520",
    },
    "Chef Cleaver": {
      name: "Chef Cleaver",
      min: 80,
      max: 190,
      type: "1h Edged",
      blurb: "Drops from Dryad Dynas in Adonis, Shadowlands. Enforcer only.",
      stats: {
        ql: { value: "140-160", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "175", quality: "" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "1000", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "720", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "" },
          Profession: { value: "Enforcer", quality: "" },
          "1h Edged": { value: "801", quality: "" },
          "Fast attack": { value: "401", quality: "" },
          Brawl: { value: "481", quality: "" },
        },
        mods: {
          "Multi melee": { value: "20", quality: "" },
          "Offense modifier": { value: "10", quality: "" },
          "Heal delta": { value: "4", quality: "" },
        },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=245584",
    },
    "Corrupted Lord of Hatred": {
      name: "Corrupted Lord of Hatred",
      min: 205,
      max: 220,
      type: "1h Edged",
      blurb: "Drops during the Home_Pyramid_raid. Level locked from 205.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "250", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1200", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "",
        },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "" },
          "Title level": { value: "7", quality: "" },
          "1h Edged": { value: "2000", quality: "" },
          "Sneak attack": { value: "900", quality: "" },
          "Fast attack": { value: "900", quality: "" },
          Brawl: { value: "1000", quality: "" },
          Dimach: { value: "451", quality: "" },
        },
        mods: {
          "Max health": { value: "300", quality: "" },
          "Matter metamorphosis": { value: "15", quality: "" },
          "Biological metamorphosis": { value: "15", quality: "" },
          "Psychological modifications": { value: "15", quality: "" },
        },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302934",
    },
    Chiroptera: {
      name: "Chiroptera",
      min: 80,
      max: 200,
      type: "1h Edged",
      blurb:
        "Drops from Cenobite Shadows in COH. Profession locked to Enforcer and Adventurer. Stats vary significantly across the 5 QLs.",
      stats: {
        ql: { value: "100-105", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.25s", quality: "" },
        rSpeed: { value: "1.25s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "1250", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1000", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "",
        },
        reqs: {
          Profession: { value: "Enforcer or Adventurer", quality: "" },
          "1h Edged": { value: "1001", quality: "" },
          "Sneak attack": { value: "501", quality: "" },
          "Fast attack": { value: "501", quality: "" },
          Brawl: { value: "601", quality: "" },
          Dimach: { value: "201", quality: "" },
        },
        mods: {
          "Nano pool": { value: "40", quality: "" },
          "Nano cost modifier": { value: "2", quality: "" },
        },
      },
      profs: ["Adventurer", "Enforcer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=246714",
    },
    "Frozen Tear of Uklesh": {
      name: "Frozen Tear of Uklesh",
      min: 50,
      max: 100,
      type: "1h Edged",
      blurb:
        "Drops from Uklesh the Frozen in TOTW. Hits have a 8% chance to proc an instant damage program.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "95", quality: "" },
        maxDamage: { value: "148", quality: "g" },
        critMod: { value: "0", quality: "" },
        attackCap: { value: "700", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "230", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Edged": { value: "357", quality: "g" },
          "Fast attack": { value: "181", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=204739",
    },
    "Gelid Blade of Inobak": {
      name: "Gelid Blade of Inobak",
      min: 150,
      max: 205,
      type: "1h Edged",
      blurb:
        "Drops from Inobak the Gelid in IS. Hits have a 8% chance to proc an instant damage program.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "184", quality: "" },
        maxDamage: { value: "409", quality: "" },
        critMod: { value: "89", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "904", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Edged": { value: "1049", quality: "" },
          "Fast attack": { value: "909", quality: "" },
        },
        mods: { "Max health": { value: "50", quality: "" } },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206057",
    },
    "Hatred of the Xan": {
      versions: [
        {
          name: "Hatred of the Xan",
          min: 190,
          max: 220,
          type: "1h Edged",
          blurb:
            "Upgrade result from Lord of Hatred. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.3s", quality: "" },
            rSpeed: { value: "1.3s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "325", quality: "" },
            maxDamage: { value: "358", quality: "" },
            critMod: { value: "325", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Brawl, Dimach",
              quality: "",
            },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "" },
              "Title level": { value: "6", quality: "" },
              "1h Edged": { value: "2251", quality: "" },
              "Sneak attack": { value: "1126", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Matter metamorphosis": { value: "15", quality: "" },
              "Biological metamorphosis": { value: "15", quality: "" },
              "Psychological modifications": { value: "15", quality: "" },
            },
          },
          profs: ["Enforcer", "Adventurer"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280718",
        },
        {
          name: "Hatred of the Xan",
          min: 190,
          max: 220,
          type: "1h Edged",
          blurb:
            "Upgrade result from Lord of Hatred. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.3s", quality: "" },
            rSpeed: { value: "1.3s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "325", quality: "" },
            maxDamage: { value: "358", quality: "" },
            critMod: { value: "325", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Brawl, Dimach",
              quality: "",
            },
            reqs: {
              "1h Edged": { value: "2251", quality: "" },
              "Sneak attack": { value: "1126", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Matter metamorphosis": { value: "15", quality: "" },
              "Biological metamorphosis": { value: "15", quality: "" },
              "Psychological modifications": { value: "15", quality: "" },
            },
          },
          profs: ["Enforcer", "Adventurer"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280718&patch=18000200",
        },
      ],
    },
    "Icebound Heart": {
      name: "Icebound Heart",
      min: 150,
      max: 190,
      type: "1h Edged",
      blurb: "Drops in IS.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "116", quality: "" },
        maxDamage: { value: "379", quality: "" },
        critMod: { value: "49", quality: "" },
        attackCap: { value: "1150", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "820", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Edged": { value: "1003", quality: "" },
          "Fast attack": { value: "841", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=206056",
    },
    "Illegally Augmented Ofab Mongoose": {
      name: "Illegally Augmented Ofab Mongoose",
      min: 210,
      max: 220,
      type: "1h Edged",
      blurb:
        "Drops from the Queen of the Slums in the 18.8_Subway_raid. Hits have a 3% chance to proc a DOT/NDOT/nano drain.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "315", quality: "" },
        maxDamage: { value: "368", quality: "" },
        critMod: { value: "301", quality: "" },
        attackCap: { value: "2650", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1700", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "",
        },
        reqs: {
          Level: { value: "210", quality: "" },
          "1h Edged": { value: "2250", quality: "" },
          "Fast attack": { value: "1100", quality: "" },
          "Sneak attack": { value: "1100", quality: "" },
          Brawl: { value: "1300", quality: "" },
          Dimach: { value: "600", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305985",
    },
    "Impious Dominator": {
      name: "Impious Dominator",
      min: 150,
      max: 200,
      type: "1h Edged",
      blurb: "Drops from Hazek the Immortal in IS.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "186", quality: "" },
        maxDamage: { value: "422", quality: "" },
        critMod: { value: "78", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1100", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Edged": { value: "1051", quality: "" },
          "Fast attack": { value: "927", quality: "" },
        },
        mods: { "Max health": { value: "205", quality: "" } },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206052",
    },

    "Kyr'Ozch Axe": {
      name: "Kyr'Ozch Axe",
      min: 1,
      max: 200,
      type: "1h Edged",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "275", quality: "g" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "275", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "1h Edged": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254688",
    },
    "Lord of Hatred": {
      name: "Lord of Hatred",
      min: 190,
      max: 215,
      type: "1h Edged",
      blurb: "Drops during The_Beast_raid. Upgrades to Hatred of the Xan.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "20", quality: "" },
        maxDamage: { value: "600", quality: "" },
        critMod: { value: "20", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1750", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Brawl", quality: "" },
        reqs: {
          "Title level": { value: "6", quality: "" },
          "1h Edged": { value: "2251", quality: "" },
          "Sneak attack": { value: "1126", quality: "" },
          "Fast attack": { value: "1126", quality: "" },
          Brawl: { value: "1351", quality: "" },
        },
        mods: {
          "Max health": { value: "350", quality: "" },
          "Biological metamorphosis": { value: "30", quality: "" },
          "Max nano": { value: "350", quality: "" },
        },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=244762",
    },
    "Mantis Scissors": {
      name: "Mantis Scissors",
      min: 146,
      max: 190,
      type: "1h Edged",
      blurb:
        "Drops in the Mantis_Den. Can be upgraded with Diamondine Soldier loot.",
      stats: {
        ql: { value: "185", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.96s", quality: "" },
        rSpeed: { value: "1.15s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "95", quality: "" },
        maxDamage: { value: "346", quality: "" },
        critMod: { value: "110", quality: "" },
        attackCap: { value: "1100", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "880", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack", quality: "" },
        reqs: {
          "1h Edged": { value: "1007", quality: "" },
          "Fast attack": { value: "705", quality: "" },
          "Sneak attack": { value: "405", quality: "" },
          Level: { value: "146", quality: "" },
        },
        mods: {
          "Max health": { value: "30", quality: "" },
          "Poison AC": { value: "100", quality: "" },
        },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=157760",
    },

    "Meibutsu Daito": {
      name: "Meibutsu Daito",
      min: 1,
      max: 135,
      type: "1h Edged",
      blurb:
        "Sold by Tsunayoshi_Smith. Model listed is QL 135 interpolation as it is the highest reported to be sold. The vendor sells variants of this weapon with different special attacks.",
      stats: {
        ql: { value: "1-135", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.55s", quality: "" },
        rSpeed: { value: "2.4s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "10", quality: "" },
        maxDamage: { value: "347", quality: "" },
        critMod: { value: "173", quality: "" },
        attackCap: { value: "818", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "509", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "",
        },
        reqs: {
          "1h Edged": { value: "812", quality: "" },
          "Sneak attack": { value: "406", quality: "" },
          "Fast attack": { value: "406", quality: "" },
          Brawl: { value: "487", quality: "" },
          Dimach: { value: "163", quality: "" },
        },
        mods: { "Evade close": { value: "6", quality: "" } },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=164017&ql=135",
    },
    Nervejolter: {
      name: "Nervejolter",
      min: 40,
      max: 80,
      type: "1h Edged",
      blurb:
        "Drops from Pulsing Hatred in Steps_of_Madness. Hits have a 10% chance to proc a taunt.",
      stats: {
        ql: { value: "50", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.28s", quality: "" },
        rSpeed: { value: "2.09s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "60", quality: "" },
        maxDamage: { value: "110", quality: "" },
        critMod: { value: "25", quality: "" },
        attackCap: { value: "650", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "170", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          "1h Edged": { value: "301", quality: "" },
          "Fast attack": { value: "151", quality: "" },
          Brawl: { value: "126", quality: "" },
        },
        mods: { "Radiation AC": { value: "20", quality: "" } },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=152025",
    },

    "Ofab Mongoose": {
      name: "Ofab Mongoose",
      min: 1,
      max: 200,
      type: "1h Edged",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "1.2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "303", quality: "" },
        maxDamage: { value: "358", quality: "" },
        critMod: { value: "303", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1649", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "",
        },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "" },
          "1h Edged": { value: "2201", quality: "" },
          "Sneak attack": { value: "1101", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=264935",
    },

    "Phase Blade": {
      name: "Phase Blade",
      min: 30,
      max: 50,
      type: "1h Edged",
      blurb:
        "Drops from named mobs in TOTW. Naturally upgrades to Frozen_Tear_of_Uklesh.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "35", quality: "" },
        maxDamage: { value: "121", quality: "g" },
        critMod: { value: "0", quality: "" },
        attackCap: { value: "700", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "165", quality: "g" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "1h Edged": { value: "305", quality: "" },
          "Fast attack": { value: "146", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=204745",
    },
    "SOL Fire Executioner": {
      name: "SOL Fire Executioner",
      min: 1,
      max: 200,
      type: "1h Edged",
      blurb:
        "Drops from common pools and blitzable. Comes in 4 flavors with different special attacks.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "830", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          "1h Edged": { value: "1036", quality: "" },
          "Fast attack": { value: "519", quality: "" },
          Brawl: { value: "622", quality: "" },
          Dimach: { value: "208", quality: "" },
        },
        mods: { "Evade close": { value: "20", quality: "" } },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=160238",
    },
    "Survival Axe of Genevra": {
      name: "Survival Axe of Genevra",
      min: 1,
      max: 200,
      type: "1h Edged",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens. Speeds get slighty faster as the QL rises.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1.05s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "110", quality: "" },
        maxDamage: { value: "420", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1800", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1050", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "" },
          "1h Edged": { value: "1101", quality: "" },
          "Fast attack": { value: "551", quality: "" },
          Brawl: { value: "661", quality: "" },
        },
        mods: {
          "Max health": { value: "75", quality: "" },
          "Run speed": { value: "30", quality: "" },
        },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=249055",
    },
    "Sword of Wonder": {
      name: "Sword of Wonder",
      min: 150,
      max: 205,
      type: "1h Edged",
      blurb: "Drops from Eremites in Inferno, Shadowlands.",
      stats: {
        ql: { value: "240-260", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "600", quality: "" },
        critMod: { value: "600", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "Sneak Attack, Brawl", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "" },
          "1h Edged": { value: "1601", quality: "" },
          "Sneak attack": { value: "801", quality: "" },
          Brawl: { value: "961", quality: "" },
        },
        mods: {
          Perception: { value: "80", quality: "" },
          "Run speed": { value: "80", quality: "" },
        },
      },
      profs: ["Enforcer", "Adventurer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=246105",
    },
  },
  "2h Blunt": {
    "Absolution Hammer": {
      name: "Absolution Hammer",
      min: 40,
      max: 80,
      type: "2h Blunt",
      blurb: "Drops from hammer-wielding cultists in TOTW. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.1s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "101", quality: "" },
        maxDamage: { value: "242", quality: "" },
        critMod: { value: "37", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "2h Blunt": { value: "301", quality: "" },
          Brawl: { value: "151", quality: "" },
          Dimach: { value: "101", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Enforcer", "Meta-Physicist"],
      diff: 69,
      prk: true,
    },
    "Aggressive Staff of Julian Redfire": {
      versions: [
        {
          name: "Aggressive Staff of Julian Redfire",
          min: 190,
          max: 220,
          type: "2h Blunt",
          blurb:
            "Dust_Brigade_mission_reward. Meta-Physicist only. Enables casting an AAO buff on attack pet. Uses Time & Space as an attack skill.",
          stats: {
            ql: { value: "215", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "6 m", quality: "" },
            minDamage: { value: "325", quality: "" },
            maxDamage: { value: "600", quality: "" },
            critMod: { value: "650", quality: "" },
            attackCap: { value: "", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "" },
            reqs: {
              Profession: { value: "Meta-Physicist", quality: "" },
              Cyberdeck: { value: "6", quality: "" },
              "Biological metamorphosis": { value: "2109", quality: "" },
              "Time and space": { value: "2209", quality: "" },
              "2h Blunt": { value: "850", quality: "" },
            },
            mods: { "Nano init": { value: "300", quality: "" } },
          },
          profs: ["Meta-Physicist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=275019",
        },
        {
          name: "Aggressive Staff of Julian Redfire",
          min: 190,
          max: 220,
          type: "2h Blunt",
          blurb:
            "Dust_Brigade_mission_reward. Meta-Physicist only. Enables casting an AAO buff on attack pet. Uses Time & Space as an attack skill more prominently.",
          stats: {
            ql: { value: "215", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.6s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "6 m", quality: "" },
            minDamage: { value: "325", quality: "" },
            maxDamage: { value: "600", quality: "" },
            critMod: { value: "650", quality: "" },
            attackCap: { value: "", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "" },
            reqs: {
              Profession: { value: "Meta-Physicist", quality: "" },
              Cyberdeck: { value: "6", quality: "" },
              "Biological metamorphosis": { value: "2109", quality: "" },
              "Time and space": { value: "2209", quality: "" },
              "2h Blunt": { value: "850", quality: "" },
            },
            mods: { "Nano init": { value: "300", quality: "" } },
          },
          profs: ["Meta-Physicist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=275019&patch=17090000",
        },
      ],
    },
    "Corrupted Lord of Gluttony": {
      name: "Corrupted Lord of Gluttony",
      min: 205,
      max: 220,
      type: "2h Blunt",
      blurb: "Drops during the Home_Pyramid_raid.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.9s", quality: "" },
        rSpeed: { value: "1.9s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "250", quality: "" },
        maxDamage: { value: "650", quality: "" },
        critMod: { value: "450", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "" },
          "Title level": { value: "7", quality: "" },
          "2h Blunt": { value: "1800", quality: "" },
          "Fast attack": { value: "900", quality: "" },
        },
        mods: {
          "Max health": { value: "500", quality: "" },
          "Matter creation": { value: "30", quality: "" },
          "Offense modifier": { value: "30", quality: "" },
        },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302949",
    },
    "Dreadloch Enhanced Bear": {
      name: "Dreadloch Enhanced Bear",
      min: 190,
      max: 220,
      type: "2h Blunt",
      blurb:
        "Drops from Dreadloch_camps. Hits have a 5% chance to proc an AAD debuff. ",
      stats: {
        ql: { value: "", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "440", quality: "" },
        maxDamage: { value: "578", quality: "" },
        critMod: { value: "450", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "" },
          "2h Blunt": { value: "2201", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=267254",
    },
    "Gluttony of the Xan": {
      versions: [
        {
          name: "Gluttony of the Xan",
          min: 190,
          max: 220,
          type: "2h Blunt",
          blurb:
            "Upgrade result from Lord of Gluttony. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "440", quality: "" },
            maxDamage: { value: "578", quality: "" },
            critMod: { value: "450", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "" },
              "Title level": { value: "6", quality: "" },
              "2h Blunt": { value: "1800", quality: "" },
              "Fast attack": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Matter creation": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280721",
        },
        {
          name: "Gluttony of the Xan",
          min: 190,
          max: 220,
          type: "2h Blunt",
          blurb:
            "Upgrade result from Lord of Gluttony. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "440", quality: "" },
            maxDamage: { value: "578", quality: "" },
            critMod: { value: "450", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack", quality: "" },
            reqs: {
              "2h Blunt": { value: "1800", quality: "" },
              "Fast attack": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Matter creation": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280721&patch=18010000",
        },
      ],
    },

    "Healing Staff of Alcofribas Nasier": {
      name: "Healing Staff of Alcofribas Nasier",
      min: 150,
      max: 220,
      type: "2h Blunt",
      blurb:
        "Inferno_Anansi_mission_reward. Enables casting a heal modifier buff on heal pet. Uses Time & Space as an attack skill more prominently.",
      stats: {
        ql: { value: "205", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.6s", quality: "" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "280", quality: "" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "" },
          Profession: { value: "Meta-Physicist", quality: "" },
          "Biological metamorphosis": { value: "1466", quality: "" },
          "Time and space": { value: "1463", quality: "" },
          "2h Blunt": { value: "850", quality: "" },
        },
        mods: { "Nano init": { value: "200", quality: "" } },
      },
      profs: ["Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=260772",
    },

    Howlet: {
      name: "Howlet",
      min: 80,
      max: 200,
      type: "2h Blunt",
      blurb:
        "Drops from Cenobite Shadows in COH. Profession locked to Enforcer and Meta-Physicist. Stats vary significantly across the 5 QLs.",
      stats: {
        ql: { value: "100-105", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.25s", quality: "g" },
        rSpeed: { value: "1.25s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "125", quality: "" },
        maxDamage: { value: "625", quality: "g" },
        critMod: { value: "125", quality: "" },
        attackCap: { value: "1250", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Profession: { value: "Meta-Physicist or Enforcer", quality: "r" },
          "2h Blunt": { value: "1001", quality: "" },
          "Fast attack": { value: "501", quality: "" },
          Brawl: { value: "601", quality: "" },
          Dimach: { value: "201", quality: "" },
        },
        mods: {
          "Nano pool": { value: "40", quality: "" },
          "Nano cost modifier": { value: "2", quality: "" },
        },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=246709",
    },
    Icebreaker: {
      name: "Icebreaker",
      min: 25,
      max: 60,
      type: "2h Blunt",
      blurb: "Drops from Dynas. Enforcer only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.2s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "175", quality: "g" },
        critMod: { value: "175", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Profession: { value: "Enforcer", quality: "r" },
          "2h Blunt": { value: "248", quality: "g" },
          "Fast attack": { value: "125", quality: "" },
          Brawl: { value: "149", quality: "" },
          Dimach: { value: "50", quality: "" },
        },
        mods: {
          "Max health": { value: "40", quality: "" },
          "Melee AC": { value: "60", quality: "" },
          "Melee init": { value: "20", quality: "" },
        },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208061",
    },

    "Kyr'Ozch Sledgehammer": {
      name: "Kyr'Ozch Sledgehammer",
      min: 1,
      max: 200,
      type: "2h Blunt",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "375", quality: "g" },
        maxDamage: { value: "525", quality: "" },
        critMod: { value: "375", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "2h Blunt": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254730",
    },
    "Lightened Murder Maul": {
      versions: [
        {
          name: "Lightened Murder Maul",
          min: 201,
          max: 220,
          type: "2h Blunt",
          blurb: "Weapon_tradeskilled_from_alien_parts. Level locked from 201.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "250", quality: "" },
            maxDamage: { value: "575", quality: "" },
            critMod: { value: "250", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Brawl", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "" },
              Level: { value: "201", quality: "" },
              "2h Blunt": { value: "2001", quality: "" },
              Brawl: { value: "1201", quality: "" },
            },
            mods: {
              "Body development": { value: "50", quality: "" },
              "Evade close": { value: "30", quality: "" },
              Psychology: { value: "70", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=257111",
        },
        {
          name: "Lightened Murder Maul",
          min: 201,
          max: 220,
          type: "2h Blunt",
          blurb:
            "Weapon_tradeskilled_from_alien_parts. Level locked from 210. Significantly slower.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3.25s", quality: "" },
            rSpeed: { value: "3.25s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "250", quality: "" },
            maxDamage: { value: "575", quality: "" },
            critMod: { value: "250", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Brawl", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "" },
              Level: { value: "210", quality: "" },
              "2h Blunt": { value: "2001", quality: "" },
              Brawl: { value: "1201", quality: "" },
            },
            mods: {
              "Body development": { value: "50", quality: "" },
              "Evade close": { value: "30", quality: "" },
              Psychology: { value: "70", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=257111&patch=15080000",
        },
      ],
    },
    "Mesmerizing Staff of Francois": {
      versions: [
        {
          name: "Mesmerizing Staff of Francois",
          min: 70,
          max: 150,
          type: "2h Blunt",
          blurb:
            "Scheol_scientist_mission_reward. Meta-Physicist only. Enables casting an nanoskill buff on mezz pet. Uses Time & Space as an attack skill more prominently.",
          stats: {
            ql: { value: "205", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.6s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "180", quality: "" },
            maxDamage: { value: "325", quality: "" },
            critMod: { value: "175", quality: "" },
            attackCap: { value: "", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "" },
              "2h Blunt": { value: "449", quality: "" },
              "Time and space": { value: "567", quality: "" },
            },
            mods: { "Nano init": { value: "100", quality: "" } },
          },
          profs: ["Meta-Physicist"],
          prk: false,
          diff: 4,
          auno: "https://auno.org/ao/db.php?id=263299",
        },
        {
          name: "Mesmerizing Staff of Francois",
          min: 70,
          max: 150,
          type: "2h Blunt",
          blurb:
            "Scheol_scientist_mission_reward. Meta-Physicist only. Enables casting an nanoskill buff on mezz pet. Uses Time & Space as an attack skill more prominently.",
          stats: {
            ql: { value: "205", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.6s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "180", quality: "" },
            maxDamage: { value: "275", quality: "" },
            critMod: { value: "175", quality: "" },
            attackCap: { value: "", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "" },
              "2h Blunt": { value: "449", quality: "" },
              "Time and space": { value: "567", quality: "" },
            },
            mods: { "Nano init": { value: "100", quality: "" } },
          },
          profs: ["Meta-Physicist"],
          prk: true,
          diff: 4,
          auno: "https://auno.org/ao/db.php?id=263299&patch=17090000",
        },
      ],
    },

    "Neleb's Nightmare Battlerod": {
      versions: [
        {
          name: "Neleb's Nightmare Battlerod",
          min: 40,
          max: 125,
          type: "2h Blunt",
          blurb:
            "Neleb the Deranged's rod. The weapon base drops from Neleb, and is then upgraded with items you find in Steps_of_Madness. Hits transfer 5 nano from the target to the user.",
          stats: {
            ql: { value: "53", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "g" },
            rSpeed: { value: "3s", quality: "r" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "75", quality: "" },
            maxDamage: { value: "330", quality: "g" },
            critMod: { value: "30", quality: "" },
            attackCap: { value: "800", quality: "g" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack", quality: "" },
            reqs: {
              "2h Blunt": { value: "351", quality: "g" },
              "Fast attack": { value: "201", quality: "" },
            },
            mods: { "Max nano": { value: "100", quality: "" } },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: false,
          auno: "https://auno.org/ao/db.php?id=274955&patch=18085300",
          diff: 5,
        },
        {
          name: "Neleb's Nightmare Battlerod",
          min: 40,
          max: 125,
          type: "2h Blunt",
          blurb:
            "Neleb the Deranged's rod. The weapon base drops from Neleb, and is then upgraded with items you find in Steps_of_Madness. Hits transfer 20 nano from the target to the user.",
          stats: {
            ql: { value: "53", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1s", quality: "g" },
            rSpeed: { value: "3s", quality: "r" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "75", quality: "" },
            maxDamage: { value: "330", quality: "g" },
            critMod: { value: "30", quality: "" },
            attackCap: { value: "800", quality: "g" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack", quality: "" },
            reqs: {
              "2h Blunt": { value: "351", quality: "g" },
              "Fast attack": { value: "201", quality: "" },
            },
            mods: { "Max nano": { value: "100", quality: "" } },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          auno: "https://auno.org/ao/db.php?id=274955&patch=17090000",
          diff: 5,
        },
      ],
    },

    "Ofab Bear": {
      name: "Ofab Bear",
      min: 1,
      max: 200,
      type: "2h Blunt",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "413", quality: "" },
        maxDamage: { value: "578", quality: "" },
        critMod: { value: "413", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "" },
          "2h Blunt": { value: "2201", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=265278",
    },

    "Punishment Rod": {
      name: "Punishment Rod",
      min: 185,
      max: 220,
      type: "2h Blunt",
      blurb:
        "Drops from Obediency_Enforcer. Enforcer only and level locked to 185.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "5.2s", quality: "r" },
        rSpeed: { value: "4s", quality: "r" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "427", quality: "" },
        maxDamage: { value: "1127", quality: "g" },
        critMod: { value: "6", quality: "" },
        attackCap: { value: "1200", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          Profession: { value: "Enforcer", quality: "r" },
          "2h Blunt": { value: "1010", quality: "" },
          "Fast attack": { value: "620", quality: "" },
          Level: { value: "185", quality: "r" },
        },
        mods: {},
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=201943",
    },
    "Special Edition Kyr'Ozch Sledgehammer": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Sledgehammer",
          min: 151,
          max: 200,
          type: "2h Blunt",
          blurb:
            "Drops from Sector_07_aliens. Enforcer only. Level locked to 151. Hits have a 5% chance to proc an AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "250", quality: "" },
            maxDamage: { value: "330", quality: "" },
            critMod: { value: "350", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "" },
              Level: { value: "151", quality: "" },
              Profession: { value: "Enforcer", quality: "" },
              "2h Blunt": { value: "700", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Enforcer"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288285",
        },
        {
          name: "Special Edition Kyr'Ozch Sledgehammer",
          min: 151,
          max: 200,
          type: "2h Blunt",
          blurb:
            "Drops from Sector_07_aliens. Enforcer only. Hits have a 5% chance to proc an AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "250", quality: "" },
            maxDamage: { value: "330", quality: "" },
            critMod: { value: "350", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "" },
              Profession: { value: "Enforcer", quality: "" },
              "2h Blunt": { value: "700", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Enforcer"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288285",
        },
      ],
    },

    "Support Beam of Intolerance": {
      name: "Support Beam of Intolerance",
      min: 10,
      max: 40,
      type: "2h Blunt",
      blurb:
        "Drops from Workman Striker mobs in the Subway. One high level Workman Striker mob can be found in deep Subway to drop the higher QLs. Model listed is QL 30 interpolation. QL is hidden in game. Breed locked to Atrox.",
      stats: {
        ql: { value: "10-30", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3.5s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "11", quality: "" },
        maxDamage: { value: "122", quality: "g" },
        critMod: { value: "114", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          Breed: { value: "Atrox", quality: "r" },
          "2h Blunt": { value: "202", quality: "" },
          Brawl: { value: "123", quality: "" },
          Dimach: { value: "44", quality: "" },
          Psychology: { value: "101", quality: "r" },
        },
        mods: { "Max health": { value: "20", quality: "" } },
      },
      profs: ["Enforcer", "Meta-Physicist"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=202720",
    },
    "Vicious Support Beam of Malice": {
      name: "Vicious Support Beam of Malice",
      min: 220,
      max: 220,
      type: "2h Blunt",
      blurb:
        "Drops from Abmouth Supremus in the 18.8_Subway_raid. Enforcer only. Level locked at 220. Hits have a 15% chance to proc a taunt.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "5 m", quality: "" },
        minDamage: { value: "450", quality: "" },
        maxDamage: { value: "585", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2800", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: {
          value: "Fast Attack, Sneak Attack, Brawl, Dimach",
          quality: "",
        },
        reqs: {
          Level: { value: "220", quality: "" },
          Profession: { value: "Enforcer", quality: "" },
          "2h Blunt": { value: "2200", quality: "" },
          Brawl: { value: "1300", quality: "" },
          "Fast attack": { value: "1200", quality: "" },
          "Sneak attack": { value: "1200", quality: "" },
          Dimach: { value: "400", quality: "" },
        },
        mods: { "Max health": { value: "750", quality: "" } },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305965",
    },
  },
  "2h Edged": {
    "Abyssal Desecrator": {
      name: "Abyssal Desecrator",
      min: 125,
      max: 200,
      type: "2h Edged",
      blurb:
        "Drops from Hezak the Immortal in IS. High level variant of Stygian Desecrator, lacking any proc.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.8s", quality: "r" },
        rSpeed: { value: "3s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "233", quality: "" },
        maxDamage: { value: "666", quality: "g" },
        critMod: { value: "0", quality: "" },
        attackCap: { value: "1200", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "2h Edged": { value: "1065", quality: "" },
          "Fast attack": { value: "941", quality: "" },
        },
        mods: {
          "Max health": { value: "75", quality: "" },
          "Energy AC": { value: "140", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206058",
    },
    "Blade of Khione": {
      name: "Blade of Khione",
      min: 175,
      max: 215,
      type: "2h Edged",
      blurb:
        "Mission reward for Keepers during Xan_Civilization_Quest. Keeper only. Comes with a -500 to melee inits. Can be upgraded with escaped_prisoner_drops.",
      stats: {
        ql: { value: "", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "r" },
        rSpeed: { value: "1.2s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "390", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2050", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Keeper", quality: "r" },
          "2h Edged": { value: "1485", quality: "" },
          "Fast attack": { value: "835", quality: "" },
        },
        mods: {
          "Max health": { value: "150", quality: "" },
          "Melee init": { value: "-500", quality: "" },
          "Nano init": { value: "-150", quality: "" },
        },
      },
      profs: ["Keeper"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=269513",
    },

    "Copy of The Excalibur": {
      versions: [
        {
          name: "Copy of The Excalibur",
          min: 150,
          max: 220,
          type: "2h Edged",
          blurb: "Drops from Tuq'usk, a dynaboss in Inferno. Keeper only.",
          stats: {
            ql: { value: "240-260", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1s", quality: "g" },
            rSpeed: { value: "1s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "800", quality: "g" },
            critMod: { value: "200", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              Profession: { value: "Keeper", quality: "r" },
              "2h Edged": { value: "1601", quality: "" },
              "Fast attack": { value: "801", quality: "" },
              Dimach: { value: "321", quality: "" },
              Parry: { value: "641", quality: "" },
              Riposte: { value: "641", quality: "" },
            },
            mods: { "Melee AC": { value: "600", quality: "" } },
          },
          profs: ["Keeper"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=246018",
        },
        {
          name: "Copy of The Excalibur",
          min: 150,
          max: 220,
          type: "2h Edged",
          blurb:
            "Drops from Tuq'usk, a dynaboss in Inferno. Keeper only. Missing Fast attack.",
          stats: {
            ql: { value: "240-260", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1s", quality: "g" },
            rSpeed: { value: "1s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "800", quality: "g" },
            critMod: { value: "200", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Dimach", quality: "r" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              Profession: { value: "Keeper", quality: "r" },
              "2h Edged": { value: "1601", quality: "" },
              Dimach: { value: "321", quality: "" },
              Parry: { value: "641", quality: "" },
              Riposte: { value: "641", quality: "" },
            },
            mods: { "Melee AC": { value: "600", quality: "" } },
          },
          profs: ["Keeper"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=246018&patch=15040000",
        },
      ],
    },
    "Corpse Cutter": {
      versions: [
        {
          name: "Corpse Cutter",
          min: 80,
          max: 175,
          type: "2h Edged",
          blurb: "Drops from Dynas. Enforcer and Keeper only.",
          stats: {
            ql: { value: "140-150", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.75s", quality: "" },
            rSpeed: { value: "3.75s", quality: "r" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "100", quality: "" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "100", quality: "" },
            attackCap: { value: "2200", quality: "g" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl", quality: "" },
            reqs: {
              Profession: { value: "Enforcer or Keeper", quality: "r" },
              "2h Edged": { value: "747", quality: "g" },
              "Fast attack": { value: "374", quality: "" },
              Brawl: { value: "449", quality: "" },
            },
            mods: {
              "Max health": { value: "150", quality: "" },
              "Cold AC": { value: "300", quality: "" },
              Brawl: { value: "20", quality: "" },
            },
          },
          profs: ["Enforcer", "Keeper"],
          prk: false,
          diff: 3,
          auno: "https://auno.org/ao/db.php?id=208018&patch=18085300",
        },
        {
          name: "Corpse Cutter",
          min: 80,
          max: 175,
          type: "2h Edged",
          blurb: "Drops from Dynas. Enforcer only.",
          stats: {
            ql: { value: "140-150", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.75s", quality: "" },
            rSpeed: { value: "3.75s", quality: "r" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "100", quality: "" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "100", quality: "" },
            attackCap: { value: "2200", quality: "g" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl", quality: "" },
            reqs: {
              Profession: { value: "Enforcer", quality: "r" },
              "2h Edged": { value: "747", quality: "g" },
              "Fast attack": { value: "374", quality: "" },
              Brawl: { value: "449", quality: "" },
            },
            mods: {
              "Max health": { value: "150", quality: "" },
              "Cold AC": { value: "300", quality: "" },
              Brawl: { value: "20", quality: "" },
            },
          },
          profs: ["Enforcer", "Keeper"],
          prk: true,
          diff: 3,
          auno: "https://auno.org/ao/db.php?id=208016&patch=15000100",
        },
      ],
    },

    "Corrupted Edge": {
      name: "Corrupted Edge",
      min: 215,
      max: 220,
      type: "2h Edged",
      blurb: "Drops from Binyacht the Faithful during the 18.8_TOTW_raid.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.3s", quality: "g" },
        rSpeed: { value: "1.3s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "425", quality: "g" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2650", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Level: { value: "201", quality: "r" },
          "2h Edged": { value: "2251", quality: "" },
          "Fast attack": { value: "1126", quality: "" },
          Brawl: { value: "1351", quality: "" },
          Dimach: { value: "451", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "25", quality: "" },
          "Dodge ranged": { value: "25", quality: "" },
          "Evade close": { value: "25", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305521",
    },
    "Corrupted Lord of Pride": {
      name: "Corrupted Lord of Pride",
      min: 205,
      max: 220,
      type: "2h Edged",
      blurb: "Drops during the Home_Pyramid_raid.",
      stats: {
        ql: { value: "", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "250", quality: "" },
        maxDamage: { value: "625", quality: "g" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan?", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          "2h Edged": { value: "2000", quality: "" },
          "Fast attack": { value: "900", quality: "" },
          Brawl: { value: "900", quality: "" },
          Dimach: { value: "451", quality: "" },
        },
        mods: {
          "Max health": { value: "300", quality: "" },
          "Biological metamorphosis": { value: "30", quality: "" },
          "Psychological modifications": { value: "30", quality: "" },
          "Defense modifier": { value: "15", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302936",
    },

    "Energy Scythe": {
      name: "Energy Scythe",
      min: 30,
      max: 50,
      type: "2h Edged",
      blurb:
        "Drops from named mobs in TOTW. Upgrades naturally to Frost_Scythe_of_the_Legionnaire.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.8s", quality: "" },
        rSpeed: { value: "3.2s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "92", quality: "" },
        maxDamage: { value: "224", quality: "g" },
        critMod: { value: "37", quality: "" },
        attackCap: { value: "700", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "2h Edged": { value: "305", quality: "g" },
          "Fast attack": { value: "161", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=204747",
    },
    "Frost-bound Reaper": {
      name: "Frost-bound Reaper",
      min: 125,
      max: 215,
      type: "2h Edged",
      blurb:
        "Drops in IS. Carries a -1110 to melee init and -150 to nano init, making the speeds misleading.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "r" },
        rSpeed: { value: "1s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "386", quality: "g" },
        maxDamage: { value: "386", quality: "g" },
        critMod: { value: "0", quality: "" },
        attackCap: { value: "1150", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: { "2h Edged": { value: "1040", quality: "" } },
        mods: {
          "Max health": { value: "30", quality: "" },
          "Melee init": { value: "-1110", quality: "" },
          "Nano init": { value: "-150", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=206061",
    },

    "Frost Scythe of the Legionnaire": {
      name: "Frost Scythe of the Legionnaire",
      min: 40,
      max: 80,
      type: "2h Edged",
      blurb:
        "Drops from Deathless Legionnaires in TOTW. Upgrades naturally to Stygian_Desolator.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.8s", quality: "" },
        rSpeed: { value: "3.2s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "227", quality: "g" },
        maxDamage: { value: "227", quality: "g" },
        critMod: { value: "0", quality: "" },
        attackCap: { value: "700", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "2h Edged": { value: "357", quality: "g" },
          "Fast attack": { value: "191", quality: "" },
        },
        mods: { "Max health": { value: "15", quality: "" } },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=204746",
    },
    "Guard of the Gentleman": {
      name: "Guard of the Gentleman",
      min: 1,
      max: 50,
      type: "2h Edged",
      blurb:
        "Sold by Shadowlands melee weapons vendors in the sided gardens. Part of some common SL loot pools. Model listed is QL 29 interpolation. Upgrades to Energy_Scythe.",
      stats: {
        ql: { value: "1-300", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.19s", quality: "g" },
        rSpeed: { value: "1.19s", quality: "g" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "5", quality: "" },
        maxDamage: { value: "84", quality: "g" },
        critMod: { value: "37", quality: "" },
        attackCap: { value: "214", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Dimach", quality: "r" },
        reqs: {
          Profession: { value: "Enforcer or Keeper", quality: "r" },
          "2h Edged": { value: "175", quality: "g" },
          "Fast attack": { value: "88", quality: "" },
          Dimach: { value: "36", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 0,
      auno: "https://auno.org/ao/db.php?id=231255",
    },
    "Jobe Defender Naginata": {
      name: "Jobe Defender Naginata",
      min: 1,
      max: 200,
      type: "2h Edged",
      blurb: "Sold by Shadowlands garden vendors. Enforcer and Keeper only.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2200", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Dimach", quality: "" },
        reqs: {
          Profession: { value: "Enforcer or Keeper", quality: "r" },
          "2h Edged": { value: "1801", quality: "" },
          "Fast attack": { value: "901", quality: "" },
          Dimach: { value: "361", quality: "" },
          Parry: { value: "721", quality: "" },
          Riposte: { value: "721", quality: "" },
        },
        mods: {
          "Energy AC": { value: "320", quality: "" },
          "Radiation AC": { value: "320", quality: "" },
          "Max nano": { value: "160", quality: "" },
        },
      },
      profs: ["Keeper", "Enforcer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=231220",
    },
    "Kyr'Ozch Sword": {
      name: "Kyr'Ozch Sword",
      min: 1,
      max: 200,
      type: "2h Edged",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "375", quality: "g" },
        maxDamage: { value: "475", quality: "" },
        critMod: { value: "375", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "2h Edged": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Keeper", "Enforcer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254758",
    },
    "Landsknecht Zweihander": {
      name: "Landsknecht Zweihander",
      min: 25,
      max: 50,
      type: "2h Edged",
      blurb:
        "Drops from Dynas. Doesn't see much use due to overlap with TOTW arsenal.",
      stats: {
        ql: { value: "40-80", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "120", quality: "g" },
        maxDamage: { value: "160", quality: "" },
        critMod: { value: "240", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Brawl", quality: "" },
        reqs: {
          "2h Edged": { value: "414", quality: "" },
          "Melee energy": { value: "276", quality: "r" },
          Brawl: { value: "276", quality: "" },
        },
        mods: { "Evade close": { value: "20", quality: "" } },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208082",
    },

    Longmoon: {
      name: "Longmoon",
      min: 1,
      max: 200,
      type: "2h Edged",
      blurb: "Blitzable and part of common loot pools.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "44", quality: "" },
        maxDamage: { value: "460", quality: "" },
        critMod: { value: "101", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "2h Edged": { value: "1020", quality: "" },
          Brawl: { value: "612", quality: "" },
          Dimach: { value: "205", quality: "" },
        },
        mods: {},
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=122063",
    },
    "Lost Blade of Elder Tsunayoshi": {
      name: "Lost Blade of Elder Tsunayoshi",
      min: 215,
      max: 220,
      type: "2h Edged",
      blurb:
        "Drops from Vergil in the 18.8_Subway_raid. Level locked from 215. Hits have a 5% chance to proc an init debuff.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.3s", quality: "g" },
        rSpeed: { value: "1.3s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "450", quality: "g" },
        maxDamage: { value: "555", quality: "g" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2750", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Level: { value: "215", quality: "r" },
          "2h Edged": { value: "2250", quality: "" },
          Brawl: { value: "1300", quality: "" },
          Dimach: { value: "500", quality: "" },
          "Fast attack": { value: "1250", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "30", quality: "" },
          "Dodge ranged": { value: "30", quality: "" },
          "Evade close": { value: "30", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305993",
    },

    "Meibutsu Katana of Celerity": {
      name: "Meibutsu Katana of Celerity",
      min: 1,
      max: 135,
      type: "2h Edged",
      blurb:
        "Sold by Tsunayoshi_Smith. Enforcer only. Model listed is QL 135 interpolation as it is the highest reported to be sold. The vendor sells variants of this weapon with different special attacks.",
      stats: {
        ql: { value: "1-135", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.55s", quality: "" },
        rSpeed: { value: "2.4s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "38", quality: "" },
        maxDamage: { value: "347", quality: "" },
        critMod: { value: "220", quality: "" },
        attackCap: { value: "818", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Profession: { value: "Enforcer", quality: "r" },
          "2h Edged": { value: "677", quality: "" },
          "Fast attack": { value: "339", quality: "" },
          Brawl: { value: "406", quality: "" },
          Dimach: { value: "136", quality: "" },
        },
        mods: {
          Riposte: { value: "10", quality: "" },
          "Body development": { value: "10", quality: "" },
        },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=164037&ql=135",
    },
    "Obsidian Desecrator": {
      name: "Obsidian Desecrator",
      min: 210,
      max: 220,
      type: "2h Edged",
      blurb:
        "Drops from Aztur the Immortal during the 18.8_TOTW_raid. Level locked to 210+. Hits have a 5% chance to proc a combined DOT, AAO/AAD debuff.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "g" },
        rSpeed: { value: "1.4s", quality: "g" },
        range: { value: "4m", quality: "" },
        minDamage: { value: "425", quality: "g" },
        maxDamage: { value: "575", quality: "g" },
        critMod: { value: "666", quality: "g" },
        attackCap: { value: "2750", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Level: { value: "210", quality: "r" },
          "2h Edged": { value: "2150", quality: "" },
          "Fast attack": { value: "1150", quality: "" },
          Brawl: { value: "1250", quality: "" },
          Dimach: { value: "450", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Energy AC": { value: "666", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305530",
    },
    "Ofab Wolf": {
      name: "Ofab Wolf",
      min: 1,
      max: 200,
      type: "2h Edged",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "413", quality: "g" },
        maxDamage: { value: "523", quality: "g" },
        critMod: { value: "413", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          "2h Edged": { value: "2201", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Brawl: { value: "1321", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Keeper", "Enforcer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=265236",
    },

    Panther: {
      versions: [
        {
          name: "Panther",
          min: 80,
          max: 200,
          type: "2h Edged",
          blurb:
            "Drops from Cenobite Shadows in COH. Profession locked to Keeper, Enforcer and Meta-Physicist. Stats vary significantly across the 5 QLs.",
          stats: {
            ql: { value: "100-105", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.25s", quality: "g" },
            rSpeed: { value: "1.25s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "125", quality: "" },
            maxDamage: { value: "625", quality: "g" },
            critMod: { value: "125", quality: "" },
            attackCap: { value: "1250", quality: "r" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              Profession: {
                value: "Keeper, Enforcer or Meta-Physicist",
                quality: "r",
              },
              "2h Edged": { value: "1000", quality: "r" },
              "Fast attack": { value: "500", quality: "" },
              Brawl: { value: "600", quality: "" },
              Dimach: { value: "200", quality: "" },
            },
            mods: {
              "Nano pool": { value: "40", quality: "" },
              "Nano cost modifier": { value: "2", quality: "" },
            },
          },
          profs: ["Keeper", "Enforcer", "Meta-Physicist"],
          prk: false,
          diff: 4,
          auno: "https://auno.org/ao/db.php?id=246719",
        },
        {
          name: "Panther",
          min: 100,
          max: 200,
          type: "2h Edged",
          blurb:
            "Drops from Cenobite Shadows in COH. Profession locked to Enforcer and Meta-Physicist. Stats vary significantly across the 5 QLs.",
          stats: {
            ql: { value: "100-105", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.25s", quality: "g" },
            rSpeed: { value: "1.25s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "125", quality: "" },
            maxDamage: { value: "625", quality: "g" },
            critMod: { value: "125", quality: "" },
            attackCap: { value: "1250", quality: "r" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              Profession: { value: "Enforcer or Meta-Physicist", quality: "r" },
              "2h Edged": { value: "1001", quality: "r" },
              "Fast attack": { value: "501", quality: "" },
              Brawl: { value: "601", quality: "" },
              Dimach: { value: "201", quality: "" },
            },
            mods: {
              "Nano pool": { value: "40", quality: "" },
              "Nano cost modifier": { value: "2", quality: "" },
            },
          },
          profs: ["Enforcer", "Meta-Physicist"],
          prk: true,
          diff: 4,
          auno: "https://auno.org/ao/db.php?id=246719&patch=15050000",
        },
      ],
    },
    Permafrost: {
      name: "Permafrost",
      min: 125,
      max: 200,
      type: "2h Edged",
      blurb:
        "Drops in IS. Hits have a 7% chance to proc a root. High level variant of TOTW's energy scythe.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.9s", quality: "r" },
        rSpeed: { value: "1.2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "247", quality: "" },
        maxDamage: { value: "634", quality: "g" },
        critMod: { value: "2", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "2h Edged": { value: "1089", quality: "" },
          "Fast attack": { value: "893", quality: "" },
        },
        mods: { "Max health": { value: "40", quality: "" } },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=206062",
    },

    "Pride of the Xan": {
      versions: [
        {
          name: "Pride of the Xan",
          min: 190,
          max: 220,
          type: "2h Edged",
          blurb:
            "Upgrade result from Lord of Pride. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "441", quality: "g" },
            maxDamage: { value: "558", quality: "g" },
            critMod: { value: "444", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Title level": { value: "6", quality: "r" },
              "Expansion sets": { value: "Legacy of the Xan?", quality: "r" },
              "2h Edged": { value: "2251", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Biological metamorphosis": { value: "30", quality: "" },
              "Psychological modifications": { value: "30", quality: "" },
              "Defense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Enforcer", "Keeper"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280720",
        },
        {
          name: "Pride of the Xan",
          min: 190,
          max: 220,
          type: "2h Edged",
          blurb:
            "Upgrade result from Lord_of_Greed. Upgrade drops during 3_different_raids.",
          stats: {
            ql: { value: "", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "441", quality: "g" },
            maxDamage: { value: "558", quality: "g" },
            critMod: { value: "444", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "2h Edged": { value: "2251", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Biological metamorphosis": { value: "30", quality: "" },
              "Psychological modifications": { value: "30", quality: "" },
              "Defense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Enforcer", "Keeper"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280720&patch=18000200",
        },
      ],
    },
    "Queen Blade": {
      name: "Queen Blade",
      min: 161,
      max: 200,
      type: "2h Edged",
      blurb:
        "Drops from the Mantis Queen in the Mantis_Den. Level locked from 161. Can be enhanced_further with Diamondine Soldier loot.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "4s (capped at 1.8s)", quality: "r" },
        rSpeed: { value: "7.2s (capped at 3.1s)", quality: "r" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "417", quality: "" },
        maxDamage: { value: "1083", quality: "g" },
        critMod: { value: "66", quality: "" },
        attackCap: { value: "1100", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          Level: { value: "161", quality: "r" },
          "2h Edged": { value: "1023", quality: "" },
          Brawl: { value: "486", quality: "" },
          Dimach: { value: "263", quality: "" },
        },
        mods: {
          "Max health": { value: "320", quality: "" },
          "Chemical AC": { value: "150", quality: "" },
          "Poison AC": { value: "150", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=157761",
    },
    "Special Edition Kyr'Ozch Sword": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Sword",
          min: 151,
          max: 200,
          type: "2h Edged",
          blurb:
            "Drops from Sector_07_aliens. Enforcer and Keeper only. Level locked to 151. Hits have a 5% chance to proc an AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "259", quality: "g" },
            maxDamage: { value: "333", quality: "" },
            critMod: { value: "259", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Enforcer or Keeper", quality: "r" },
              Level: { value: "151", quality: "r" },
              "2h Edged": { value: "700", quality: "g" },
              "Fast attack": { value: "350", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Enforcer", "Keeper"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=288294",
        },
        {
          name: "Special Edition Kyr'Ozch Sword",
          min: 151,
          max: 200,
          type: "2h Edged",
          blurb:
            "Drops from Sector_07_aliens. Enforcer and Keeper only. Hits have a 5% chance to proc an AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "259", quality: "g" },
            maxDamage: { value: "333", quality: "" },
            critMod: { value: "259", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Enforcer or Keeper", quality: "r" },
              "2h Edged": { value: "700", quality: "g" },
              "Fast attack": { value: "350", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Enforcer", "Keeper"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=288294&patch=18041400",
        },
      ],
    },
    "Stygian Desolator": {
      name: "Stygian Desolator",
      min: 50,
      max: 130,
      type: "2h Edged",
      blurb:
        "Aztur the Immortal's sword. Drops in TOTW. Hits have a 6% to activate its proc, which applies a DOT and AAD/AAO debuff.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "3.3s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "331", quality: "g" },
        critMod: { value: "33", quality: "" },
        attackCap: { value: "800", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "2h Edged": { value: "434", quality: "g" },
          "Fast attack": { value: "245", quality: "" },
        },
        mods: {
          "Max health": { value: "20", quality: "" },
          "Energy AC": { value: "80", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      auno: "https://auno.org/ao/db.php?id=204755",
      diff: 5,
    },
    "Sword of Achilles": {
      name: "Sword of Achilles",
      min: 1,
      max: 200,
      type: "2h Edged",
      blurb:
        "Drops from the Catacombs statics in the Shadowlands. Keeper only. Comes in 3 variants that hit different ACs.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "475", quality: "" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Dimach", quality: "" },
        reqs: {
          Profession: { value: "Keeper", quality: "r" },
          "2h Edged": { value: "2001", quality: "" },
          "Fast attack": { value: "1001", quality: "" },
          Dimach: { value: "401", quality: "" },
          Parry: { value: "801", quality: "" },
          Riposte: { value: "801", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "50", quality: "" },
          "Dodge ranged": { value: "50", quality: "" },
          "Evade close": { value: "50", quality: "" },
        },
      },
      profs: ["Keeper"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=233285",
    },
    "Sword of Lord Mordeth": {
      versions: [
        {
          name: "Sword of Lord Mordeth",
          min: 200,
          max: 220,
          type: "2h Edged",
          blurb:
            "Drops from Lord Mordeth, an Unredeemed boss in Inferno, Shadowlands. Keeper only.",
          stats: {
            ql: { value: "199-200", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.8s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "90", quality: "" },
            maxDamage: { value: "900", quality: "g" },
            critMod: { value: "90", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Brawl",
              quality: "",
            },
            reqs: {
              Profession: { value: "Keeper", quality: "r" },
              "2h Edged": { value: "1261", quality: "" },
              "Melee energy": { value: "841", quality: "" },
              "Fast attack": { value: "701", quality: "" },
              Brawl: { value: "841", quality: "" },
              "Sneak attack": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "500", quality: "" },
              "Defense modifier": { value: "10", quality: "" },
            },
          },
          profs: ["Keeper"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=225513",
        },
        {
          name: "Sword of Lord Mordeth",
          min: 200,
          max: 220,
          type: "2h Edged",
          blurb:
            "Drops from Lord Mordeth, an Unredeemed boss in Inferno, Shadowlands. Keeper only.",
          stats: {
            ql: { value: "199-200", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3.5s", quality: "r" },
            rSpeed: { value: "3.5s", quality: "r" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "90", quality: "" },
            maxDamage: { value: "900", quality: "g" },
            critMod: { value: "90", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl", quality: "r" },
            reqs: {
              Profession: { value: "Keeper", quality: "r" },
              "2h Edged": { value: "1261", quality: "" },
              "Melee energy": { value: "841", quality: "" },
              "Fast attack": { value: "701", quality: "" },
              Brawl: { value: "841", quality: "" },
            },
            mods: {
              "Max health": { value: "500", quality: "" },
              "Defense modifier": { value: "10", quality: "" },
              Scale: { value: "2", quality: "" },
            },
          },
          profs: ["Keeper"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=225513&patch=15000100",
        },
      ],
    },
    "Sword of Sir Galahad": {
      versions: [
        {
          name: "Sword of Sir Galahad",
          min: 200,
          max: 220,
          type: "2h Edged",
          blurb:
            "Drops from Sir Galahad, a Redeemed boss in Inferno, Shadowlands. Keeper only.",
          stats: {
            ql: { value: "199-200", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.8s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "90", quality: "" },
            maxDamage: { value: "900", quality: "g" },
            critMod: { value: "90", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Brawl",
              quality: "",
            },
            reqs: {
              Profession: { value: "Keeper", quality: "r" },
              "2h Edged": { value: "1261", quality: "" },
              "Melee energy": { value: "841", quality: "" },
              "Fast attack": { value: "701", quality: "" },
              Brawl: { value: "841", quality: "" },
              "Sneak attack": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "500", quality: "" },
              "Defense modifier": { value: "10", quality: "" },
            },
          },
          profs: ["Keeper"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=225513",
        },
        {
          name: "Sword of Sir Galahad",
          min: 200,
          max: 220,
          type: "2h Edged",
          blurb:
            "Drops from Sir Galahad, a Redeemed boss in Inferno, Shadowlands. Keeper only.",
          stats: {
            ql: { value: "199-200", quality: "r" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3.5s", quality: "r" },
            rSpeed: { value: "3.5s", quality: "r" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "90", quality: "" },
            maxDamage: { value: "900", quality: "g" },
            critMod: { value: "90", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fast Attack, Brawl", quality: "r" },
            reqs: {
              Profession: { value: "Keeper", quality: "r" },
              "2h Edged": { value: "1261", quality: "" },
              "Melee energy": { value: "841", quality: "" },
              "Fast attack": { value: "701", quality: "" },
              Brawl: { value: "841", quality: "" },
            },
            mods: {
              "Max health": { value: "500", quality: "" },
              "Defense modifier": { value: "10", quality: "" },
              Scale: { value: "2", quality: "" },
            },
          },
          profs: ["Keeper"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=225513&patch=15000100",
        },
      ],
    },

    "Sword of Sir Tristram": {
      name: "Sword of Sir Tristram",
      min: 1,
      max: 200,
      type: "2h Edged",
      blurb: "Sold from Shadowlands garden merchants. Keeper only.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2200", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Dimach", quality: "" },
        reqs: {
          Profession: { value: "Keeper", quality: "r" },
          "2h Edged": { value: "1801", quality: "" },
          "Fast attack": { value: "901", quality: "" },
          Dimach: { value: "361", quality: "" },
          Parry: { value: "721", quality: "r" },
          Riposte: { value: "721", quality: "r" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Melee AC": { value: "200", quality: "" },
          "Defense modifier": { value: "5", quality: "" },
        },
      },
      profs: ["Keeper"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=231139",
    },
    "Sword of the Illuminated": {
      name: "Sword of the Illuminated",
      min: 80,
      max: 175,
      type: "2h Edged",
      blurb: "Drops from Dryad Dynas in Adonis, Shadowlands. Keeper only.",
      stats: {
        ql: { value: "140-160", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "1000", quality: "r" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Dimach", quality: "" },
        reqs: {
          Profession: { value: "Keeper", quality: "r" },
          "2h Edged": { value: "801", quality: "g" },
          "Fast attack": { value: "401", quality: "" },
          Dimach: { value: "161", quality: "" },
          Parry: { value: "321", quality: "" },
          Riposte: { value: "321", quality: "" },
        },
        mods: {
          Intelligence: { value: "25", quality: "" },
          "Max nano": { value: "125", quality: "" },
        },
      },
      profs: ["Keeper"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=245580",
    },
    Tangleblade: {
      name: "Tangleblade",
      min: 60,
      max: 125,
      type: "2h Edged",
      blurb: "Drops from Dynas. Breed locked to Solitus. Clan only.",
      stats: {
        ql: { value: "100-125", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3.25s", quality: "r" },
        rSpeed: { value: "3.5s", quality: "r" },
        range: { value: "5 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "525", quality: "g" },
        critMod: { value: "175", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          Breed: { value: "Solitus", quality: "r" },
          Faction: { value: "Clan", quality: "r" },
          "2h Edged": { value: "651", quality: "" },
          "Fast attack": { value: "326", quality: "" },
          Brawl: { value: "391", quality: "" },
          Dimach: { value: "131", quality: "" },
        },
        mods: {
          Stamina: { value: "6", quality: "" },
          Psychic: { value: "6", quality: "" },
          "Melee init": { value: "18", quality: "" },
        },
      },
      profs: ["Enforcer", "Keeper"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=207994",
    },

    "The Edge of the Tarasque": {
      name: "The Edge of the Tarasque",
      min: 200,
      max: 220,
      type: "2h Edged",
      blurb:
        "Drops from Tarasque. Keeper only. Can be upgraded with DeValos_loot. The upgraded version is Enforcer enabled. Has a 2% chance to proc a DOT.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "5 m", quality: "" },
        minDamage: { value: "40", quality: "r" },
        maxDamage: { value: "630", quality: "g" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2350", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          Profession: { value: "Keeper", quality: "r" },
          "2h Edged": { value: "1249", quality: "" },
          "Fast attack": { value: "625", quality: "" },
          Brawl: { value: "750", quality: "" },
        },
        mods: {
          "Max health": { value: "350", quality: "" },
          "Poison AC": { value: "300", quality: "" },
          "Melee init": { value: "40", quality: "" },
        },
      },
      profs: ["Keeper"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=157856",
    },
  },

  "Martial arts": {
    "Blades of Boltar": {
      versions: [
        {
          name: "Blades of Boltar",
          min: 201,
          max: 220,
          type: "Martial arts",
          blurb:
            "Weapon_tradeskilled_from_alien_parts. Level locked from 201. Can be upgraded with loot from the same raid.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.1s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "260", quality: "g" },
            maxDamage: { value: "330", quality: "" },
            critMod: { value: "520", quality: "g" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "900", quality: "" },
            specials: { value: "Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "201", quality: "r" },
              "Martial arts": { value: "2000", quality: "" },
              Brawl: { value: "1335", quality: "" },
              Dimach: { value: "445", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader", "Martial Artist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=257147",
        },
        {
          name: "Blades of Boltar",
          min: 210,
          max: 220,
          type: "Martial arts",
          blurb: "Weapon_tradeskilled_from_alien_parts. Level locked from 210.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.1s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "1 m", quality: "" },
            minDamage: { value: "145", quality: "" },
            maxDamage: { value: "225", quality: "" },
            critMod: { value: "520", quality: "g" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "900", quality: "" },
            specials: { value: "Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "210", quality: "r" },
              "Martial arts": { value: "2000", quality: "" },
              Brawl: { value: "1335", quality: "" },
              Dimach: { value: "445", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader", "Martial Artist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=257147&patch=15080000",
        },
      ],
    },
    "Corrupted Lord of Wisdom": {
      name: "Corrupted Lord of Wisdom",
      min: 205,
      max: 220,
      type: "Martial arts",
      blurb:
        "Drops during the Home_Pyramid_raid. Level locked from 205. Right hand only. Left hand version is Corrupted Lady of Wisdom. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "1750", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
        reqs: {
          "Title level": { value: "7", quality: "r" },
          "Martial arts": { value: "2000", quality: "" },
          "Fast attack": { value: "1000", quality: "" },
          Brawl: { value: "1100", quality: "" },
          Dimach: { value: "451", quality: "" },
        },
        mods: {
          "Max health": { value: "150", quality: "" },
          "Sensory improvement": { value: "7", quality: "" },
          "Biological metamorphosis": { value: "7", quality: "" },
          "Offense modifier": { value: "7", quality: "" },
        },
      },
      profs: ["Martial Artist", "Trader"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302946",
    },
    "Dreadloch Shen Sticks": {
      name: "Dreadloch Shen Sticks",
      min: 210,
      max: 220,
      type: "Martial arts",
      blurb:
        "Drops from Dreadloch_camps. Level locked from 210. Hits have a 2% chance to proc a nano init and heal modifier debuff. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "310", quality: "" },
        maxDamage: { value: "490", quality: "" },
        critMod: { value: "500", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "1550", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Level: { value: "210", quality: "r" },
          "Martial arts": { value: "2101", quality: "" },
          Brawl: { value: "1301", quality: "" },
          Dimach: { value: "651", quality: "" },
        },
        mods: { "Max health": { value: "250", quality: "" } },
      },
      profs: ["Martial Artist", "Trader"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=267258",
    },
    "Hazangerine Bear Claw": {
      name: "Hazangerine Bear Claw",
      min: 1,
      max: 200,
      type: "Martial arts",
      blurb:
        "Drops from common pools, blitzable and shop buyable. Martial Artist only.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "40", quality: "" },
        maxDamage: { value: "310", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "801", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          Profession: { value: "Martial Artist", quality: "r" },
          "Martial arts": { value: "896", quality: "" },
          Piercing: { value: "597", quality: "r" },
          Brawl: { value: "597", quality: "" },
          Dimach: { value: "200", quality: "" },
          "Martial arts (optional)": { value: "911", quality: "r" },
        },
        mods: {
          "Dodge ranged": { value: "16", quality: "" },
          "Evade close": { value: "16", quality: "" },
        },
      },
      profs: ["Martial Artist"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=160287",
    },
    "Huzzum's Iron Fist": {
      name: "Huzzum's Iron Fist",
      min: 100,
      max: 150,
      type: "Martial arts",
      blurb:
        "Drops from Huzzum in The_Reck. Level locked from 100. Shade and MA only. Left hand only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "1.6s", quality: "" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "5 m", quality: "" },
        minDamage: { value: "150", quality: "" },
        maxDamage: { value: "250", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "400", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          Level: { value: "100", quality: "r" },
          Profession: { value: "Shade or Martial Artist", quality: "r" },
          "Martial arts": { value: "500", quality: "" },
          Brawl: { value: "300", quality: "" },
          Dimach: { value: "150", quality: "" },
        },
        mods: {},
      },
      profs: ["Shade", "Martial Artist"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=303055",
    },
    "Inamorata Enel-Xum Swatter": {
      name: "Inamorata Enel-Xum Swatter",
      min: 80,
      max: 200,
      type: "Martial arts",
      blurb: "Drops from sided mobs in the Shadowlands.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "125", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          "Faction Unredeemed": { value: "35001", quality: "r" },
          "Martial arts": { value: "1441", quality: "" },
          "1h Blunt": { value: "961", quality: "r" },
          Brawl: { value: "961", quality: "" },
          Dimach: { value: "321", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Martial Artist", "Trader"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=212398",
    },
    "Kuma Tonfa": {
      versions: [
        {
          name: "Kuma Tonfa",
          min: 205,
          max: 220,
          type: "Martial arts",
          blurb:
            "One of the Xan_weapon_upgrades. Level locked from 190. Comes in left and right hand versions. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "r" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "325", quality: "g" },
            maxDamage: { value: "495", quality: "g" },
            critMod: { value: "500", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "1550", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              "Martial arts": { value: "2251", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Sensory improvement": { value: "15", quality: "" },
              "Biological metamorphosis": { value: "15", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Trader", "Martial Artist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=293995",
        },
        {
          name: "Kuma Tonfa",
          min: 205,
          max: 220,
          type: "Martial arts",
          blurb:
            "One of the Xan_weapon_upgrades. Comes in left and right hand versions. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "r" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "310", quality: "g" },
            maxDamage: { value: "490", quality: "g" },
            critMod: { value: "500", quality: "" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "1550", quality: "" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Martial arts": { value: "2251", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Brawl: { value: "1351", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Sensory improvement": { value: "15", quality: "" },
              "Biological metamorphosis": { value: "15", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Trader", "Martial Artist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=293995&patch=18041300",
        },
      ],
    },
    "Kyr'Ozch Nunchacko": {
      name: "Kyr'Ozch Nunchacko",
      min: 1,
      max: 200,
      type: "Martial arts",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. Hits have a 5*4% chance to proc an AAO buff. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "5 m", quality: "" },
        minDamage: { value: "290", quality: "g" },
        maxDamage: { value: "340", quality: "" },
        critMod: { value: "340", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "Martial arts": { value: "2001", quality: "" },
          Brawl: { value: "1201", quality: "" },
          Dimach: { value: "401", quality: "" },
        },
        mods: {},
      },
      profs: ["Trader", "Martial Artist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=288671",
    },

    "Lotus Parry Stick": {
      name: "Lotus Parry Stick",
      min: 1,
      max: 200,
      type: "Martial arts",
      blurb: "Blitzable and part of common loot pools. ",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "3.5s", quality: "r" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2300", quality: "g" },
        init: { value: "Physical", quality: "r" },
        multi: { value: "777", quality: "r" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "Martial arts": { value: "806", quality: "" },
          "1h Blunt": { value: "537", quality: "" },
          Brawl: { value: "537", quality: "" },
          Dimach: { value: "180", quality: "" },
        },
        mods: {
          Parry: { value: "100", quality: "" },
          "Evade close": { value: "100", quality: "" },
        },
      },
      auno: "https://auno.org/ao/db.php?id=152357",
      profs: ["Martial Artist", "Trader"],
      diff: 2,
    },
    "Nano-Charged Stun Glove - 870": {
      versions: [
        {
          name: "Nano-Charged Stun Glove - 870",
          min: 1,
          max: 200,
          type: "Martial arts",
          blurb:
            "Sold in stores and craftable_with_weapon_upgrade_kits. Uses an additional attack bar.",
          stats: {
            ql: { value: "1-300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.5s", quality: "g" },
            rSpeed: { value: "1.5s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "140", quality: "" },
            maxDamage: { value: "440", quality: "g" },
            critMod: { value: "240", quality: "" },
            attackCap: { value: "2400", quality: "g" },
            init: { value: "Physical", quality: "r" },
            multi: { value: "1200", quality: "r" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Martial arts": { value: "1501", quality: "r" },
              Brawl: { value: "901", quality: "" },
              "Fast attack": { value: "751", quality: "" },
              Dimach: { value: "301", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader", "Martial Artist"],
          prk: false,
          auno: "https://auno.org/ao/db.php?id=271047&ql=200",
          diff: 1,
        },
        {
          name: "Nano-Charged Stun Glove - 870",
          min: 1,
          max: 200,
          type: "Martial arts",
          blurb:
            "Last known to be buyable from Weapon Fragment stores in ICC and craftable_with_weapon_upgrade_kits. Uses an additional attack bar. Uses 1h Blunt skill instead of Martial Arts.",
          stats: {
            ql: { value: "1-300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.5s", quality: "g" },
            rSpeed: { value: "1.5s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "140", quality: "" },
            maxDamage: { value: "440", quality: "g" },
            critMod: { value: "240", quality: "" },
            attackCap: { value: "2400", quality: "g" },
            init: { value: "Physical", quality: "r" },
            multi: { value: "1200", quality: "r" },
            specials: { value: "Fast Attack, Brawl, Dimach", quality: "g" },
            reqs: {
              "Martial arts": { value: "1501", quality: "r" },
              Brawl: { value: "901", quality: "" },
              "Fast attack": { value: "751", quality: "" },
              Dimach: { value: "301", quality: "" },
            },
            profs: ["Enforcer", "Meta-Physicist", "Trader"],
            prk: true,
            auno: "https://auno.org/ao/db.php?id=271047&patch=17060000",
            diff: 0,
          },
        },
      ],
    },
    "Sacrosanct Enel-Xum Nunchaku": {
      name: "Sacrosanct Enel-Xum Nunchaku",
      min: 80,
      max: 200,
      type: "Martial arts",
      blurb: "Drops from sided mobs in the Shadowlands.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "125", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          "Faction Redeemed": { value: "35001", quality: "r" },
          "Martial arts": { value: "1441", quality: "" },
          "1h Blunt": { value: "961", quality: "r" },
          Brawl: { value: "961", quality: "" },
          Dimach: { value: "321", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Trader", "Martial Artist"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=212418",
    },
    "Special Edition Kyr'Ozch Nunchacko": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Nunchacko",
          min: 151,
          max: 200,
          type: "Martial arts",
          blurb:
            "Drops from Sector_07_aliens. Shade and MA Only. Level locked to 151. Hits have a 5*2% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "233", quality: "g" },
            maxDamage: { value: "266", quality: "" },
            critMod: { value: "299", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "151", quality: "r" },
              Profession: { value: "Shade or Martial Artist", quality: "r" },
              "Martial arts": { value: "700", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader", "Martial Artist"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288291",
        },
        {
          name: "Special Edition Kyr'Ozch Nunchacko",
          min: 151,
          max: 200,
          type: "Martial arts",
          blurb:
            "Drops from Sector_07_aliens. Shade and MA Only. Hits have a 5*2% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "233", quality: "g" },
            maxDamage: { value: "266", quality: "" },
            critMod: { value: "299", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Brawl, Dimach", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Shade or Martial Artist", quality: "r" },
              "Martial arts": { value: "700", quality: "" },
              Brawl: { value: "400", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader", "Martial Artist"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288291",
        },
      ],
    },
  },
  "Melee energy": {
    "B-19 Modified Breathing Space - Vacuum Creator": {
      name: "B-19 Modified Breathing Space - Vacuum Creator",
      min: 50,
      max: 100,
      type: "Melee energy",
      blurb:
        "Drops from Reverend Hyuan in TOTW. Hits have a 10% chance to proc a DOT. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "1.2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "55", quality: "" },
        maxDamage: { value: "162", quality: "" },
        critMod: { value: "30", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "196", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Dimach", quality: "" },
        reqs: {
          "Melee energy": { value: "305", quality: "" },
          "Fast Attack": { value: "137", quality: "" },
          "Sneak Attack": { value: "137", quality: "" },
          Dimach: { value: "101", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Enforcer", "Keeper"],
      diff: 69,
      prk: true,
    },
    "Dusk & Dawn of the Xan": {
      versions: [
        {
          name: "Dusk & Dawn of the Xan",
          min: 190,
          max: 220,
          type: "Melee energy",
          blurb:
            "Tradeskilled_from_Shadowlands_boss_loot. 2 seperate items with the same stats. Level locked from 190. Checks duck explosives.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1s", quality: "g" },
            rSpeed: { value: "1s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "300", quality: "g" },
            maxDamage: { value: "350", quality: "" },
            critMod: { value: "500", quality: "g" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1500", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              "Melee energy": { value: "1800", quality: "" },
              "Sneak attack": { value: "900", quality: "" },
              "Fast attack": { value: "900", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              Intelligence: { value: "32", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Keeper", "Enforcer"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280730",
        },
        {
          name: "Dusk & Dawn of the Xan",
          min: 190,
          max: 220,
          type: "Melee energy",
          blurb:
            "Tradeskilled_from_Shadowlands_boss_loot. 2 seperate items with the same stats. Level locked from 190. Checks duck explosives.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1s", quality: "g" },
            rSpeed: { value: "1s", quality: "g" },
            range: { value: "3 m", quality: "" },
            minDamage: { value: "300", quality: "g" },
            maxDamage: { value: "350", quality: "" },
            critMod: { value: "500", quality: "g" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1500", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              "Melee energy": { value: "1800", quality: "" },
              "Sneak attack": { value: "900", quality: "" },
              "Fast attack": { value: "900", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              Intelligence: { value: "32", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Keeper", "Enforcer"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280730",
        },
      ],
    },

    "Gift of Jupiter": {
      name: "Gift of Jupiter",
      min: 25,
      max: 60,
      type: "Melee energy",
      blurb: "Drops from Dynas. Meta-Physicist only.",
      stats: {
        ql: { value: "50", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "25", quality: "" },
        maxDamage: { value: "200", quality: "g" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "211", quality: "g" },
        specials: { value: "Fast Attack, Brawl", quality: "g" },
        reqs: {
          Profession: { value: "Meta-Physicist", quality: "r" },
          "Melee energy": { value: "213", quality: "g" },
          "Fast attack": { value: "107", quality: "" },
          Brawl: { value: "128", quality: "" },
        },
        mods: {
          "Radiation AC": { value: "80", quality: "" },
          "Nano init": { value: "20", quality: "" },
          "Defense modifier": { value: "20", quality: "" },
        },
      },
      profs: ["Meta-Physicist"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=208071",
    },
    "Kyr'Ozch Energy Hammer": {
      name: "Kyr'Ozch Energy Hammer",
      min: 1,
      max: 200,
      type: "Melee energy",
      blurb: "",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "325", quality: "g" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "325", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "Melee energy": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Keeper", "Enforcer", "Shade"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254702",
    },

    "Perfected Immortal Katana": {
      name: "Perfected Immortal Katana",
      min: 80,
      max: 190,
      type: "Melee energy",
      blurb: "Drops from Commander Jocasta in the Cyborg_Barracks. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "0.8s", quality: "" },
        rSpeed: { value: "0.8s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "95", quality: "" },
        maxDamage: { value: "475", quality: "" },
        critMod: { value: "65", quality: "" },
        attackCap: { value: "1250", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          "Melee energy": { value: "750", quality: "" },
          "Fast Attack": { value: "400", quality: "" },
          Brawling: { value: "350", quality: "" },
          Dimach: { value: "250", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Enforcer", "Keeper"],
      diff: 69,
      prk: true,
    },

    "Prototype Energy Katana": {
      name: "Prototype Energy Katana",
      min: 25,
      max: 50,
      type: "Melee energy",
      blurb: "Drops from Integrated Emissary in the Subway. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "40", quality: "" },
        maxDamage: { value: "95", quality: "" },
        critMod: { value: "15", quality: "" },
        attackCap: { value: "300", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fast Attack, Dimach", quality: "" },
        reqs: {
          "Melee energy": { value: "151", quality: "" },
          "Fast Attack": { value: "91", quality: "" },
          Dimach: { value: "71", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Enforcer", "Keeper"],
      diff: 69,
      prk: true,
    },

    Sockdolager: {
      name: "Sockdolager",
      min: 70,
      max: 150,
      type: "Melee energy",
      blurb: "Drops from Dynas. Nanomage only.",
      stats: {
        ql: { value: "", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "250", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "500", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          Breed: { value: "Nanomage", quality: "r" },
          "Melee energy": { value: "551", quality: "" },
          "Fast attack": { value: "276", quality: "" },
          Brawl: { value: "331", quality: "" },
        },
        mods: {
          "Energy AC": { value: "150", quality: "" },
          "Nano init": { value: "50", quality: "" },
          "Max nano": { value: "200", quality: "" },
        },
      },
      profs: ["Keeper", "Enforcer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=207968",
    },
    "Special Edition Kyr'Ozch Energy Rapier": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Energy Rapier",
          min: 151,
          max: 200,
          type: "Melee energy",
          blurb:
            "Drops from Sector_07_aliens. Shade, Keeper, and Enforcer Only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.3s", quality: "" },
            rSpeed: { value: "1.3s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "234", quality: "" },
            critMod: { value: "333", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "400", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "151", quality: "r" },
              Profession: { value: "Shade, Keeper, Enforcer", quality: "r" },
              "Melee energy": { value: "700", quality: "" },
              "Sneak attack": { value: "350", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Keeper", "Enforcer", "Shade"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288287",
        },
        {
          name: "Special Edition Kyr'Ozch Energy Rapier",
          min: 151,
          max: 200,
          type: "Melee energy",
          blurb:
            "Drops from Sector_07_aliens. Shade, Keeper, and Enforcer Only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.3s", quality: "" },
            rSpeed: { value: "1.3s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "234", quality: "" },
            critMod: { value: "333", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "400", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              Profession: { value: "Shade, Keeper, Enforcer", quality: "r" },
              "Melee energy": { value: "700", quality: "" },
              "Sneak attack": { value: "350", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Keeper", "Enforcer", "Shade"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288287",
        },
      ],
    },
    "The Argument": {
      versions: [
        {
          name: "The Argument",
          min: 125,
          max: 200,
          type: "Melee energy",
          blurb:
            "Drops during the Hollow_Island_raid. Profession locked to Keeper, Meta-Physicist, Enforcer.",
          stats: {
            ql: { value: "200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2.1s", quality: "" },
            rSpeed: { value: "2.1s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "225", quality: "" },
            maxDamage: { value: "700", quality: "g" },
            critMod: { value: "225", quality: "" },
            attackCap: { value: "1600", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Dimach", quality: "" },
            reqs: {
              Profession: {
                value: "Keeper, Meta-Physicist, Enforcer",
                quality: "r",
              },
              "Melee energy": { value: "1101", quality: "" },
              Dimach: { value: "221", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              Intelligence: { value: "20", quality: "" },
              "Duck explosives": { value: "40", quality: "" },
            },
          },
          profs: ["Keeper", "Meta-Physicist", "Enforcer"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=223469",
        },
        {
          name: "The Argument",
          min: 125,
          max: 200,
          type: "Melee energy",
          blurb:
            "Drops during the Hollow_Island_raid. Profession locked to Meta-Physicist and Enforcer.",
          stats: {
            ql: { value: "200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2.1s", quality: "" },
            rSpeed: { value: "2.1s", quality: "" },
            range: { value: "4 m", quality: "" },
            minDamage: { value: "225", quality: "" },
            maxDamage: { value: "700", quality: "g" },
            critMod: { value: "225", quality: "" },
            attackCap: { value: "1600", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Dimach", quality: "" },
            reqs: {
              Profession: {
                value: "Meta-Physicist, Enforcer",
                quality: "r",
              },
              "Melee energy": { value: "1101", quality: "" },
              Dimach: { value: "221", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              Intelligence: { value: "20", quality: "" },
              "Duck explosives": { value: "40", quality: "" },
            },
          },
          profs: ["Meta-Physicist", "Enforcer"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=223469",
        },
      ],
    },
  },
  Piercing: {
    "Aleksander's Punchknife": {
      name: "Aleksander's Punchknife",
      min: 1,
      max: 215,
      type: "Piercing",
      blurb: "Drops from alien_generals.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "210", quality: "" },
        maxDamage: { value: "425", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2300", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1199", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Piercing: { value: "1701", quality: "" },
          "Fast attack": { value: "851", quality: "" },
          "Martial arts (optional)": { value: "1600", quality: "r" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Dodge ranged": { value: "20", quality: "" },
          Concealment: { value: "20", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=253241",
    },
    Chicanery: {
      name: "Chicanery",
      min: 80,
      max: 200,
      type: "Piercing",
      blurb: "Drops from Dynas. Opifex only. Clan only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.6s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2300", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "600", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          Breed: { value: "Opifex", quality: "r" },
          Faction: { value: "Clan", quality: "r" },
          Piercing: { value: "761", quality: "" },
          "Fast attack": { value: "381", quality: "" },
          Brawl: { value: "457", quality: "" },
          Dimach: { value: "153", quality: "" },
        },
        mods: {
          "Melee init": { value: "16", quality: "" },
          "Body development": { value: "8", quality: "" },
          "Evade close": { value: "16", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=207976",
    },

    "Corrupted Lord of Deceit": {
      name: "Corrupted Lord of Deceit",
      min: 205,
      max: 220,
      type: "Piercing",
      blurb: "Drops during the Home_Pyramid_raid. Level locked from 205.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.6s", quality: "" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "450", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1200", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          Piercing: { value: "2000", quality: "" },
          "Sneak attack": { value: "900", quality: "" },
          "Fast attack": { value: "900", quality: "" },
          Dimach: { value: "451", quality: "" },
        },
        mods: {
          "Max health": { value: "300", quality: "" },
          "Offense modifier": { value: "15", quality: "" },
          "Defense modifier": { value: "15", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302935",
    },
    "Deceit of the Xan": {
      versions: [
        {
          name: "Deceit of the Xan",
          min: 190,
          max: 220,
          type: "Piercing",
          blurb:
            "Upgrade result from Lord of Deceit. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1s", quality: "" },
            rSpeed: { value: "1s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "300", quality: "" },
            maxDamage: { value: "350", quality: "" },
            critMod: { value: "500", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Piercing: { value: "2251", quality: "" },
              "Sneak attack": { value: "1126", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Shade", "Enforcer"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280719",
        },
        {
          name: "Deceit of the Xan",
          min: 190,
          max: 220,
          type: "Piercing",
          blurb:
            "Upgrade result from Lord of Deceit. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1s", quality: "" },
            rSpeed: { value: "1s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "300", quality: "" },
            maxDamage: { value: "350", quality: "" },
            critMod: { value: "500", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              Piercing: { value: "2251", quality: "" },
              "Sneak attack": { value: "1126", quality: "" },
              "Fast attack": { value: "1126", quality: "" },
              Dimach: { value: "451", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Shade", "Enforcer"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280719&patch=18000200",
        },
      ],
    },
    "Die Nadel": {
      name: "Die Nadel",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb:
        "Drops from Shadowlands common loot pools. Shade and Enforcer only.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.2s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "899", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack", quality: "" },
        reqs: {
          Profession: { value: "Enforcer or Shade", quality: "r" },
          Piercing: { value: "1801", quality: "" },
          "Sneak attack": { value: "901", quality: "" },
          "Fast attack": { value: "901", quality: "" },
          "Martial arts (optional)": { value: "2000", quality: "r" },
        },
        mods: {
          "Max health": { value: "50", quality: "" },
          "Evade close": { value: "5", quality: "" },
          "Offense modifier": { value: "2", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=226476",
    },
    "Elite Flower Guard Gofleprod": {
      name: "Elite Flower Guard Gofleprod",
      min: 175,
      max: 215,
      type: "Piercing",
      blurb: "Drops from the Juggernaut_raid. Enforcer only. Clan only.",
      stats: {
        ql: { value: "200-250", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.2s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "225", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Brawl", quality: "" },
        reqs: {
          Faction: { value: "Clan", quality: "r" },
          Profession: { value: "Enforcer", quality: "r" },
          Piercing: { value: "1534", quality: "" },
          Brawl: { value: "921", quality: "" },
        },
        mods: {
          "Projectile AC": { value: "300", quality: "" },
          "Melee AC": { value: "300", quality: "" },
          "Energy AC": { value: "300", quality: "" },
        },
      },
      profs: ["Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=207863",
    },
    "Improved Tango Dirk": {
      name: "Improved Tango Dirk",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb: "One_of_the_mass_relocating_robot_tradeskills.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.75s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2150", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "830", quality: "" },
        specials: { value: "Brawl", quality: "" },
        reqs: {
          Piercing: { value: "1039", quality: "" },
          Brawl: { value: "624", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "15", quality: "" },
          "Dodge ranged": { value: "20", quality: "" },
          "Evade close": { value: "20", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=206707",
    },

    "Inamorata Rapier": {
      name: "Inamorata Rapier",
      min: 80,
      max: 200,
      type: "Piercing",
      blurb: "Drops from sided mobs in the Shadowlands.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "475", quality: "" },
        critMod: { value: "50", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Faction Unredeemed": { value: "35001", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Piercing: { value: "1601", quality: "" },
          "Martial arts (optional)": { value: "1600", quality: "r" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212891",
    },

    "Fear-forged Blade": {
      name: "Fear-forged Blade",
      min: 40,
      max: 80,
      type: "Piercing",
      blurb:
        "Drops from Unrelenting Fear in Steps_of_Madness. Hits have a 5% chance to proc a DOT.",
      stats: {
        ql: { value: "50", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.08s", quality: "g" },
        rSpeed: { value: "1.3s", quality: "g" },
        range: { value: "1 m", quality: "r" },
        minDamage: { value: "45", quality: "" },
        maxDamage: { value: "125", quality: "g" },
        critMod: { value: "50", quality: "" },
        attackCap: { value: "720", quality: "g" },
        init: { value: "Melee", quality: "" },
        multi: { value: "122", quality: "g" },
        specials: { value: "Fast Attack, Sneak Attack", quality: "" },
        reqs: {
          Piercing: { value: "301", quality: "g" },
          "Sneak attack": { value: "151", quality: "" },
          "Fast attack": { value: "101", quality: "" },
        },
        mods: { Piercing: { value: "20", quality: "" } },
      },
      auno: "https://auno.org/ao/db.php?id=151903",
      profs: ["Shade"],
      diff: 4,
    },
    "Flea Bite": {
      name: "Flea Bite",
      min: 60,
      max: 150,
      type: "Piercing",
      blurb: "Drops from Dynas. Nanomage only.",
      stats: {
        ql: { value: "99-100", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.75s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "235", quality: "" },
        critMod: { value: "275", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "325", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          Breed: { value: "Nanomage", quality: "r" },
          Piercing: { value: "476", quality: "" },
          "Fast attack": { value: "239", quality: "" },
          Brawl: { value: "286", quality: "" },
        },
        mods: {
          "Energy AC": { value: "50", quality: "" },
          "Radiation AC": { value: "150", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=202789",
    },
    "Hacked Medi-Blade": {
      name: "Hacked Medi-Blade",
      min: 200,
      max: 220,
      type: "Piercing",
      blurb: "Drops from escaped_prisoners.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "315", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "500", quality: "" },
        attackCap: { value: "2750", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1649", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Dimach", quality: "" },
        reqs: {
          Piercing: { value: "2201", quality: "" },
          "Sneak attack": { value: "1101", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {
          "Max health": { value: "25", quality: "" },
          "Sneak attack": { value: "50", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=274974",
    },
    Kid: {
      name: "Kid",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb: "Drops from Dynas.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.75s", quality: "" },
        rSpeed: { value: "1.55s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "10", quality: "" },
        maxDamage: { value: "330", quality: "" },
        critMod: { value: "260", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "793", quality: "" },
        specials: { value: "Fast Attack, Brawl, Dimach", quality: "" },
        reqs: {
          Piercing: { value: "987", quality: "" },
          "Fast attack": { value: "494", quality: "" },
          Brawl: { value: "593", quality: "" },
          Dimach: { value: "198", quality: "" },
        },
        mods: {
          Agility: { value: "5", quality: "" },
          Adventuring: { value: "10", quality: "" },
          "Run speed": { value: "15", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=160449",
    },
    "Kyr'Ozch Energy Rapier": {
      name: "Kyr'Ozch Energy Rapier",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.  Uses ranged inits instead of physical.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "280", quality: "" },
        maxDamage: { value: "340", quality: "" },
        critMod: { value: "340", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Piercing: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254716",
    },

    "Kyr'Ozch Spear": {
      name: "Kyr'Ozch Spear",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.  Uses ranged inits instead of physical.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "4 m", quality: "" },
        minDamage: { value: "360", quality: "g" },
        maxDamage: { value: "460", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Piercing: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Shade"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254779",
    },
    "Mantis Predator Blade": {
      name: "Mantis Predator Blade",
      min: 80,
      max: 125,
      type: "Piercing",
      blurb: "Drops in the Mantis_Den. Flat damage.",
      stats: {
        ql: { value: "90-120", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "80", quality: "" },
        maxDamage: { value: "80", quality: "" },
        critMod: { value: "160", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "327", quality: "" },
        specials: { value: "Brawl, Dimach", quality: "" },
        reqs: {
          Piercing: { value: "481", quality: "" },
          Brawl: { value: "289", quality: "" },
          Dimach: { value: "97", quality: "" },
        },
        mods: {
          Psychic: { value: "4", quality: "" },
          "Poison AC": { value: "150", quality: "" },
          "Melee damage modifier": { value: "8", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=164431",
    },
    "Nippy John Stiletto": {
      versions: [
        {
          name: "Nippy John Stiletto",
          min: 80,
          max: 200,
          type: "Piercing",
          blurb:
            "Drops from Nippy Slither in Adonis. Shade only. Level locked from 50.",
          stats: {
            ql: { value: "140-160", quality: "r" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1s", quality: "" },
            rSpeed: { value: "1s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "175", quality: "" },
            maxDamage: { value: "375", quality: "" },
            critMod: { value: "300", quality: "" },
            attackCap: { value: "1000", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "800", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              Profession: { value: "Shade", quality: "r" },
              "Title level": { value: "3", quality: "r" },
              Piercing: { value: "801", quality: "" },
              "Sneak attack": { value: "401", quality: "" },
              "Fast attack": { value: "401", quality: "" },
              Dimach: { value: "161", quality: "" },
              Parry: { value: "321", quality: "" },
              Riposte: { value: "321", quality: "" },
            },
            mods: {
              "Max health": { value: "75", quality: "" },
              "Melee AC": { value: "300", quality: "" },
              "First aid": { value: "15", quality: "" },
            },
          },
          profs: ["Shade"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=245607",
        },
        {
          name: "Nippy John Stiletto",
          min: 80,
          max: 200,
          type: "Piercing",
          blurb:
            "Drops from Nippy Slither in Adonis. Shade only. Level locked from 100.",
          stats: {
            ql: { value: "140-160", quality: "r" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1s", quality: "" },
            rSpeed: { value: "1s", quality: "" },
            range: { value: "2 m", quality: "" },
            minDamage: { value: "175", quality: "" },
            maxDamage: { value: "375", quality: "" },
            critMod: { value: "300", quality: "" },
            attackCap: { value: "1000", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "800", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              Profession: { value: "Shade", quality: "r" },
              "Title level": { value: "4", quality: "r" },
              Piercing: { value: "801", quality: "" },
              "Sneak attack": { value: "401", quality: "" },
              "Fast attack": { value: "401", quality: "" },
              Dimach: { value: "161", quality: "" },
              Parry: { value: "321", quality: "" },
              Riposte: { value: "321", quality: "" },
            },
            mods: {
              "Max health": { value: "75", quality: "" },
              "Melee AC": { value: "300", quality: "" },
              "First aid": { value: "15", quality: "" },
            },
          },
          profs: ["Shade"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=245607&patch=15050000",
        },
      ],
    },

    "Ofab Viper": {
      name: "Ofab Viper",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "308", quality: "" },
        maxDamage: { value: "374", quality: "" },
        critMod: { value: "374", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1649", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Dimach", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Piercing: { value: "2201", quality: "" },
          "Sneak attack": { value: "1101", quality: "" },
          "Fast attack": { value: "1101", quality: "" },
          Dimach: { value: "441", quality: "" },
        },
        mods: {},
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=265019",
    },
    "Omni-Med Scalpel": {
      name: "Omni-Med Scalpel",
      min: 80,
      max: 170,
      type: "Piercing",
      blurb:
        "Drops from Research Technician in Foremans. Hits have a 100% chance to proc a heal effect on user. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1100", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "500", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Dimach", quality: "" },
        reqs: {
          Piercing: { value: "701", quality: "" },
          "Fast Attack": { value: "351", quality: "" },
          "Sneak Attack": { value: "351", quality: "" },
          Dimach: { value: "201", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Soldier", "Trader", "Fixer"],
      diff: 69,
      prk: true,
    },
    "Sancrosanct Stiletto": {
      name: "Sancrosanct Stiletto",
      min: 80,
      max: 200,
      type: "Piercing",
      blurb: "Drops from sided Shadowlands mobs.",
      stats: {
        ql: { value: "80-300", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "475", quality: "" },
        critMod: { value: "50", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Faction Redeemed": { value: "35001", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Piercing: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=212800",
    },
    "Slayerdroid Claw": {
      name: "Slayerdroid Claw",
      min: 150,
      max: 215,
      type: "Piercing",
      blurb: "Drops from Obediency_Enforcer.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3.1s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "3 m", quality: "" },
        minDamage: { value: "10", quality: "" },
        maxDamage: { value: "600", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "1440", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "817", quality: "" },
        specials: { value: "Fast Attack, Brawl", quality: "" },
        reqs: {
          Piercing: { value: "1112", quality: "" },
          "Fast attack": { value: "557", quality: "" },
          Brawl: { value: "668", quality: "" },
        },
        mods: {
          "Nano init": { value: "25", quality: "" },
          "Evade close": { value: "20", quality: "" },
          "Max nano": { value: "75", quality: "" },
        },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=165133",
    },
    "Special Edition Kyr'Ozch Rapier": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Rapier",
          min: 151,
          max: 200,
          type: "Piercing",
          blurb:
            "Drops from Sector_07_aliens. Shade Only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.3s", quality: "" },
            rSpeed: { value: "1.3s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "234", quality: "" },
            critMod: { value: "333", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "400", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "151", quality: "r" },
              Profession: { value: "Shade", quality: "r" },
              Piercing: { value: "700", quality: "" },
              "Sneak attack": { value: "350", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Shade", "Enforcer"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288288",
        },
        {
          name: "Special Edition Kyr'Ozch Rapier",
          min: 151,
          max: 200,
          type: "Piercing",
          blurb:
            "Drops from Sector_07_aliens. Shade Only. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.3s", quality: "" },
            rSpeed: { value: "1.3s", quality: "" },
            range: { value: "5 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "234", quality: "" },
            critMod: { value: "333", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Melee", quality: "" },
            multi: { value: "400", quality: "" },
            specials: {
              value: "Fast Attack, Sneak Attack, Dimach",
              quality: "",
            },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Shade", quality: "r" },
              Piercing: { value: "700", quality: "" },
              "Sneak attack": { value: "350", quality: "" },
              "Fast attack": { value: "350", quality: "" },
              Dimach: { value: "150", quality: "" },
            },
            mods: {},
          },
          profs: ["Shade", "Enforcer"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288288&patch=18041400",
        },
      ],
    },
    Toothpicker: {
      name: "Toothpicker",
      min: 71,
      max: 125,
      type: "Piercing",
      blurb: "Drops in Mantis_Den. Level locked from 71.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "19", quality: "" },
        maxDamage: { value: "144", quality: "" },
        critMod: { value: "292", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "220", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack", quality: "" },
        reqs: {
          Level: { value: "71", quality: "r" },
          Piercing: { value: "521", quality: "" },
          "Fast attack": { value: "282", quality: "" },
          "Sneak attack": { value: "221", quality: "" },
        },
        mods: {},
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=158913",
    },
    "Uklesh's Talon": {
      name: "Uklesh's Talon",
      min: 210,
      max: 220,
      type: "Piercing",
      blurb:
        "Drops during the 18.8_TOTW_raid. Level locked from 210. Hits have a 3% chance to proc a stun.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "2 m", quality: "" },
        minDamage: { value: "290", quality: "" },
        maxDamage: { value: "375", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "Fast Attack, Sneak Attack, Dimach", quality: "" },
        reqs: {
          Level: { value: "210", quality: "r" },
          Piercing: { value: "2150", quality: "" },
          "Sneak attack": { value: "1100", quality: "" },
          "Fast attack": { value: "1100", quality: "" },
          Dimach: { value: "450", quality: "" },
        },
        mods: {},
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305525",
    },

    "Variable Density Tanto": {
      name: "Variable Density Tanto",
      min: 1,
      max: 200,
      type: "Piercing",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens. Speeds slow somewhat as the QL rises.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "1 m", quality: "" },
        minDamage: { value: "65", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "260", quality: "" },
        attackCap: { value: "1800", quality: "" },
        init: { value: "Melee", quality: "" },
        multi: { value: "1049", quality: "" },
        specials: { value: "Fast Attack", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Piercing: { value: "1101", quality: "" },
          "Fast attack": { value: "551", quality: "" },
        },
        mods: { "Max health": { value: "100", quality: "" } },
      },
      profs: ["Shade", "Enforcer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=249079",
    },
  },
  "Assault rifle": {
    "Airframed Blaster Betatype": {
      name: "Airframed Blaster Betatype",
      min: 40,
      max: 100,
      type: "Assault rifle",
      blurb:
        "Drops from Entvined and Medusae in Deep Artery Valley. Attack speed gets slightly faster as the QL rises.",
      stats: {
        ql: { value: "60-80", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.4s", quality: "r" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "15", quality: "" },
        maxDamage: { value: "200", quality: "" },
        critMod: { value: "140", quality: "" },
        attackCap: { value: "875", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Assault rifle": { value: "451", quality: "" },
          Burst: { value: "339", quality: "" },
          "Full auto": { value: "406", quality: "" },
        },
        mods: {
          Burst: { value: "10", quality: "" },
          "Full auto": { value: "10", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=248897",
    },

    "Anger of the Xan": {
      versions: [
        {
          name: "Anger of the Xan",
          min: 190,
          max: 220,
          type: "Assault rifle",
          blurb:
            "Upgrade result from Lord of Anger. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "320", quality: "g" },
            maxDamage: { value: "560", quality: "g" },
            critMod: { value: "350", quality: "" },
            attackCap: { value: "2800", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Burst, Full Auto", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              "Assault rifle": { value: "2251", quality: "r" },
              Burst: { value: "1689", quality: "" },
              "Full auto": { value: "2026", quality: "" },
            },
            mods: {
              "Matter creation": { value: "30", quality: "" },
              "Time and space": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Soldier"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280722",
        },
        {
          name: "Anger of the Xan",
          min: 190,
          max: 220,
          type: "Assault rifle",
          blurb:
            "Upgrade result from Lord of Anger. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.4s", quality: "" },
            rSpeed: { value: "1.4s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "320", quality: "g" },
            maxDamage: { value: "560", quality: "g" },
            critMod: { value: "350", quality: "" },
            attackCap: { value: "2800", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Burst, Full Auto", quality: "" },
            reqs: {
              "Assault rifle": { value: "2251", quality: "r" },
              Burst: { value: "1689", quality: "" },
              "Full auto": { value: "2026", quality: "" },
            },
            mods: {
              "Matter creation": { value: "30", quality: "" },
              "Time and space": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Soldier"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280722&patch=18000200",
        },
      ],
    },
    "Bulwark Blaster": {
      name: "Bulwark Blaster",
      min: 1,
      max: 50,
      type: "Assault rifle",
      blurb:
        "Drops from common pools in the Shadowlands. Model listed is QL 50 interpolation. Speeds get much slower as the QL rises.",
      stats: {
        ql: { value: "1-300", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.33s", quality: "r" },
        rSpeed: { value: "2.91s", quality: "r" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "51", quality: "g" },
        maxDamage: { value: "64", quality: "r" },
        critMod: { value: "12", quality: "" },
        attackCap: { value: "358", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          "Assault rifle": { value: "272", quality: "" },
          Burst: { value: "206", quality: "" },
          "Full auto": { value: "245", quality: "" },
        },
        mods: {
          "Poison AC": { value: "50", quality: "" },
          "Duck explosives": { value: "5", quality: "" },
          "Dodge ranged": { value: "10", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=211215&ql=50",
    },
    "Corrupted Lord of Anger": {
      name: "Corrupted Lord of Anger",
      min: 205,
      max: 220,
      type: "Assault rifle",
      blurb: "Drops during the Home_Pyramid_raid. Level locked from 205. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.6s", quality: "" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "250", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          "Assault rifle": { value: "2000", quality: "" },
          Burst: { value: "1000", quality: "" },
          "Full auto": { value: "1800", quality: "" },
        },
        mods: {
          "Matter creation": { value: "30", quality: "" },
          "Time and space": { value: "30", quality: "" },
          "Offense modifier": { value: "15", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302938",
    },
    "Division 9 Plasmaprojector": {
      name: "Division 9 Plasmaprojector",
      min: 1,
      max: 200,
      type: "Assault rifle",
      blurb: "Drops from Dynas. Soldier only.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.6s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "28 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "460", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2100", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "847", quality: "" },
          "Ranged energy": { value: "565", quality: "r" },
          Burst: { value: "706", quality: "" },
        },
        mods: {
          "Max health": { value: "300", quality: "" },
          "Ranged init": { value: "24", quality: "" },
          "Evade close": { value: "35", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=163324",
    },

    "Dreadloch Modified Shark": {
      name: "Dreadloch Modified Shark",
      min: 210,
      max: 220,
      type: "Assault rifle",
      blurb:
        "Drops from Dreadloch_camps. Level locked from 210. Hits have a 5% chance to proc a run speed debuff.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "320", quality: "g" },
        maxDamage: { value: "560", quality: "g" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Level: { value: "210", quality: "r" },
          "Assault rifle": { value: "2001", quality: "" },
          Burst: { value: "1001", quality: "" },
          "Full auto": { value: "1801", quality: "" },
        },
        mods: { "Offense modifier": { value: "20", quality: "" } },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=267158",
    },
    "Eradicator XCI-52": {
      name: "Eradicator XCI-52",
      min: 1,
      max: 200,
      type: "Assault rifle",
      blurb: "Blitzable, drops from common loot pools, and shop buyable.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.15s", quality: "g" },
        rSpeed: { value: "1.15s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "30", quality: "" },
        maxDamage: { value: "350", quality: "g" },
        critMod: { value: "350", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Assault rifle": { value: "1027", quality: "" },
          "Fling shot": { value: "514", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=122272",
    },
    "Hellfury Assault Cannon": {
      name: "Hellfury Assault Cannon",
      min: 71,
      max: 100,
      type: "Assault rifle",
      blurb:
        "Drops from the Cyborg_Barracks. Level locked from 71. Hits have a 4% chance to proc a radiation armor and reflect debuff. Can be upgraded.",
      stats: {
        ql: { value: "80", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "16", quality: "" },
        maxDamage: { value: "162", quality: "" },
        critMod: { value: "76", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Level: { value: "71", quality: "r" },
          "Assault rifle": { value: "407", quality: "" },
          Burst: { value: "324", quality: "" },
        },
        mods: {
          "Radiation AC": { value: "100", quality: "" },
          "Fire AC": { value: "100", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=153977",
    },
    "Hellspinner Shock Cannon": {
      name: "Hellspinner Shock Cannon",
      min: 71,
      max: 100,
      type: "Assault rifle",
      blurb:
        "Drops from the Cyborg_Barracks. Level locked from 71. Hits have a 6% chance to proc a radiation armor and reflect debuff. Can be upgraded.",
      stats: {
        ql: { value: "84", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "51", quality: "" },
        maxDamage: { value: "205", quality: "" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          Level: { value: "71", quality: "r" },
          "Assault rifle": { value: "440", quality: "" },
          Burst: { value: "329", quality: "" },
          "Full auto": { value: "368", quality: "" },
        },
        mods: {
          "Radiation AC": { value: "120", quality: "" },
          "Fire AC": { value: "120", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=153976",
    },

    "Inner Circle Strategic Flamer": {
      name: "Inner Circle Strategic Flamer",
      min: 1,
      max: 200,
      type: "Assault rifle",
      blurb: "Drops from random mission side loot. Soldier only.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3.1s", quality: "r" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "450", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "1250", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "998", quality: "" },
          Burst: { value: "749", quality: "" },
          "Full auto": { value: "898", quality: "" },
        },
        mods: {
          Intelligence: { value: "6", quality: "" },
          "Fire AC": { value: "300", quality: "" },
          "Run speed": { value: "40", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=233803",
    },
    "Illegally Modified Dreadloch Modified Shark": {
      name: "Illegally Modified Dreadloch Modified Shark",
      min: 215,
      max: 220,
      type: "Assault rifle",
      blurb:
        "Drops from Abmouth during the 18.8_Subway_raid. Level locked from 215. Hits have a 7% and 3% chance to proc a run speed debuff and root, respectively.  Could be modified a little more.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "32 m", quality: "" },
        minDamage: { value: "310", quality: "" },
        maxDamage: { value: "565", quality: "" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2750", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst, Full Auto", quality: "g" },
        reqs: {
          Level: { value: "215", quality: "r" },
          "Assault rifle": { value: "2250", quality: "" },
          Burst: { value: "1700", quality: "" },
          "Full auto": { value: "2075", quality: "" },
          "Fling shot": { value: "1200", quality: "" },
        },
        mods: { "Offense modifier": { value: "20", quality: "" } },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=306004",
    },

    "Kyr'Ozch Carbine": {
      name: "Kyr'Ozch Carbine",
      min: 1,
      max: 200,
      type: "Assault rifle",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.  Uses ranged inits instead of physical.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "250", quality: "g" },
        maxDamage: { value: "450", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "Assault rifle": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254492",
    },
    "Master of Combustion": {
      name: "Master of Combustion",
      min: 150,
      max: 200,
      type: "Assault rifle",
      blurb: "Drops from Fiery_Soldier. Soldier only. Checks duck explosives.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "16 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "500", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "1850", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Full Auto", quality: "" },
        reqs: {
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "1151", quality: "" },
          "Full auto": { value: "1036", quality: "" },
        },
        mods: {
          Strength: { value: "10", quality: "" },
          "Chemical AC": { value: "50", quality: "" },
          "Fire AC": { value: "200", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=165200",
    },

    "Merren Flamethrower": {
      name: "Merren Flamethrower",
      min: 60,
      max: 200,
      type: "Assault rifle",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens. Speeds slow somewhat as the QL rises. Small magazine capacity.",
      stats: {
        ql: { value: "81-200", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "1.5s", quality: "r" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "150", quality: "" },
        maxDamage: { value: "430", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "1750", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Expansion", quality: "r" },
          "Assault rifle": { value: "1101", quality: "" },
          Burst: { value: "826", quality: "" },
        },
        mods: { "Shield fire damage": { value: "25", quality: "" } },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=248607",
    },
    "Mortiig Blaster": {
      name: "Mortiig Blaster",
      min: 80,
      max: 200,
      type: "Assault rifle",
      blurb:
        "Drops from Mortiig bosses in Elysium, Shadowlands. Soldier only. Notable locations include Spade Beach and Eastfang. ",
      stats: {
        ql: { value: "100-125", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "350", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "750", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "626", quality: "" },
          Burst: { value: "470", quality: "" },
          "Full auto": { value: "563", quality: "" },
        },
        mods: { "Body development": { value: "40", quality: "" } },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=246344",
    },
    "Mother Nitrogena": {
      name: "Mother Nitrogena",
      min: 100,
      max: 200,
      type: "Assault rifle",
      blurb: "Drops from Dust_Brigade_Generals.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.3s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "40", quality: "" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "520", quality: "g" },
        attackCap: { value: "1950", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Full Auto", quality: "" },
        reqs: {
          "Assault rifle": { value: "901", quality: "" },
          "Heavy weapons": { value: "601", quality: "r" },
          "Full auto": { value: "901", quality: "" },
        },
        mods: {
          "Projectile AC": { value: "60", quality: "" },
          "Melee AC": { value: "60", quality: "" },
          "Fire AC": { value: "300", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=156719",
    },
    "MTI F-88 Cineration": {
      name: "MTI F-88 Cineration",
      min: 100,
      max: 200,
      type: "Assault rifle",
      blurb: "Drops from Dynas. Soldier only. Checks duck explosives.",
      stats: {
        ql: { value: "165-175", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "20", quality: "" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "1600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "872", quality: "" },
          Burst: { value: "654", quality: "" },
          "Fling shot": { value: "437", quality: "" },
        },
        mods: {
          "Max health": { value: "150", quality: "" },
          "Vehicle ground": { value: "12", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208003",
    },

    "Neutrino Flash": {
      name: "Neutrino Flash",
      min: 40,
      max: 100,
      type: "Assault rifle",
      blurb:
        "Drops from Notum Habit in Steps_of_Madness. Hits have a 5% chance to proc a reflect shutdown.",
      stats: {
        ql: { value: "50", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "21 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "160", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "730", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Assault rifle": { value: "301", quality: "g" },
          Burst: { value: "151", quality: "" },
        },
        mods: {},
      },
      auno: "https://auno.org/ao/db.php?id=152027",
      profs: ["Soldier"],
      diff: 4,
    },
    "Nophex Plasma Destroyer II": {
      name: "Nophex Plasma Destroyer II",
      min: 125,
      max: 200,
      type: "Assault rifle",
      blurb: "Drops from Notum_Soldier. Soldier only.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "500", quality: "" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "1650", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "901", quality: "" },
          "Ranged energy": { value: "601", quality: "r" },
          Burst: { value: "751", quality: "" },
          "Fling shot": { value: "501", quality: "" },
        },
        mods: {
          "Energy AC": { value: "150", quality: "" },
          "Duck explosives": { value: "15", quality: "" },
          "Experience modifier": { value: "2", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=165140",
    },

    "Nova Flow - Mark I": {
      versions: [
        {
          name: "Nova Flow - Mark I",
          min: 1,
          max: 200,
          type: "Assault rifle",
          blurb: "Blitzable, drops from common loot pools, shop buyable.",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2.1s", quality: "" },
            rSpeed: { value: "2.1s", quality: "" },
            range: { value: "22 m", quality: "" },
            minDamage: { value: "1", quality: "r" },
            maxDamage: { value: "410", quality: "" },
            critMod: { value: "260", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              "Assault rifle": { value: "847", quality: "" },
              "Ranged energy": { value: "565", quality: "r" },
              Burst: { value: "706", quality: "" },
              "Fling shot": { value: "471", quality: "" },
            },
            mods: {},
          },
          profs: ["Soldier"],
          prk: false,
          diff: 1,
          auno: "https://auno.org/ao/db.php?id=158962",
        },
        {
          name: "Nova Flow - Mark I",
          min: 1,
          max: 200,
          type: "Assault rifle",
          blurb:
            "Blitzable, drops from common loot pools, shop buyable. Buyable from the Trader Shop. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2.1s", quality: "" },
            rSpeed: { value: "2.1s", quality: "" },
            range: { value: "22 m", quality: "" },
            minDamage: { value: "1", quality: "r" },
            maxDamage: { value: "410", quality: "" },
            critMod: { value: "260", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              "Assault rifle": { value: "847", quality: "" },
              "Ranged energy": { value: "565", quality: "r" },
              Burst: { value: "706", quality: "" },
              "Fling shot": { value: "471", quality: "" },
            },
            mods: {},
          },
          profs: ["Soldier"],
          prk: true,
          diff: 0,
          auno: "https://auno.org/ao/db.php?id=158962",
        },
      ],
    },
    "Nova Flow - Mk IV": {
      name: "Nova Flow - Mk IV",
      min: 1,
      max: 200,
      type: "Assault rifle",
      blurb: "Blitzable, drops from common loot pools, shop buyable.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "362", quality: "" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Assault rifle": { value: "785", quality: "" },
          "Ranged energy": { value: "524", quality: "r" },
          Burst: { value: "654", quality: "" },
          "Fling shot": { value: "437", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=123285",
    },

    "Ofab Shark": {
      name: "Ofab Shark",
      min: 1,
      max: 200,
      type: "Assault rifle",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "310", quality: "" },
        maxDamage: { value: "550", quality: "" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          "Assault rifle": { value: "2201", quality: "" },
          Burst: { value: "1651", quality: "" },
          "Full auto": { value: "1981", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=265103",
    },
    "Perennium Blaster": {
      name: "Perennium Blaster",
      min: 30,
      max: 200,
      type: "Assault rifle",
      blurb:
        "Crafted from a Nano-Charged_weapon_and_a_bunch_of_SL_parts. Soldier only. ",
      stats: {
        ql: { value: "50-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "175", quality: "" },
        maxDamage: { value: "425", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "1001", quality: "" },
          Burst: { value: "751", quality: "" },
          "Full auto": { value: "901", quality: "" },
        },
        mods: { "Experience modifier": { value: "4", quality: "" } },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=246428",
    },
    "Special Edition Kyr'Ozch Carbine": {
      name: "Special Edition Kyr'Ozch Carbine",
      min: 151,
      max: 200,
      type: "Assault rifle",
      blurb:
        "Drops from Sector_07_aliens. Engineer Only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "1.2s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "180", quality: "g" },
        maxDamage: { value: "230", quality: "" },
        critMod: { value: "170", quality: "" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          Level: { value: "151", quality: "r" },
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Profession: { value: "Soldier", quality: "r" },
          "Assault rifle": { value: "700", quality: "" },
          Burst: { value: "500", quality: "" },
          "Full auto": { value: "600", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=288283",
    },
  },
  Bow: {
    "Bang of Thunder": {
      name: "Bang of Thunder",
      min: 80,
      max: 200,
      type: "Bow",
      blurb: "Drops from Dynas. Martial Artist only.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "2.3s", quality: "r" },
        range: { value: "19 m", quality: "" },
        minDamage: { value: "5", quality: "r" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "" },
        reqs: {
          Profession: { value: "Martial Artist", quality: "r" },
          Bow: { value: "1001", quality: "" },
          "Fling shot": { value: "501", quality: "" },
          "Aimed shot": { value: "501", quality: "" },
        },
        mods: {
          "Max health": { value: "150", quality: "" },
          "Dodge ranged": { value: "40", quality: "" },
          Concealment: { value: "15", quality: "" },
        },
      },
      profs: ["Martial Artist"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208027",
    },
    "Bow of Belith": {
      name: "Bow of Belith",
      min: 1,
      max: 200,
      type: "Bow",
      blurb: "Drops from Hecklers in the Shadowlands. Breed locked to Opifex.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "2s", quality: "r" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "r" },
        reqs: {
          Breed: { value: "Opifex", quality: "r" },
          Bow: { value: "2001", quality: "" },
          "Aimed shot": { value: "1001", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "60", quality: "" },
          "Offense modifier": { value: "30", quality: "" },
        },
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=233346",
    },
    "Bow of Ferocious Appetite": {
      name: "Bow of Ferocious Appetite",
      min: 1,
      max: 200,
      type: "Bow",
      blurb: "Part of common loot pools.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.8s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "28 m", quality: "" },
        minDamage: { value: "85", quality: "" },
        maxDamage: { value: "450", quality: "g" },
        critMod: { value: "600", quality: "g" },
        attackCap: { value: "2400", quality: "g" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: { Bow: { value: "1001", quality: "" } },
        mods: {
          "Max health": { value: "160", quality: "" },
          Stamina: { value: "8", quality: "" },
          "Bow special attack": { value: "12", quality: "" },
        },
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=165059&ql=200",
    },
    "Bow of Forsaken Reveries": {
      name: "Bow of Forsaken Reveries",
      min: 40,
      max: 100,
      type: "Bow",
      blurb:
        "Drops from Jealousy in Steps_of_Madness. Hits have a 10% chance to proc an instant damage program. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "80", quality: "" },
        maxDamage: { value: "173", quality: "" },
        critMod: { value: "15", quality: "" },
        attackCap: { value: "800", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "" },
        reqs: {
          Bow: { value: "321", quality: "" },
          "Fling Shot": { value: "151", quality: "" },
          "Aimed Shot": { value: "151", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Martial Artist", "Meta-Physicist"],
      diff: 69,
      prk: true,
    },
    "Bow of the Double Nimbus": {
      name: "Bow of the Double Nimbus",
      min: 1,
      max: 200,
      type: "Bow",
      blurb:
        "Drops from common Shadowlands loot pools. The min-max damage window slims as the QL rises.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3.5s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "400", quality: "g" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Bow: { value: "1451", quality: "" },
        },
        mods: { Adventuring: { value: "30", quality: "" } },
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=211256",
    },
    "Chaos of the Xan": {
      versions: [
        {
          name: "Chaos of the Xan",
          min: 190,
          max: 220,
          type: "Bow",
          blurb:
            "Upgrade result from Lord_of_Chaos. Upgrade drops during 3_different_raids. Uses ranged inits instead of physical.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.3s", quality: "g" },
            rSpeed: { value: "1.3s", quality: "g" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "375", quality: "g" },
            maxDamage: { value: "600", quality: "g" },
            critMod: { value: "650", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "r" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan?", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Bow: { value: "1800", quality: "" },
              "Fling shot": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Psychological modifications": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Martial Artist", "Meta-Physicist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280726",
        },
        {
          name: "Chaos of the Xan",
          min: 190,
          max: 220,
          type: "Bow",
          blurb:
            "Upgrade result from Lord_of_Greed. Upgrade drops during 3_different_raids. Uses ranged inits instead of physical.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.3s", quality: "g" },
            rSpeed: { value: "1.3s", quality: "g" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "375", quality: "g" },
            maxDamage: { value: "600", quality: "g" },
            critMod: { value: "650", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "r" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Bow: { value: "1800", quality: "" },
              "Fling shot": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Psychological modifications": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Martial Artist", "Meta-Physicist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280726&patch=18000200",
        },
      ],
    },
    "Corrupted Lord of Chaos": {
      name: "Corrupted Lord of Chaos",
      min: 205,
      max: 220,
      type: "Bow",
      blurb: "Drops during the Home_Pyramid_raid. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "700", quality: "g" },
        critMod: { value: "500", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "r" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of The Xan?", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          Bow: { value: "1800", quality: "" },
          "Fling shot": { value: "900", quality: "" },
        },
        mods: {
          "Max health": { value: "400", quality: "" },
          "Psychological modifications": { value: "30", quality: "" },
          "Offense modifier": { value: "30", quality: "" },
        },
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302942",
    },
    "Dreadloch Tigress": {
      versions: [
        {
          name: "Dreadloch Tigress",
          min: 200,
          max: 220,
          type: "Bow",
          blurb:
            "Drops from Dreadloch_camps. Meta-Physicist only. Uses ranged inits instead of physical. Hits have a 10% chance to proc a Nano init+Nano damage debuff. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "325", quality: "g" },
            maxDamage: { value: "600", quality: "g" },
            critMod: { value: "650", quality: "" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Ranged", quality: "r" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Lost Eden", quality: "r" },
              Profession: { value: "Meta-Physicist", quality: "r" },
              Bow: { value: "1801", quality: "" },
              "Fling shot": { value: "901", quality: "" },
              "Aimed shot": { value: "901", quality: "" },
            },
            mods: {
              "Max health": { value: "500", quality: "" },
              "Max nano": { value: "500", quality: "" },
            },
          },
          profs: ["Meta-Physicist"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=267257",
        },
        {
          name: "Dreadloch Tigress",
          min: 200,
          max: 220,
          type: "Bow",
          blurb:
            "Drops from Dreadloch_camps. Meta-Physicist only. Uses ranged inits instead of physical. Hits have a 10% chance to proc a Nano init+Nano damage debuff. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.6s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "325", quality: "g" },
            maxDamage: { value: "600", quality: "g" },
            critMod: { value: "650", quality: "" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Ranged", quality: "r" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Lost Eden", quality: "r" },
              Profession: { value: "Meta-Physicist", quality: "r" },
              Bow: { value: "1801", quality: "" },
              "Fling shot": { value: "901", quality: "" },
              "Aimed shot": { value: "901", quality: "" },
            },
            mods: {
              "Max health": { value: "500", quality: "" },
              "Max nano": { value: "500", quality: "" },
            },
          },
          profs: ["Meta-Physicist"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=267257&patch=17020000",
        },
      ],
    },
    "Illegally-Modified Dreadloch Tigress": {
      name: "Illegally-Modified Dreadloch Tigress",
      min: 215,
      max: 220,
      type: "Bow",
      blurb:
        "Drops from The Psion in the 18.8_Subway_raid. Meta-Physicist only. Level locked from 215. Uses ranged inits instead of physical.  Hits have a 15% chance to proc a Nano init+Nano damage debuff.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "350", quality: "g" },
        maxDamage: { value: "625", quality: "g" },
        critMod: { value: "650", quality: "" },
        attackCap: { value: "2750", quality: "" },
        init: { value: "Ranged", quality: "r" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
        reqs: {
          Profession: { value: "Meta-Physicist", quality: "r" },
          Level: { value: "215", quality: "r" },
          Bow: { value: "2000", quality: "" },
          "Fling shot": { value: "1000", quality: "" },
          "Aimed shot": { value: "1000", quality: "" },
        },
        mods: {
          "Max health": { value: "500", quality: "" },
          "Max nano": { value: "500", quality: "" },
        },
      },
      profs: ["Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305988",
    },
    "Kyr'Ozch Crossbow": {
      name: "Kyr'Ozch Crossbow",
      min: 1,
      max: 200,
      type: "Bow",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.  Uses ranged inits instead of physical.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "250", quality: "g" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "r" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Bow: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254597",
    },
    "Lord of Chaos": {
      name: "Lord of Chaos",
      min: 190,
      max: 220,
      type: "Bow",
      blurb: "Drops during The_Beast_raid. Upgrades to Chaos_of_the_Xan.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "150", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Title level": { value: "6", quality: "r" },
          Bow: { value: "2251", quality: "" },
        },
        mods: {
          "Max health": { value: "400", quality: "" },
          "Time and space": { value: "30", quality: "" },
          "Max nano": { value: "400", quality: "" },
        },
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=244910",
    },
    "Ofab Tiger": {
      name: "Ofab Tiger",
      min: 1,
      max: 200,
      type: "Bow",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.6s", quality: "" },
        rSpeed: { value: "1.6s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "275", quality: "" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "550", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Bow: { value: "2101", quality: "" },
          "Fling shot": { value: "1051", quality: "" },
          "Aimed shot": { value: "1051", quality: "" },
        },
        mods: {},
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=265145",
    },
    "Schuyler Bow": {
      versions: [
        {
          name: "Schuyler Bow",
          min: 1,
          max: 200,
          type: "Bow",
          blurb: "Blitzable.",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2.5s", quality: "r" },
            rSpeed: { value: "2.5s", quality: "r" },
            range: { value: "18 m", quality: "" },
            minDamage: { value: "1", quality: "r" },
            maxDamage: { value: "580", quality: "g" },
            critMod: { value: "200", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "r" },
            reqs: { Bow: { value: "986", quality: "" } },
            mods: {
              "Max health": { value: "150", quality: "" },
              Perception: { value: "20", quality: "" },
              "Evade close": { value: "30", quality: "" },
            },
          },
          profs: ["Martial Artist", "Meta-Physicist"],
          prk: false,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159023",
        },
        {
          name: "Schuyler Bow",
          min: 1,
          max: 200,
          type: "Bow",
          blurb: "Blitzable and buyable in the Trader shop.",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2.5s", quality: "r" },
            rSpeed: { value: "2.5s", quality: "r" },
            range: { value: "18 m", quality: "" },
            minDamage: { value: "1", quality: "r" },
            maxDamage: { value: "580", quality: "g" },
            critMod: { value: "200", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Physical", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "r" },
            reqs: { Bow: { value: "986", quality: "" } },
            mods: {
              "Max health": { value: "150", quality: "" },
              Perception: { value: "20", quality: "" },
              "Evade close": { value: "30", quality: "" },
            },
          },
          profs: ["Martial Artist", "Meta-Physicist"],
          prk: true,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159023",
        },
      ],
    },
    "Schuyler Pup": {
      name: "Schuyler Pup",
      min: 15,
      max: 40,
      type: "Bow",
      blurb: "Drops from Dynas. Martial Artist only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "90", quality: "g" },
        maxDamage: { value: "90", quality: "" },
        critMod: { value: "90", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Martial Artist", quality: "r" },
          Bow: { value: "281", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "20", quality: "" },
          "Dodge ranged": { value: "20", quality: "" },
          "Evade close": { value: "20", quality: "" },
        },
      },
      profs: ["Martial Artist"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208036",
    },
    "Sharky's Kevlar Bow": {
      name: "Sharky's Kevlar Bow",
      min: 1,
      max: 200,
      type: "Bow",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens. Speeds slow significantly as the QL rises.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "2s", quality: "r" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "110", quality: "" },
        maxDamage: { value: "410", quality: "" },
        critMod: { value: "320", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Physical", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Bow: { value: "1101", quality: "" },
          "Aimed shot": { value: "551", quality: "" },
        },
        mods: {},
      },
      profs: ["Martial Artist", "Meta-Physicist"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=248539",
    },
  },
  Grenade: {
    "Corrupted Lord of Sloth": {
      name: "Corrupted Lord of Sloth",
      min: 205,
      max: 220,
      type: "Grenade",
      blurb: "Drops during the Home_Pyramid_raid. Level locked from 215.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "g" },
        rSpeed: { value: "1.5s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "250", quality: "" },
        maxDamage: { value: "625", quality: "g" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          Grenade: { value: "2000", quality: "" },
          "Fling shot": { value: "1126", quality: "" },
        },
        mods: {
          "Max health": { value: "600", quality: "" },
          "Matter creation": { value: "30", quality: "" },
          "Time and space": { value: "30", quality: "" },
          "Offense modifier": { value: "30", quality: "" },
        },
      },
      profs: ["Engineer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302943",
    },
    "Dreadloch Obliterator": {
      name: "Dreadloch Obliterator",
      min: 210,
      max: 220,
      type: "Grenade",
      blurb:
        "Drops from Dreadloch_camps. Level locked from 210. Hits have a 10% chance to proc an init debuff. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "325", quality: "g" },
        maxDamage: { value: "525", quality: "g" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Level: { value: "210", quality: "r" },
          Grenade: { value: "2001", quality: "" },
          "Fling shot": { value: "1001", quality: "" },
        },
        mods: {},
      },
      profs: ["Engineer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=267127",
    },
    "Illegally Modified Dreadloch Obliterator": {
      name: "Illegally Modified Dreadloch Obliterator",
      min: 215,
      max: 220,
      type: "Grenade",
      blurb:
        "Drops from Abmouth during the 18.8_Subway_raid. Level locked from 215. Hits have a 15% chance to proc a init debuff.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.3s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "360", quality: "g" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "550", quality: "g" },
        attackCap: { value: "2700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "g" },
        reqs: {
          Level: { value: "215", quality: "r" },
          Grenade: { value: "2200", quality: "" },
          "Fling shot": { value: "1200", quality: "" },
          Burst: { value: "1200", quality: "" },
        },
        mods: {},
      },
      profs: ["Engineer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=306005",
    },

    "Kyr'Ozch Grenade Gun": {
      name: "Kyr'Ozch Grenade Gun",
      min: 1,
      max: 200,
      type: "Grenade",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. ",
      stats: {
        ql: { value: "", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.2s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "240", quality: "g" },
        maxDamage: { value: "540", quality: "" },
        critMod: { value: "240", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Grenade: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Engineer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254569",
    },
    "Nizno's Bomb Blaster": {
      name: "Nizno's Bomb Blaster",
      min: 25,
      max: 220,
      type: "Grenade",
      blurb:
        "Drops from parts on alien_generals.2 Engineer only. Get somewhat faster as the QL rises. Limited magazine capacity.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.2s", quality: "r" },
        rSpeed: { value: "2.2s", quality: "r" },
        range: { value: "10 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "450", quality: "" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2300", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Profession: { value: "Engineer", quality: "r" },
          Grenade: { value: "2201", quality: "" },
          "Fling shot": { value: "1101", quality: "" },
        },
        mods: {},
      },
      profs: ["Engineer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=253233",
    },
    "OT Hurler": {
      name: "OT Hurler",
      min: 80,
      max: 150,
      type: "Grenade",
      blurb: "Drops from Dynas. Engineer only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.25s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2400", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Engineer", quality: "r" },
          Grenade: { value: "775", quality: "" },
        },
        mods: {
          Tutoring: { value: "20", quality: "" },
          Chemistry: { value: "20", quality: "" },
          "Breaking and entry": { value: "20", quality: "" },
        },
      },
      profs: ["Engineer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=207999",
    },
    // discovered no clip = 1 bullet
    // "OT M-110 Renegade SAW": {
    //   name: "OT M-110 Renegade SAW",
    //   min: 1,
    //   max: 200,
    //   type: "Grenade",
    //   blurb:
    //     "Blitzable, shop buyable, and in common loot pools. Speeds get faster as the QL rises.",
    //   stats: {
    //     ql: { value: "1-200", quality: "" },
    //     dual: { value: "No", quality: "" },
    //     aSpeed: { value: "2.4s", quality: "r" },
    //     rSpeed: { value: "1.5s", quality: "r" },
    //     range: { value: "18 m", quality: "" },
    //     minDamage: { value: "16", quality: "" },
    //     maxDamage: { value: "426", quality: "" },
    //     critMod: { value: "167", quality: "" },
    //     attackCap: { value: "2500", quality: "" },
    //     init: { value: "Ranged", quality: "" },
    //     multi: { value: "", quality: "" },
    //     specials: { value: "", quality: "" },
    //     reqs: {
    //       Grenade: { value: "969", quality: "" },
    //       "Assault rifle": { value: "647", quality: "r" },
    //     },
    //     mods: {},
    //   },
    //   profs: ["Engineer"],
    //   prk: false,
    //   diff: 1,
    //   auno: "https://auno.org/ao/db.php?id=124816",
    // },
    "Prohibited Hand-Mortar of Bacam-Xum": {
      versions: [
        {
          name: "Prohibited Hand-Mortar of Bacam-Xum",
          min: 205,
          max: 220,
          type: "Grenade",
          blurb:
            "Tradeskilled from various shadowlands_boss_drops. Level locked from 215. ",
          stats: {
            ql: { value: "250", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "350", quality: "g" },
            maxDamage: { value: "467", quality: "" },
            critMod: { value: "563", quality: "g" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              "Title level": { value: "7", quality: "r" },
              Grenade: { value: "1750", quality: "" },
              "Fling shot": { value: "875", quality: "" },
            },
            mods: {
              Intelligence: { value: "50", quality: "" },
              "Mechanical engineering": { value: "120", quality: "" },
              "Matter creation": { value: "75", quality: "" },
            },
          },
          profs: ["Engineer"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=246873",
        },
        {
          name: "Prohibited Hand-Mortar of Bacam-Xum",
          min: 205,
          max: 220,
          type: "Grenade",
          blurb:
            "Tradeskilled from various shadowlands_boss_drops. Level locked from 215. ",
          stats: {
            ql: { value: "250", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "g" },
            rSpeed: { value: "1.5s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "350", quality: "g" },
            maxDamage: { value: "467", quality: "" },
            critMod: { value: "563", quality: "g" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              "Title level": { value: "7", quality: "r" },
              Grenade: { value: "1750", quality: "" },
              "Fling shot": { value: "875", quality: "" },
            },
            mods: {
              Intelligence: { value: "50", quality: "" },
              "Mechanical engineering": { value: "120", quality: "" },
              "Matter creation": { value: "75", quality: "" },
            },
          },
          profs: ["Engineer"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=246873&patch=18041300",
        },
      ],
    },

    "Red Line Grenade Launcher": {
      name: "Red Line Grenade Launcher",
      min: 25,
      max: 60,
      type: "Grenade",
      blurb: "Drops from Dynas. Engineer only. Right hand only.",
      stats: {
        ql: { value: "40-50", quality: "" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "3s", quality: "r" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "5", quality: "" },
        maxDamage: { value: "400", quality: "g" },
        critMod: { value: "20", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "217", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          Profession: { value: "Engineer", quality: "r" },
          Grenade: { value: "218", quality: "g" },
        },
        mods: {
          "Chemical AC": { value: "60", quality: "" },
          "Fire AC": { value: "60", quality: "" },
          "Mechanical engineering": { value: "30", quality: "" },
        },
      },
      profs: ["Engineer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=208039",
    },
    "Sloth of the Xan": {
      versions: [
        {
          name: "Sloth of the Xan",
          min: 190,
          max: 220,
          type: "Grenade",
          blurb:
            "Upgrade result from Lord of Sloth. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "420", quality: "g" },
            maxDamage: { value: "560", quality: "g" },
            critMod: { value: "675", quality: "g" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Grenade: { value: "2251", quality: "" },
              "Fling shot": { value: "1126", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Matter creation": { value: "30", quality: "" },
              "Time and space": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Engineer"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280727",
        },
        {
          name: "Sloth of the Xan",
          min: 190,
          max: 220,
          type: "Grenade",
          blurb:
            "Upgrade result from Lord of Sloth. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "g" },
            rSpeed: { value: "1.5s", quality: "g" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "420", quality: "g" },
            maxDamage: { value: "560", quality: "g" },
            critMod: { value: "675", quality: "g" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Grenade: { value: "2251", quality: "" },
              "Fling shot": { value: "1126", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Matter creation": { value: "30", quality: "" },
              "Time and space": { value: "30", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Engineer"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280727&patch=18010000",
        },
      ],
    },
    "Special Edition Kyr'Ozch Grenade Gun": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Grenade Gun",
          min: 151,
          max: 200,
          type: "Grenade",
          blurb:
            "Drops from Sector_07_aliens. Engineer Only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "262", quality: "g" },
            maxDamage: { value: "380", quality: "" },
            critMod: { value: "450", quality: "g" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Engineer", quality: "r" },
              Level: { value: "151", quality: "r" },
              Grenade: { value: "700", quality: "g" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: ["Engineer"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288296",
        },
        {
          name: "Special Edition Kyr'Ozch Grenade Gun",
          min: 151,
          max: 200,
          type: "Grenade",
          blurb:
            "Drops from Sector_07_aliens. Engineer Only. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "262", quality: "g" },
            maxDamage: { value: "380", quality: "" },
            critMod: { value: "450", quality: "g" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Engineer", quality: "r" },
              Grenade: { value: "700", quality: "g" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: ["Engineer"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288296&patch=18041400",
        },
      ],
    },
  },
  Pistol: {
    "Arm of the Disciple": {
      name: "Arm of the Disciple",
      min: 40,
      max: 100,
      type: "Pistol",
      blurb: "Drops from pistol-wielding cultists in TOTW. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "49", quality: "" },
        maxDamage: { value: "131", quality: "" },
        critMod: { value: "92", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "203", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Pistol: { value: "301", quality: "" },
          "Fling shot": { value: "151", quality: "" },
          Burst: { value: "201", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      diff: 69,
      prk: true,
    },
    "BBI Faithful 1000": {
      name: "BBI Faithful 1000",
      min: 205,
      max: 220,
      type: "Pistol",
      blurb:
        "Drops from Eumenides and Abmouth in the 18.8_Subway_raid. Adventurer only. Equipping this weapon will virtually disable aimed shot.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "225", quality: "g" },
        maxDamage: { value: "275", quality: "r" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1750", quality: "" },
        specials: { value: "Full Auto", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "2250", quality: "" },
          "Full auto": { value: "1200", quality: "" },
        },
        mods: {
          "Aimed shot": { value: "-2000", quality: "" },
          "Duck explosives": { value: "30", quality: "" },
          "Dodge ranged": { value: "30", quality: "" },
          "Evade close": { value: "30", quality: "" },
        },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305980",
    },

    "BBI Faithful 750": {
      versions: [
        {
          name: "BBI Faithful 750",
          min: 1,
          max: 200,
          type: "Pistol",
          blurb: "Blitzable, shop buyable, and in common loot pools. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "2s", quality: "" },
            range: { value: "16 m", quality: "" },
            minDamage: { value: "30", quality: "" },
            maxDamage: { value: "410", quality: "" },
            critMod: { value: "200", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "818", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Profession: { value: "Adventurer", quality: "r" },
              Pistol: { value: "1026", quality: "" },
              "Fling shot": { value: "513", quality: "" },
            },
            mods: {
              "Duck explosives": { value: "15", quality: "" },
              "Dodge ranged": { value: "15", quality: "" },
            },
          },
          profs: ["Adventurer"],
          prk: false,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159039",
        },
        {
          name: "BBI Faithful 750",
          min: 1,
          max: 200,
          type: "Pistol",
          blurb:
            "Blitzable, buyable in the trader shop, and in common loot pools. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "2s", quality: "" },
            range: { value: "16 m", quality: "" },
            minDamage: { value: "30", quality: "" },
            maxDamage: { value: "410", quality: "" },
            critMod: { value: "200", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "818", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Profession: { value: "Adventurer", quality: "r" },
              Pistol: { value: "1026", quality: "" },
              "Fling shot": { value: "513", quality: "" },
            },
            mods: {
              "Duck explosives": { value: "15", quality: "" },
              "Dodge ranged": { value: "15", quality: "" },
            },
          },
          profs: ["Adventurer"],
          prk: true,
          diff: 1,
          auno: "https://auno.org/ao/db.php?id=159039",
        },
      ],
    },
    "Bronto Anaesthetic Pistol": {
      name: "Bronto Anaesthetic Pistol",
      min: 70,
      max: 200,
      type: "Pistol",
      blurb: "Drops from Dynas. Hits poison AC.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "16 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "500", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "1900", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1002", quality: "" },
        specials: { value: "", quality: "" },
        reqs: { Pistol: { value: "1003", quality: "" } },
        mods: {
          "Ranged init": { value: "20", quality: "" },
          "Nano init": { value: "10", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208103",
    },
    "Corrupted Lord of Lust": {
      name: "Corrupted Lord of Lust",
      min: 205,
      max: 220,
      type: "Pistol",
      blurb: "Drops during the Home_Pyramid_raid. Level locked from 205. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "150", quality: "" },
        maxDamage: { value: "390", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2600", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1200", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          Pistol: { value: "1800", quality: "" },
          Burst: { value: "900", quality: "" },
          "Fling shot": { value: "900", quality: "" },
        },
        mods: {
          "Max health": { value: "150", quality: "" },
          "Ranged init": { value: "50", quality: "" },
          "Nano init": { value: "50", quality: "" },
          "Offense modifier": { value: "15", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302944",
    },
    "Customized IMI Desert Reet 1000": {
      name: "Customized IMI Desert Reet 1000",
      min: 41,
      max: 190,
      type: "Pistol",
      blurb:
        "Drops from the Lab Director in Foremans and Notum_Soldier. Level locked from 41. Hits have a 5% chance to proc an instant damage program. ",
      stats: {
        ql: { value: "SPECIAL", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.29s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "65", quality: "" },
        maxDamage: { value: "143", quality: "g" },
        critMod: { value: "162", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "296", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Level: { value: "41", quality: "r" },
          Pistol: { value: "357", quality: "g" },
          Burst: { value: "269", quality: "" },
          "Fling shot": { value: "181", quality: "" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=156771",
    },

    "Dark Pistol": {
      name: "Dark Pistol",
      min: 60,
      max: 150,
      type: "Pistol",
      blurb:
        "Drops from Dark Cenobites & Summoners in COH. The mobs can be accessed in the entrance before you need a team to go deeper. Left hand and Bureaucrat only.",
      stats: {
        ql: { value: "75-94 + 100", quality: "r" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "190", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1000", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "500", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Bureaucrat", quality: "r" },
          Pistol: { value: "521", quality: "" },
          "Fling shot": { value: "261", quality: "" },
        },
        mods: {
          Intelligence: { value: "25", quality: "" },
          "Max nano": { value: "150", quality: "" },
          "Experience modifier": { value: "3", quality: "" },
        },
      },
      profs: ["Bureaucrat"],
      prk: false,
      auno: "https://auno.org/ao/db.php?id=245223",
      diff: 3,
    },
    "Diamondine Kick Pistol": {
      name: "Diamondine Kick Pistol",
      min: 125,
      max: 210,
      type: "Pistol",
      blurb: "Drops from Diamondine_Soldier. Atrox only.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "480", quality: "" },
        critMod: { value: "540", quality: "g" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "800", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Breed: { value: "Atrox", quality: "r" },
          Pistol: { value: "901", quality: "" },
          Shotgun: { value: "601", quality: "" },
          Burst: { value: "751", quality: "" },
          "Fling shot": { value: "501", quality: "" },
        },
        mods: {
          "Ranged init": { value: "20", quality: "" },
          "Multi ranged": { value: "20", quality: "" },
          "Duck explosives": { value: "20", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
        "Trader",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=165168",
    },
    "DNA-Targeted Executioner Pistol": {
      name: "DNA-Targeted Executioner Pistol",
      min: 60,
      max: 200,
      type: "Pistol",
      blurb: "Blitzable, shop buyable, and drops from common loot pools. ",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "27", quality: "r" },
        maxDamage: { value: "130", quality: "r" },
        critMod: { value: "600", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "809", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Pistol: { value: "842", quality: "" },
          "Ranged energy": { value: "561", quality: "r" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=123113",
    },

    "Doctor's Left Hand of Grace": {
      name: "Doctor's Left Hand of Grace",
      min: 150,
      max: 220,
      type: "Pistol",
      blurb:
        "Drops from Dreadloch_camps. Doctor only. Carries a 5% heal modifier.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "260", quality: "g" },
        maxDamage: { value: "365", quality: "" },
        critMod: { value: "248", quality: "" },
        attackCap: { value: "2600", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Profession: { value: "Doctor", quality: "r" },
          Pistol: { value: "1701", quality: "" },
          "Fling shot": { value: "851", quality: "" },
        },
        mods: {
          "Max nano": { value: "250", quality: "" },
          "Heal modifier": { value: "5", quality: "" },
        },
      },
      profs: ["Doctor"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=267618",
    },
    "Doctor's Right Hand of Hope": {
      name: "Doctor's Right Hand of Hope",
      min: 150,
      max: 220,
      type: "Pistol",
      blurb:
        "Drops from Dreadloch_camps. Doctor only. Carries a 3% nano discount.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "260", quality: "g" },
        maxDamage: { value: "365", quality: "" },
        critMod: { value: "248", quality: "" },
        attackCap: { value: "2600", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Profession: { value: "Doctor", quality: "r" },
          Pistol: { value: "1701", quality: "" },
          Burst: { value: "1201", quality: "" },
        },
        mods: {
          "Nano cost modifier": { value: "-3", quality: "" },
          "Nano delta": { value: "35", quality: "" },
        },
      },
      profs: ["Doctor"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=267619",
    },
    "Dreadloch Balanced Freedom Arms": {
      name: "Dreadloch Balanced Freedom Arms",
      min: 150,
      max: 220,
      type: "Pistol",
      blurb: "Drops from Dreadloch_camps. Bureaucrat only. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "260", quality: "g" },
        maxDamage: { value: "365", quality: "" },
        critMod: { value: "248", quality: "" },
        attackCap: { value: "2600", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1550", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Profession: { value: "Bureaucrat", quality: "r" },
          Pistol: { value: "1701", quality: "" },
          "Fling shot": { value: "851", quality: "" },
        },
        mods: {
          Strength: { value: "15", quality: "" },
          Stamina: { value: "15", quality: "" },
        },
      },
      profs: ["Bureaucrat"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=267255",
    },
    "Dust Brigade Engineer Pistol": {
      versions: [
        {
          name: "Dust Brigade Engineer Pistol",
          min: 190,
          max: 220,
          type: "Pistol",
          blurb:
            "Drops from Inside_the_Machine. Engineer only. Uses 100% pistol + 10% mechanical engineering as attack skills.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "200", quality: "g" },
            maxDamage: { value: "325", quality: "" },
            critMod: { value: "400", quality: "g" },
            attackCap: { value: "2600", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1500", quality: "" },
            specials: { value: "Burst", quality: "" },
            reqs: {
              "Expansion sets": { value: "Lost Eden", quality: "r" },
              Profession: { value: "Engineer", quality: "r" },
              Pistol: { value: "1701", quality: "" },
              Burst: { value: "851", quality: "" },
            },
            mods: {
              "Mechanical engineering": { value: "20", quality: "" },
              "Electrical engineering": { value: "20", quality: "" },
              "Quantum physics": { value: "20", quality: "" },
              "NCU memory": { value: "20", quality: "" },
            },
          },
          profs: ["Engineer"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=274559&patch=18085300",
        },
        {
          name: "Dust Brigade Engineer Pistol",
          min: 190,
          max: 220,
          type: "Pistol",
          blurb:
            "Drops from Inside_the_Machine. Engineer only. Uses 50% pistol + 50% mechanical engineering as attack skills.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "200", quality: "g" },
            maxDamage: { value: "325", quality: "" },
            critMod: { value: "400", quality: "g" },
            attackCap: { value: "2600", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1500", quality: "" },
            specials: { value: "Burst", quality: "" },
            reqs: {
              "Expansion sets": { value: "Lost Eden", quality: "r" },
              Profession: { value: "Engineer", quality: "r" },
              Pistol: { value: "1701", quality: "" },
              Burst: { value: "851", quality: "" },
            },
            mods: {
              "Mechanical engineering": { value: "20", quality: "" },
              "Electrical engineering": { value: "20", quality: "" },
              "Quantum physics": { value: "20", quality: "" },
              "NCU memory": { value: "20", quality: "" },
            },
          },
          profs: ["Engineer"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=274559&patch=17080000",
        },
      ],
    },
    "Envoy to Chaos": {
      name: "Envoy to Chaos",
      min: 201,
      max: 220,
      type: "Pistol",
      blurb:
        "Drops during the 18.8_TOTW_raid. Level locked from 201. Hits have a 4% chance to proc an instant damage program.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "235", quality: "g" },
        maxDamage: { value: "340", quality: "g" },
        critMod: { value: "350", quality: "g" },
        attackCap: { value: "2650", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Level: { value: "201", quality: "r" },
          Pistol: { value: "2000", quality: "" },
          Burst: { value: "1500", quality: "" },
          "Fling shot": { value: "1126", quality: "" },
        },
        mods: {
          "Nano pool": { value: "30", quality: "" },
          "Multi ranged": { value: "30", quality: "" },
          "Body development": { value: "30", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305522",
    },
    "EVA Survivor": {
      name: "EVA Survivor",
      min: 100,
      max: 190,
      type: "Pistol",
      blurb: "Drops from Dynas. Adventurer only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.15s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "20", quality: "" },
        maxDamage: { value: "300", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "750", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "751", quality: "" },
          "Fling shot": { value: "376", quality: "" },
        },
        mods: {},
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208009",
    },

    "Eyemutant Orb Laser": {
      name: "Eyemutant Orb Laser",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb: "Tradeskilled from eye_mutant_loot. Engineer only. ",
      stats: {
        ql: { value: "1-225", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "300", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "600", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Engineer", quality: "r" },
          Pistol: { value: "1201", quality: "" },
          "Fling shot": { value: "601", quality: "" },
        },
        mods: {
          "Radiation AC": { value: "175", quality: "" },
          "Duck explosives": { value: "40", quality: "" },
          "Dodge ranged": { value: "40", quality: "" },
        },
      },
      profs: ["Engineer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=204972",
    },

    "Flux Pistol": {
      name: "Flux Pistol",
      min: 1,
      max: 220,
      type: "Pistol",
      blurb:
        "Drops from sided mobs in the Shadowlands. The high min damage becomes flat around QL 270. Speeds get slower as the QL rises.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "4s", quality: "r" },
        rSpeed: { value: "4s", quality: "r" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "300", quality: "" },
        critMod: { value: "400", quality: "g" },
        attackCap: { value: "1900", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1400", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Pistol: { value: "1401", quality: "" },
          "Fling shot": { value: "701", quality: "" },
        },
        mods: {
          "Fire AC": { value: "250", quality: "" },
          "Run speed": { value: "25", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=211259",
    },
    "IMI Desert Reet 1000": {
      name: "IMI Desert Reet 1000",
      min: 60,
      max: 200,
      type: "Pistol",
      blurb:
        "Blitzable, shop buyable, and drops from common loot pools. Attack speed gets 0.01s faster between QL 1-200. ",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "12", quality: "r" },
        maxDamage: { value: "158", quality: "r" },
        critMod: { value: "520", quality: "g" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "823", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Pistol: { value: "889", quality: "" },
          Burst: { value: "667", quality: "" },
          "Fling shot": { value: "445", quality: "" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=123513",
    },

    "Inamorata Pistol": {
      name: "Inamorata Pistol",
      min: 80,
      max: 200,
      type: "Pistol",
      blurb:
        "Drops from Redeemed mobs in the Shadowlands. Can be upgraded to a turn_spirit_weapon. Effectively an omni Sacrosanct_Pistol. Gets slower as the QL rises. ",
      stats: {
        ql: { value: "100-200", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "3.6s", quality: "r" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "575", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "1750", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          "Faction Unredeemed": { value: "35001", quality: "" },
          Pistol: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212217",
    },
    "Jobe Explorer Personal Pistol": {
      name: "Jobe Explorer Personal Pistol",
      min: 80,
      max: 190,
      type: "Pistol",
      blurb: "Drops from dryads in Adonis, Shadowlands. Adventurer only.",
      stats: {
        ql: { value: "140-160", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "200", quality: "g" },
        maxDamage: { value: "300", quality: "g" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "1000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "800", quality: "" },
        specials: { value: "Full Auto", quality: "r" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "801", quality: "" },
          "Full auto": { value: "721", quality: "r" },
        },
        mods: {
          "Max health": { value: "125", quality: "" },
          "Max nano": { value: "125", quality: "" },
        },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=245577",
    },
    "Jobe Portal Guard Personal Pistol": {
      name: "Jobe Portal Guard Personal Pistol",
      min: 80,
      max: 190,
      type: "Pistol",
      blurb: "Drops from dryads in Adonis, Shadowlands. Soldier only.",
      stats: {
        ql: { value: "140-160", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "200", quality: "g" },
        maxDamage: { value: "300", quality: "g" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "1000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "800", quality: "" },
        specials: { value: "Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Soldier", quality: "r" },
          Pistol: { value: "801", quality: "" },
          "Full auto": { value: "721", quality: "" },
        },
        mods: { "Max health": { value: "250", quality: "" } },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=245574",
    },

    "Joint Clans Scout Pistol": {
      name: "Joint Clans Scout Pistol",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb:
        "Drops from Dynas. Adventurer only. Speeds get slower as the QL rises.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "1.5s", quality: "r" },
        range: { value: "26 m", quality: "" },
        minDamage: { value: "45", quality: "" },
        maxDamage: { value: "420", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "804", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "1051", quality: "" },
          "Fling shot": { value: "526", quality: "" },
        },
        mods: { "Multi ranged": { value: "12", quality: "" } },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=201261",
    },

    "Kyr'Ozch Pistol": {
      name: "Kyr'Ozch Pistol",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "225", quality: "g" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "225", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1800", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Pistol: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Engineer", "Adventurer", "Nano-technician"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254618",
    },
    Minielectronium: {
      name: "Minielectronium",
      min: 60,
      max: 200,
      type: "Pistol",
      blurb: "Blitzable, shop buyable, and drops from common loot pools. ",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "25", quality: "r" },
        maxDamage: { value: "110", quality: "r" },
        critMod: { value: "600", quality: "g" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "796", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Pistol: { value: "844", quality: "" },
          "Ranged energy": { value: "563", quality: "r" },
          "Fling shot": { value: "469", quality: "" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=122904",
    },

    "MTI Grey": {
      versions: [
        {
          name: "MTI Grey",
          min: 1,
          max: 200,
          type: "Pistol",
          blurb: "Drops from Dynas. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "2s", quality: "" },
            range: { value: "20 m", quality: "" },
            minDamage: { value: "20", quality: "" },
            maxDamage: { value: "400", quality: "" },
            critMod: { value: "220", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "785", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Pistol: { value: "941", quality: "" },
              "Fling shot": { value: "471", quality: "" },
            },
            mods: {},
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: false,
          diff: 3,
          auno: "https://auno.org/ao/db.php?id=162779",
        },
        {
          name: "MTI Grey",
          min: 1,
          max: 200,
          type: "Pistol",
          blurb: "Drops from Dynas. Adventurer only.",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "2s", quality: "" },
            range: { value: "20 m", quality: "" },
            minDamage: { value: "20", quality: "" },
            maxDamage: { value: "400", quality: "" },
            critMod: { value: "220", quality: "" },
            attackCap: { value: "2000", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "785", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Profession: { value: "Adventurer", quality: "r" },
              Pistol: { value: "941", quality: "" },
              "Fling shot": { value: "471", quality: "" },
            },
            mods: {
              "Projectile AC": { value: "130", quality: "" },
              "Biological metamorphosis": { value: "4", quality: "" },
              Swimming: { value: "40", quality: "" },
            },
          },
          profs: ["Adventurer"],
          prk: true,
          diff: 3,
          auno: "https://auno.org/ao/db.php?id=162779&patch=15000100",
        },
      ],
    },
    "MTI P87 - Free and Easy Days": {
      name: "MTI P87 - Free and Easy Days",
      min: 15,
      max: 50,
      type: "Pistol",
      blurb: "Drops from Dynas. Adventurer only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "145", quality: "g" },
        critMod: { value: "70", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "198", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "199", quality: "" },
          "Fling shot": { value: "100", quality: "" },
        },
        mods: {
          "First aid": { value: "10", quality: "" },
          Perception: { value: "10", quality: "" },
          Adventuring: { value: "20", quality: "" },
        },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208048",
    },

    "Lord of Lust": {
      name: "Lord of Lust",
      min: 190,
      max: 220,
      type: "Pistol",
      blurb: "Drops during The_Beast_raid. Upgrades to Lust_of_the_Xan.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "350", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1750", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Title level": { value: "6", quality: "r" },
          Pistol: { value: "2251", quality: "" },
          "Fling shot": { value: "1126", quality: "" },
        },
        mods: {
          "Sensory improvement": { value: "50", quality: "" },
          "Matter metamorphosis": { value: "50", quality: "" },
          "Biological metamorphosis": { value: "50", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=244914",
    },
    "Lust of the Xan": {
      versions: [
        {
          name: "Lust of the Xan",
          min: 190,
          max: 220,
          type: "Pistol",
          blurb:
            "Upgrade result from Lord_of_Lust. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "225", quality: "g" },
            maxDamage: { value: "350", quality: "g" },
            critMod: { value: "225", quality: "" },
            attackCap: { value: "2750", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1200", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Pistol: { value: "1800", quality: "" },
              Burst: { value: "900", quality: "" },
              "Fling shot": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Ranged init": { value: "50", quality: "" },
              "Nano init": { value: "50", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280728",
        },
        {
          name: "Lust of the Xan",
          min: 190,
          max: 220,
          type: "Pistol",
          blurb:
            "Upgrade result from Lord_of_Lust. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "225", quality: "g" },
            maxDamage: { value: "350", quality: "g" },
            critMod: { value: "225", quality: "" },
            attackCap: { value: "2750", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1200", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              Pistol: { value: "1800", quality: "" },
              Burst: { value: "900", quality: "" },
              "Fling shot": { value: "900", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Ranged init": { value: "50", quality: "" },
              "Nano init": { value: "50", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280728&patch=18000200",
        },
      ],
    },
    "Ofab Peregrine": {
      name: "Ofab Peregrine",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "248", quality: "g" },
        maxDamage: { value: "358", quality: "g" },
        critMod: { value: "248", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1649", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Pistol: { value: "2201", quality: "" },
          Burst: { value: "1651", quality: "" },
          "Fling shot": { value: "1101", quality: "" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=265061",
    },

    "Pain of Patricia": {
      name: "Pain of Patricia",
      min: 175,
      max: 215,
      type: "Pistol",
      blurb: "Drops during the Mercenaries_Raid. Level locked from 175. ",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "40", quality: "" },
        maxDamage: { value: "520", quality: "g" },
        critMod: { value: "380", quality: "" },
        attackCap: { value: "1050", quality: "r" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1150", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Level: { value: "175", quality: "r" },
          Pistol: { value: "1051", quality: "" },
          Burst: { value: "789", quality: "" },
          "Fling shot": { value: "526", quality: "" },
        },
        mods: {
          Sense: { value: "6", quality: "" },
          "Sensory improvement": { value: "4", quality: "" },
          Perception: { value: "12", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=168675",
    },
    "Parasitic Hecataleech": {
      name: "Parasitic Hecataleech",
      min: 150,
      max: 215,
      type: "Pistol",
      blurb: "Drops in IS. Unlocked late game pistol with a health drain proc.",
      stats: {
        ql: { value: "SPECIAL", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "86", quality: "" },
        maxDamage: { value: "323", quality: "g" },
        critMod: { value: "17", quality: "" },
        attackCap: { value: "1100", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "0", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Pistol: { value: "948", quality: "" },
          Burst: { value: "713", quality: "" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206047",
    },

    "Peh'Wer Pistol": {
      name: "Peh'Wer Pistol",
      min: 190,
      max: 220,
      type: "Pistol",
      blurb: "One of the Xan_weapon_upgrades. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "261", quality: "g" },
        maxDamage: { value: "348", quality: "g" },
        critMod: { value: "247", quality: "" },
        attackCap: { value: "2750", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1750", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          "Title level": { value: "6", quality: "r" },
          Pistol: { value: "2251", quality: "" },
          Burst: { value: "1651", quality: "" },
          "Fling shot": { value: "1126", quality: "" },
        },
        mods: {
          "Max health": { value: "300", quality: "" },
          "Ranged init": { value: "50", quality: "" },
          "Nano init": { value: "50", quality: "" },
          "Offense modifier": { value: "15", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=281505",
    },
    "PNG M1007A1 Tactical Revolver": {
      name: "PNG M1007A1 Tactical Revolver",
      min: 60,
      max: 200,
      type: "Pistol",
      blurb: "Blitzable, shop buyable, and in common loot pools. ",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1.74s", quality: "" },
        range: { value: "17 m", quality: "" },
        minDamage: { value: "43", quality: "r" },
        maxDamage: { value: "90", quality: "r" },
        critMod: { value: "703", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "785", quality: "" },
        specials: { value: "", quality: "" },
        reqs: { Pistol: { value: "903", quality: "" } },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=123627",
    },
    "Prelude to Chaos": {
      name: "Prelude to Chaos",
      min: 150,
      max: 215,
      type: "Pistol",
      blurb: "Drops in IS. Adventurer only.",
      stats: {
        ql: { value: "SPECIAL", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.6s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "84", quality: "" },
        maxDamage: { value: "401", quality: "g" },
        critMod: { value: "9", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "0", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "1003", quality: "" },
          "Fling shot": { value: "667", quality: "" },
        },
        mods: {
          "Sensory improvement": { value: "4", quality: "" },
          "Biological metamorphosis": { value: "4", quality: "" },
          "Matter creation": { value: "4", quality: "" },
        },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206053",
    },

    "Reflex Pistol": {
      name: "Reflex Pistol",
      min: 190,
      max: 215,
      type: "Pistol",
      blurb: "Drops from escaped_prisoners. Adventurer only. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "400", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2750", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "2001", quality: "" },
          Burst: { value: "1601", quality: "" },
          "Fling shot": { value: "1001", quality: "" },
        },
        mods: { "Experience modifier": { value: "1", quality: "" } },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=274977",
    },
    "Reign of Patricia": {
      name: "Reign of Patricia",
      min: 175,
      max: 200,
      type: "Pistol",
      blurb:
        "Drops during the Mercenaries_Raid. Adventurer only. Level locked from 175. ",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3s", quality: "" },
        rSpeed: { value: "2.2s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "40", quality: "" },
        maxDamage: { value: "520", quality: "g" },
        critMod: { value: "380", quality: "" },
        attackCap: { value: "1125", quality: "r" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1100", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Level: { value: "175", quality: "r" },
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "1051", quality: "" },
          Burst: { value: "789", quality: "" },
          "Fling shot": { value: "526", quality: "" },
        },
        mods: {
          "Max health": { value: "250", quality: "" },
          "Nano resist": { value: "20", quality: "" },
          "Fire damage modifier": { value: "20", quality: "" },
        },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=212995",
    },
    "Right Hand of Entropy": {
      name: "Right Hand of Entropy",
      min: 150,
      max: 215,
      type: "Pistol",
      blurb: "Drops in IS. Adventurer only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "125", quality: "" },
        maxDamage: { value: "428", quality: "g" },
        critMod: { value: "11", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "0", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "1049", quality: "" },
          "Fling shot": { value: "723", quality: "" },
        },
        mods: {
          "Matter metamorphosis": { value: "4", quality: "" },
          "Psychological modifications": { value: "4", quality: "" },
          "Time and space": { value: "4", quality: "" },
        },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=206054",
    },

    "River Seasons XP": {
      name: "River Seasons XP",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb: "Tradeskilled from sealed_weapon_receptacles. Adventurer only. ",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "320", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "805", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Adventurer", quality: "r" },
          Pistol: { value: "1036", quality: "" },
          "Fling shot": { value: "519", quality: "" },
        },
        mods: { "Nano init": { value: "20", quality: "" } },
      },
      profs: ["Adventurer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=162933",
    },

    "Sacrosanct Pistol": {
      name: "Sacrosanct Pistol",
      min: 80,
      max: 200,
      type: "Pistol",
      blurb:
        "Drops from Unredeemed mobs in the Shadowlands. Can be upgraded to a turn_spirit_weapon. Effectively a clan Inamorata_Pistol. ",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "3.6s", quality: "r" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "575", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "1750", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          "Faction Redeemed": { value: "35001", quality: "" },
          Pistol: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212232",
    },
    "Saturated Metaplast Six-Shooter": {
      name: "Saturated Metaplast Six-Shooter",
      min: 80,
      max: 190,
      type: "Pistol",
      blurb: "Drops from Dynas. Nano-Technician only. Flat damage.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "3s", quality: "r" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "150", quality: "g" },
        maxDamage: { value: "150", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "824", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Nano-Technician", quality: "r" },
          Pistol: { value: "825", quality: "" },
        },
        mods: {
          "Nano init": { value: "20", quality: "" },
          "Max nano": { value: "125", quality: "" },
          "Radiation damage modifier": { value: "3", quality: "" },
        },
      },
      profs: ["Nano-Technician"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208024",
    },

    "Sleek Minor Fantastic": {
      name: "Sleek Minor Fantastic",
      min: 80,
      max: 190,
      type: "Pistol",
      blurb: "Drops from Dynas. Bureaucrat only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "300", quality: "" },
        critMod: { value: "50", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "750", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          Profession: { value: "Bureaucrat", quality: "r" },
          Pistol: { value: "851", quality: "" },
        },
        mods: {
          "Energy AC": { value: "150", quality: "" },
          "Dodge ranged": { value: "15", quality: "" },
          Psychology: { value: "10", quality: "" },
        },
      },
      profs: ["Bureaucrat"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208015",
    },

    "Solar Powered Tinker Pistol": {
      name: "Solar Powered Tinker Pistol",
      min: 1,
      max: 220,
      type: "Pistol",
      blurb:
        'Pistol built_from_the_starting_solar_powered_pistol. Right hand only. Model listed is QL 1 interpolation. One of the few "leveling weapons" in the game. Has to be upgraded with items roughly every 40 levels.',
      stats: {
        ql: { value: "Interpolated", quality: "r" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "3", quality: "" },
        maxDamage: { value: "16", quality: "g" },
        critMod: { value: "20", quality: "g" },
        attackCap: { value: "", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          Pistol: { value: "9", quality: "" },
          "Weapon smithing": { value: "6", quality: "r" },
        },
        mods: {
          "Max Health": { value: "1", quality: "" },
          "Max Nano": { value: "1", quality: "" },
          Tutoring: { value: "1", quality: "" },
        },
      },
      auno: "https://auno.org/ao/db.php?id=164489",
      profs: ["Engineer", "Adventurer", "Nano-technician"],
      diff: 69,
    },
    "SOL K-91 Monster": {
      name: "SOL K-91 Monster",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb: "Drops from Dynas. Speeds get slower as the QL rises.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3.1s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "500", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "815", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Pistol: { value: "1101", quality: "" },
          "Fling shot": { value: "551", quality: "" },
        },
        mods: { Perception: { value: "12", quality: "" } },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=201275",
    },
    "SOL K-94 Monster": {
      name: "SOL K-94 Monster",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb: "Drops from Dynas. Speeds get slower as the QL rises.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3.1s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "500", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "793", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Pistol: { value: "901", quality: "" },
          Smg: { value: "601", quality: "r" },
          Burst: { value: "751", quality: "" },
          "Fling shot": { value: "501", quality: "" },
        },
        mods: { Perception: { value: "12", quality: "" } },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=201268",
    },
    "Special Edition Kyr'Ozch Pistol": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Pistol",
          min: 151,
          max: 200,
          type: "Pistol",
          blurb:
            "Drops from Sector_07_aliens. Profession locked to a bunch of professions. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "r" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "170", quality: "g" },
            maxDamage: { value: "275", quality: "g" },
            critMod: { value: "225", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: {
                value:
                  "Adventurer/Bureaucrat/Doctor/Engineer/Meta-Physicist/Nano-Technician",
                quality: "r",
              },
              Level: { value: "151", quality: "r" },
              Pistol: { value: "700", quality: "" },
              Burst: { value: "500", quality: "" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288293",
        },
        {
          name: "Special Edition Kyr'Ozch Pistol",
          min: 151,
          max: 200,
          type: "Pistol",
          blurb:
            "Drops from Sector_07_aliens. Profession locked to a bunch of professions. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "SPECIAL", quality: "r" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "170", quality: "g" },
            maxDamage: { value: "275", quality: "g" },
            critMod: { value: "225", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: {
                value:
                  "Adventurer/Bureaucrat/Doctor/Engineer/Meta-Physicist/Nano-Technician",
                quality: "r",
              },
              Pistol: { value: "700", quality: "" },
              Burst: { value: "500", quality: "" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288293&patch=18041400",
        },
      ],
    },
    "The Dog of War": {
      name: "The Dog of War",
      min: 80,
      max: 190,
      type: "Pistol",
      blurb: "Drops from Wardog in The_Reck.",
      stats: {
        ql: { value: "SPECIAL", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.3s", quality: "g" },
        rSpeed: { value: "1.3s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "125", quality: "" },
        maxDamage: { value: "320", quality: "g" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "600", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          Pistol: { value: "750", quality: "g" },
          Burst: { value: "450", quality: "" },
          "Fling shot": { value: "450", quality: "" },
        },
        mods: {},
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=303060",
    },

    "The Original Electronicum v3": {
      name: "The Original Electronicum v3",
      min: 1,
      max: 200,
      type: "Pistol",
      blurb:
        "Blitzable, shop buyable, and in common loot pools. Commonly found in low Qls in the backyard shops.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.41s", quality: "" },
        rSpeed: { value: "2.29s", quality: "" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "391", quality: "" },
        critMod: { value: "345", quality: "" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "949", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: { Pistol: { value: "895", quality: "" } },
        mods: {
          "Nano init": { value: "11", quality: "" },
          "Nano programming": { value: "8", quality: "" },
          "NCU memory": { value: "5", quality: "" },
        },
      },
      profs: [
        "Adventurer",
        "Bureaucrat",
        "Doctor",
        "Engineer",
        "Meta-Physicist",
        "Nano-technician",
      ],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=160292",
    },
    "Troa'Ler Pistol": {
      versions: [
        {
          name: "Troa'Ler Pistol",
          min: 190,
          max: 220,
          type: "Pistol",
          blurb: "One of the Xan_weapon_upgrades. Disables full auto.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.2s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "20 m", quality: "" },
            minDamage: { value: "225", quality: "g" },
            maxDamage: { value: "225", quality: "" },
            critMod: { value: "100", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: { value: "Aimed Shot", quality: "r" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Pistol: { value: "2250", quality: "" },
              "Aimed shot": { value: "1650", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Ranged init": { value: "50", quality: "" },
              "Nano init": { value: "50", quality: "" },
              "Full auto": { value: "2000", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=281506",
        },
        {
          name: "Troa'Ler Pistol",
          min: 190,
          max: 220,
          type: "Pistol",
          blurb: "One of the Xan_weapon_upgrades. Disables full auto.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.2s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "20 m", quality: "" },
            minDamage: { value: "225", quality: "g" },
            maxDamage: { value: "225", quality: "" },
            critMod: { value: "100", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: { value: "Aimed Shot", quality: "r" },
            reqs: {
              Pistol: { value: "2250", quality: "" },
              "Aimed shot": { value: "1650", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Ranged init": { value: "50", quality: "" },
              "Nano init": { value: "50", quality: "" },
              "Full auto": { value: "2000", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
            },
          },
          profs: [
            "Adventurer",
            "Bureaucrat",
            "Doctor",
            "Engineer",
            "Meta-Physicist",
            "Nano-technician",
          ],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=281506&patch=18085300",
        },
      ],
    },
    "Tsunami BM-30X": {
      name: "Tsunami BM-30X",
      min: 80,
      max: 190,
      type: "Pistol",
      blurb: "Drops from Dynas. Doctor only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.87s", quality: "" },
        rSpeed: { value: "2.02s", quality: "" },
        range: { value: "21 m", quality: "" },
        minDamage: { value: "27", quality: "" },
        maxDamage: { value: "313", quality: "g" },
        critMod: { value: "321", quality: "" },
        attackCap: { value: "2250", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "714", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Doctor", quality: "r" },
          Pistol: { value: "715", quality: "" },
        },
        mods: {
          "First aid": { value: "8", quality: "" },
          Treatment: { value: "8", quality: "" },
          "Max nano": { value: "72", quality: "" },
        },
      },
      profs: ["Doctor"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208021",
    },
  },
  "Ranged energy": {
    Destruction: {
      name: "Destruction",
      min: 1,
      max: 200,
      type: "Ranged energy",
      blurb: "Drops from sided mobs in the Shadowlands. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "100", quality: "" },
        maxDamage: { value: "425", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1400", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          "Ranged energy": { value: "1401", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=211228",
    },
    "Dreadloch Rapier": {
      name: "Dreadloch Rapier",
      min: 210,
      max: 220,
      type: "Ranged energy",
      blurb:
        "Drops from Dreadloch_camps. Level locked from 210. Hits have a 2% chance to proc an AC debuff.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "230", quality: "g" },
        maxDamage: { value: "350", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1600", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Level: { value: "210", quality: "r" },
          "Ranged energy": { value: "2001", quality: "" },
          Burst: { value: "1001", quality: "" },
          "Fling shot": { value: "1001", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=267128",
    },
    "Dreadloch Thrasher": {
      name: "Dreadloch Thrasher",
      min: 210,
      max: 220,
      type: "Ranged energy",
      blurb:
        "Drops from Dreadloch_camps. Level locked from 210.  Hits have a 5% chance to proc an AC debuff.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "275", quality: "g" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "275", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Level: { value: "210", quality: "r" },
          "Ranged energy": { value: "2001", quality: "" },
          Burst: { value: "1001", quality: "" },
          "Fling shot": { value: "1001", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=267125",
    },
    "El Diablo": {
      name: "El Diablo",
      min: 60,
      max: 200,
      type: "Ranged energy",
      blurb: "Blitzable, shop buyable, and in common loot pools.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.66s", quality: "" },
        rSpeed: { value: "1.66s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "19", quality: "r" },
        maxDamage: { value: "220", quality: "r" },
        critMod: { value: "625", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "818", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Ranged energy": { value: "819", quality: "" },
          Shotgun: { value: "546", quality: "" },
          "Fling shot": { value: "455", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=122481",
    },
    "Freedom Arms Negotiator 25XX": {
      name: "Freedom Arms Negotiator 25XX",
      min: 15,
      max: 50,
      type: "Ranged energy",
      blurb: "Drops from Dynas. Bureaucrat only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.15s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "9", quality: "" },
        maxDamage: { value: "90", quality: "g" },
        critMod: { value: "160", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "192", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Bureaucrat", quality: "r" },
          "Ranged energy": { value: "193", quality: "" },
          "Fling shot": { value: "97", quality: "" },
        },
        mods: {
          "Nano init": { value: "12", quality: "" },
          Psychology: { value: "8", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Bureaucrat"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208058",
    },

    "Heavy Gamma-Beamer": {
      name: "Heavy Gamma-Beamer",
      min: 60,
      max: 200,
      type: "Ranged energy",
      blurb: "Blitzable, shop buyable, and in common loot pools.",
      stats: {
        ql: { value: "15-200", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "10 m", quality: "" },
        minDamage: { value: "4", quality: "r" },
        maxDamage: { value: "384", quality: "" },
        critMod: { value: "801", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Ranged energy": { value: "846", quality: "" },
          "Assault rifle": { value: "564", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=123151",
    },
    "Illegally Modified Dreadloch Thrasher": {
      name: "Illegally Modified Dreadloch Thrasher",
      min: 215,
      max: 220,
      type: "Ranged energy",
      blurb:
        "Drops from Vergil in the 18.8_Subway_raid. Level locked from 215.  Hits have a 5% chance to proc an AC debuff.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "330", quality: "g" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "275", quality: "" },
        attackCap: { value: "2700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst, Full Auto", quality: "g" },
        reqs: {
          Level: { value: "215", quality: "r" },
          "Ranged energy": { value: "2250", quality: "" },
          "Full auto": { value: "2050", quality: "" },
          Burst: { value: "1600", quality: "" },
          "Fling shot": { value: "1100", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305998",
    },

    "Ionization Cannon": {
      name: "Ionization Cannon",
      min: 80,
      max: 190,
      type: "Ranged energy",
      blurb:
        "Drops from T.I.M. in Foremans. Hits have a 5% chance to proc an instant damage program and AC debuff. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "85", quality: "" },
        maxDamage: { value: "520", quality: "" },
        critMod: { value: "35", quality: "" },
        attackCap: { value: "1250", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Ranged energy": { value: "751", quality: "" },
          Burst: { value: "451", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Soldier", "Trader", "Fixer"],
      diff: 69,
      prk: true,
    },

    "Khalum's Reliance": {
      name: "Khalum's Reliance",
      min: 60,
      max: 125,
      type: "Ranged energy",
      blurb: "Drops from Khalum in TOTW. Checks duck explosions. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.3s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "103", quality: "" },
        maxDamage: { value: "254", quality: "" },
        critMod: { value: "173", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Ranged energy": { value: "403", quality: "" },
          "Full auto": { value: "206", quality: "" },
          Burst: { value: "171", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Soldier", "Trader", "Fixer"],
      diff: 69,
      prk: true,
    },

    "Kyr'Ozch Energy Carbine": {
      name: "Kyr'Ozch Energy Carbine",
      min: 1,
      max: 200,
      type: "Ranged energy",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "Ranged energy": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254548",
    },
    "Kyr'Ozch Energy Pistol": {
      name: "Kyr'Ozch Energy Pistol",
      min: 1,
      max: 200,
      type: "Ranged energy",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "225", quality: "g" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "225", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1800", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "Ranged energy": { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254639",
    },
    "Overcharged Nova Flow - Mk IV": {
      name: "Overcharged Nova Flow - Mk IV",
      min: 25,
      max: 50,
      type: "Ranged energy",
      blurb: "Drops from Eumenidies in the Subway. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "38", quality: "" },
        maxDamage: { value: "90", quality: "" },
        critMod: { value: "35", quality: "" },
        attackCap: { value: "400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling shot, Burst", quality: "" },
        reqs: {
          "Ranged energy": { value: "151", quality: "" },
          Burst: { value: "96", quality: "" },
          "Fling shot": { value: "69", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Soldier", "Trader", "Fixer"],
      diff: 69,
      prk: true,
    },
    "Skawt's Compact Plasma Emitter": {
      name: "Skawt's Compact Plasma Emitter",
      min: 80,
      max: 175,
      type: "Ranged energy",
      blurb: "Drops from Skawt in The_Reck.",
      stats: {
        ql: { value: "100", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "150", quality: "g" },
        maxDamage: { value: "300", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "500", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Ranged energy": { value: "700", quality: "" },
          Burst: { value: "500", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=303059",
    },
    "Skawt's Plasma Emitter": {
      name: "Skawt's Plasma Emitter",
      min: 125,
      max: 200,
      type: "Ranged energy",
      blurb: "Drops from Skawt in The_Reck.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "200", quality: "g" },
        maxDamage: { value: "450", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "" },
        reqs: {
          "Ranged energy": { value: "1000", quality: "" },
          "Full auto": { value: "900", quality: "" },
          Burst: { value: "900", quality: "" },
        },
        mods: { "Offense modifier": { value: "15", quality: "" } },
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=303058",
    },
    "Sleek Cannon": {
      name: "Sleek Cannon",
      min: 1,
      max: 200,
      type: "Ranged energy",
      blurb: "Drops from Dynas.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.7s", quality: "r" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "17 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "400", quality: "" },
        critMod: { value: "400", quality: "" },
        attackCap: { value: "2175", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "" },
        reqs: {
          "Ranged energy": { value: "811", quality: "" },
          "Heavy weapons": { value: "541", quality: "r" },
          Burst: { value: "676", quality: "" },
          "Fling shot": { value: "451", quality: "" },
        },
        mods: { "Energy AC": { value: "300", quality: "" } },
      },
      profs: ["Soldier", "Trader"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=160162",
    },
    "SOL XII-P Medical Laser": {
      name: "SOL XII-P Medical Laser",
      min: 15,
      max: 50,
      type: "Ranged energy",
      blurb: "Drops from Dynas. Doctor only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.4s", quality: "" },
        rSpeed: { value: "1.4s", quality: "" },
        range: { value: "28 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "100", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "198", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Doctor", quality: "r" },
          "Ranged energy": { value: "199", quality: "" },
        },
        mods: {
          "Poison AC": { value: "50", quality: "" },
          "Nano init": { value: "16", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Doctor"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208064",
    },
    "Special Edition Kyr'Ozch Energy Pistol": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Energy Pistol",
          min: 151,
          max: 200,
          type: "Ranged energy",
          blurb:
            "Drops from Sector_07_aliens. Profession locked to a bunch of professions. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "175", quality: "g" },
            maxDamage: { value: "256", quality: "" },
            critMod: { value: "175", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              Profession: {
                value: "Agent/Doctor/Engineer/Fixer/Soldier/Trader",
                quality: "r",
              },
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "151", quality: "r" },
              "Ranged energy": { value: "700", quality: "" },
              Burst: { value: "500", quality: "" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: ["Soldier", "Trader", "Fixer"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288297",
        },
        {
          name: "Special Edition Kyr'Ozch Energy Pistol",
          min: 151,
          max: 200,
          type: "Ranged energy",
          blurb:
            "Drops from Sector_07_aliens. Profession locked to a bunch of professions. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "175", quality: "g" },
            maxDamage: { value: "256", quality: "" },
            critMod: { value: "175", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "400", quality: "" },
            specials: { value: "Fling Shot, Burst", quality: "" },
            reqs: {
              Profession: {
                value: "Agent/Doctor/Engineer/Fixer/Soldier/Trader",
                quality: "r",
              },
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              "Ranged energy": { value: "700", quality: "" },
              Burst: { value: "500", quality: "" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: ["Soldier", "Trader", "Fixer"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288297",
        },
      ],
    },
    "Xnemth Plasmaprojector": {
      name: "Xnemth Plasmaprojector",
      min: 1,
      max: 200,
      type: "Ranged energy",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "90", quality: "" },
        maxDamage: { value: "380", quality: "" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "1800", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Full Auto", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          "Ranged energy": { value: "1101", quality: "" },
          "Fling shot": { value: "551", quality: "" },
          "Full auto": { value: "991", quality: "" },
        },
        mods: {},
      },
      profs: ["Soldier", "Trader", "Fixer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=248626",
    },
  },
  Rifle: {
    "Angst of the Xan": {
      versions: [
        {
          name: "Angst of the Xan",
          min: 190,
          max: 220,
          type: "Rifle",
          blurb:
            "Upgrade result from Lord_of_Angst. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.6s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "308", quality: "g" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "308", quality: "" },
            attackCap: { value: "2750", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Aimed Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Rifle: { value: "2251", quality: "r" },
              "Fling shot": { value: "1126", quality: "" },
              "Aimed shot": { value: "1126", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              Concealment: { value: "120", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Agent"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280723",
        },
        {
          name: "Angst of the Xan",
          min: 190,
          max: 220,
          type: "Rifle",
          blurb:
            "Upgrade result from Lord_of_Angst. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.6s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "300", quality: "g" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "308", quality: "" },
            attackCap: { value: "2750", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Aimed Shot", quality: "" },
            reqs: {
              Rifle: { value: "2251", quality: "r" },
              "Fling shot": { value: "1126", quality: "" },
              "Aimed shot": { value: "1126", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              Concealment: { value: "120", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Agent"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280723&patch=18000200",
        },
      ],
    },
    "Barret R-0X A-M Sniper": {
      name: "Barret R-0X A-M Sniper",
      min: 25,
      max: 50,
      type: "Rifle",
      blurb: "Drops from Dynas. Agent only. ",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "30", quality: "" },
        maxDamage: { value: "120", quality: "g" },
        critMod: { value: "180", quality: "g" },
        attackCap: { value: "2450", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          Profession: { value: "Agent", quality: "r" },
          Rifle: { value: "218", quality: "" },
          "Aimed shot": { value: "109", quality: "" },
        },
        mods: {
          Perception: { value: "12", quality: "" },
          "Dodge ranged": { value: "18", quality: "" },
          Concealment: { value: "12", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208045",
    },

    "Bow-Blaster": {
      name: "Bow-Blaster",
      min: 1,
      max: 200,
      type: "Rifle",
      blurb: "Drops from common loot pools and blitzable.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "35", quality: "" },
        maxDamage: { value: "455", quality: "" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
        reqs: {
          Rifle: { value: "766", quality: "g" },
          Bow: { value: "511", quality: "g" },
          "Fling shot": { value: "426", quality: "" },
          "Aimed shot": { value: "426", quality: "" },
        },
        mods: {},
      },
      profs: ["Agent"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=122785",
    },
    "Collins IX Bio-Energy Rifle": {
      versions: [
        {
          name: "Collins IX Bio-Energy Rifle",
          min: 1,
          max: 200,
          type: "Rifle",
          blurb: "Sold by weapon specific venders. Agent only. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3.1s", quality: "r" },
            rSpeed: { value: "1.2s", quality: "" },
            range: { value: "32 m", quality: "" },
            minDamage: { value: "1", quality: "r" },
            maxDamage: { value: "470", quality: "" },
            critMod: { value: "235", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Profession: { value: "Agent", quality: "r" },
              Rifle: { value: "951", quality: "" },
              "Fling shot": { value: "476", quality: "" },
            },
            mods: {},
          },
          profs: ["Agent"],
          prk: false,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159090",
        },
        {
          name: "Collins IX Bio-Energy Rifle",
          min: 1,
          max: 200,
          type: "Rifle",
          blurb: "Sold in the Trader shop. Agent only. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3.1s", quality: "r" },
            rSpeed: { value: "1.2s", quality: "" },
            range: { value: "32 m", quality: "" },
            minDamage: { value: "1", quality: "r" },
            maxDamage: { value: "470", quality: "" },
            critMod: { value: "235", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Profession: { value: "Agent", quality: "r" },
              Rifle: { value: "951", quality: "" },
              "Fling shot": { value: "476", quality: "" },
            },
            mods: {},
          },
          profs: ["Agent"],
          prk: true,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159090",
        },
      ],
    },

    "Corrupted Lord of Angst": {
      name: "Corrupted Lord of Angst",
      min: 205,
      max: 220,
      type: "Rifle",
      blurb: "Drops during the Home_Pyramid_raid. ",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.9s", quality: "" },
        rSpeed: { value: "1.9s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "500", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          "Title level": { value: "7", quality: "r" },
          Rifle: { value: "2000", quality: "" },
          "Fling shot": { value: "1100", quality: "" },
          "Aimed shot": { value: "1100", quality: "" },
        },
        mods: {
          "Max health": { value: "600", quality: "" },
          Concealment: { value: "120", quality: "" },
          "Offense modifier": { value: "30", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302939",
    },
    "Distraction Rifle": {
      name: "Distraction Rifle",
      min: 215,
      max: 220,
      type: "Rifle",
      blurb:
        "Drops from Eliminator Shiro during the 18.8_Subway_raid. Level locked from 210. Hits have a 10% to proc a nano resist debuff.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "35 m", quality: "" },
        minDamage: { value: "290", quality: "g" },
        maxDamage: { value: "555", quality: "g" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2650", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "" },
        reqs: {
          Level: { value: "210", quality: "r" },
          Rifle: { value: "2200", quality: "" },
          "Aimed shot": { value: "1300", quality: "" },
          "Fling shot": { value: "1200", quality: "" },
        },
        mods: {},
      },
      profs: ["Agent"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=305966",
    },

    "FDA Caterwaul 913": {
      name: "FDA Caterwaul 913",
      min: 1,
      max: 200,
      type: "Rifle",
      blurb: "Blitzable and part of common loot pools. Agent only.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.9s", quality: "r" },
        rSpeed: { value: "1.1s", quality: "g" },
        range: { value: "28 m", quality: "" },
        minDamage: { value: "10", quality: "" },
        maxDamage: { value: "410", quality: "g" },
        critMod: { value: "280", quality: "g" },
        attackCap: { value: "1330", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          Profession: { value: "Agent", quality: "r" },
          Rifle: { value: "941", quality: "" },
          "Aimed shot": { value: "471", quality: "" },
        },
        mods: {
          Concealment: { value: "10", quality: "" },
          "NCU memory": { value: "8", quality: "" },
        },
      },
      auno: "https://auno.org/ao/db.php?id=160192",
      profs: ["Agent"],
      diff: 2,
    },
    "Gan'Kar Rifle": {
      name: "Gan'Kar Rifle",
      min: 215,
      max: 220,
      type: "Rifle",
      blurb: "Upgraded rifle from the Xan_weapon_upgrades.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "35 m", quality: "" },
        minDamage: { value: "350", quality: "g" },
        maxDamage: { value: "580", quality: "g" },
        critMod: { value: "500", quality: "g" },
        attackCap: { value: "2750", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
          Level: { value: "201", quality: "r" },
          Rifle: { value: "2501", quality: "r" },
          "Fling shot": { value: "1201", quality: "" },
          "Aimed shot": { value: "1751", quality: "" },
        },
        mods: {
          "Max health": { value: "800", quality: "" },
          Concealment: { value: "175", quality: "" },
          "Offense modifier": { value: "50", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=302164",
    },
    "High Lord of Angst": {
      versions: [
        {
          name: "High Lord of Angst",
          min: 201,
          max: 220,
          type: "Rifle",
          blurb:
            "Weapon_tradeskilled_from_alien_parts. Weapon base drops during The Beast raid. Agent only. Level locked from 201. Has a 25% chance to proc an untaunt.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.7s", quality: "" },
            rSpeed: { value: "1.7s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "200", quality: "" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "100", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Aimed Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              Profession: { value: "Agent", quality: "r" },
              Level: { value: "201", quality: "r" },
              Rifle: { value: "1800", quality: "" },
              "Aimed shot": { value: "900", quality: "" },
            },
            mods: {
              "Dodge ranged": { value: "60", quality: "" },
              Concealment: { value: "120", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Agent"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=257128",
        },
        {
          name: "High Lord of Angst",
          min: 201,
          max: 220,
          type: "Rifle",
          blurb:
            "Weapon_tradeskilled_from_alien_parts. Weapon base drops during The Beast raid. Agent only. Level locked from 210. Has a 10% chance to proc an untaunt.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "2s", quality: "" },
            range: { value: "30 m", quality: "" },
            minDamage: { value: "100", quality: "" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "100", quality: "" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Aimed Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              Profession: { value: "Agent", quality: "r" },
              Level: { value: "210", quality: "r" },
              Rifle: { value: "1800", quality: "" },
              "Aimed shot": { value: "900", quality: "" },
            },
            mods: {
              "Dodge ranged": { value: "60", quality: "" },
              Concealment: { value: "120", quality: "" },
              "Offense modifier": { value: "30", quality: "" },
            },
          },
          profs: ["Agent"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=257128",
        },
      ],
    },
    "Incendiary Rifle": {
      name: "Incendiary Rifle",
      min: 100,
      max: 175,
      type: "Rifle",
      blurb: "Drops from Dynas. Agent only. Checks duck-explosives.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.1s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "375", quality: "" },
        critMod: { value: "375", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Agent", quality: "r" },
          Rifle: { value: "827", quality: "" },
        },
        mods: {
          "Chemical AC": { value: "300", quality: "" },
          "Fire AC": { value: "300", quality: "" },
          "Max nano": { value: "60", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208006",
    },
    "Joy of the Hunt": {
      name: "Joy of the Hunt",
      min: 150,
      max: 215,
      type: "Rifle",
      blurb: "Drops from Tiunissik in Inferno, Shadowlands. Agent only. ",
      stats: {
        ql: { value: "240-260", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "200", quality: "" },
        maxDamage: { value: "400", quality: "g" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Agent", quality: "r" },
          Rifle: { value: "1601", quality: "" },
          "Aimed shot": { value: "801", quality: "" },
        },
        mods: {
          Perception: { value: "60", quality: "" },
          Adventuring: { value: "60", quality: "" },
          "Run speed": { value: "60", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=245883",
    },
    "Kyr'Ozch Rifle": {
      name: "Kyr'Ozch Rifle",
      min: 1,
      max: 200,
      type: "Rifle",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "250", quality: "g" },
        maxDamage: { value: "500", quality: "g" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Rifle: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Agent"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254471",
    },

    Longshot: {
      name: "Longshot",
      min: 150,
      max: 200,
      type: "Rifle",
      blurb:
        "Drops from high rank officers in the OT base in Avalon or clan base in Wailing Wastes. Agent only. Level locked from 150.",
      stats: {
        ql: { value: "200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.5s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "30", quality: "" },
        maxDamage: { value: "500", quality: "g" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "2050", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          Profession: { value: "Agent", quality: "r" },
          "Title level": { value: "5", quality: "r" },
          Rifle: { value: "1001", quality: "" },
          "Aimed shot": { value: "501", quality: "" },
        },
        mods: {
          "Chemical AC": { value: "300", quality: "" },
          "Ranged init": { value: "30", quality: "" },
          "Dodge ranged": { value: "20", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=203574",
    },

    "MTI SL70 RX Razorback Gargantua": {
      name: "MTI SL70 RX Razorback Gargantua",
      min: 1,
      max: 200,
      type: "Rifle",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "28 m", quality: "" },
        minDamage: { value: "10", quality: "r" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "225", quality: "" },
        attackCap: { value: "1600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Rifle: { value: "1201", quality: "" },
          "Fling shot": { value: "601", quality: "" },
          "Aimed shot": { value: "601", quality: "" },
        },
        mods: {
          Intelligence: { value: "25", quality: "" },
          Rifle: { value: "25", quality: "" },
          "Dodge ranged": { value: "30", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=249829",
    },
    "Ofab Cobra": {
      name: "Ofab Cobra",
      min: 1,
      max: 200,
      type: "Rifle",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.7s", quality: "" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "275", quality: "" },
        maxDamage: { value: "550", quality: "g" },
        critMod: { value: "275", quality: "" },
        attackCap: { value: "2600", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Rifle: { value: "2201", quality: "" },
          "Fling shot": { value: "1101", quality: "" },
          "Aimed shot": { value: "1101", quality: "" },
        },
        mods: {},
      },
      profs: ["Agent"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=265320",
    },
    "Perennium Sniper": {
      name: "Perennium Sniper",
      min: 30,
      max: 200,
      type: "Rifle",
      blurb:
        "Crafted from a Nano-Charged_weapon_and_a_bunch_of_SL_parts. Agent only. ",
      stats: {
        ql: { value: "50-200", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "175", quality: "" },
        maxDamage: { value: "425", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1250", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Agent", quality: "r" },
          Rifle: { value: "1001", quality: "" },
          "Aimed shot": { value: "501", quality: "" },
        },
        mods: { "Experience modifier": { value: "4", quality: "" } },
      },
      profs: ["Agent"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=246414",
    },

    "Shadowfade Rifle": {
      name: "Shadowfade Rifle",
      min: 40,
      max: 100,
      type: "Rifle",
      blurb:
        "Drops from Reverend Dashell in TOTW. Hits have a 10% to proc an AAO debuff. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "83", quality: "" },
        maxDamage: { value: "171", quality: "" },
        critMod: { value: "50", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "" },
        reqs: {
          Rifle: { value: "321", quality: "" },
          "Aimed shot": { value: "176", quality: "" },
          "Fling shot": { value: "151", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Agent"],
      diff: 69,
      prk: true,
    },
    "Unionist Arbalest": {
      name: "Unionist Arbalest",
      min: 70,
      max: 175,
      type: "Rifle",
      blurb: "Drops from Dynas. Clan/Neutral only.",
      stats: {
        ql: { value: "100-150", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.3s", quality: "" },
        rSpeed: { value: "1.3s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "30", quality: "" },
        maxDamage: { value: "330", quality: "r" },
        critMod: { value: "300", quality: "" },
        attackCap: { value: "1450", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          Faction: { value: "Not Omni-Tek", quality: "r" },
          Rifle: { value: "755", quality: "g" },
          Bow: { value: "504", quality: "" },
          "Aimed shot": { value: "420", quality: "" },
        },
        mods: {
          "Cold AC": { value: "300", quality: "" },
          Perception: { value: "20", quality: "" },
          Concealment: { value: "10", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208089",
    },

    "Yatamutchy X-3 Counter-Sniper Rifle": {
      name: "Yatamutchy X-3 Counter-Sniper Rifle",
      min: 1,
      max: 200,
      type: "Rifle",
      blurb: "Drops from common loot pools.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.4s", quality: "" },
        rSpeed: { value: "2.3s", quality: "" },
        range: { value: "35 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "464", quality: "" },
        critMod: { value: "496", quality: "g" },
        attackCap: { value: "1925", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Aimed Shot", quality: "" },
        reqs: {
          Rifle: { value: "946", quality: "" },
          "Aimed shot": { value: "473", quality: "" },
        },
        mods: {
          Rifle: { value: "12", quality: "" },
          Perception: { value: "24", quality: "" },
          "Aimed shot": { value: "12", quality: "" },
        },
      },
      profs: ["Agent"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=161130",
    },
  },
  Shotgun: {
    "Cries from the Aether": {
      name: "Cries from the Aether",
      min: 40,
      max: 80,
      type: "Shotgun",
      blurb: "Drops from shotgun-wielding cultists in TOTW. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "91", quality: "" },
        maxDamage: { value: "163", quality: "" },
        critMod: { value: "50", quality: "" },
        attackCap: { value: "700", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Shotgun: { value: "321", quality: "" },
          "Fling shot": { value: "157", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Trader"],
      diff: 69,
      prk: true,
    },
    "Eye Wind Onehander": {
      name: "Eye Wind Onehander",
      min: 60,
      max: 200,
      type: "Shotgun",
      blurb: "Blitzable and part of common loot pools.",
      stats: {
        ql: { value: "1-188", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.01s", quality: "g" },
        rSpeed: { value: "1.12s", quality: "g" },
        range: { value: "12 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "121", quality: "r" },
        critMod: { value: "584", quality: "g" },
        attackCap: { value: "1223", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "724", quality: "" },
        specials: { value: "Fling Shot, Burst, Aimed Shot", quality: "g" },
        reqs: {
          Shotgun: { value: "797", quality: "" },
          Burst: { value: "598", quality: "" },
          "Fling shot": { value: "400", quality: "" },
          "Aimed shot": { value: "400", quality: "r" },
        },
        mods: {
          "Chemical AC": { value: "30", quality: "" },
          "Radiation AC": { value: "30", quality: "" },
          "Trap disarming": { value: "30", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=144062",
    },
    "Greed of the Xan": {
      versions: [
        {
          name: "Greed of the Xan",
          min: 190,
          max: 220,
          type: "Shotgun",
          blurb:
            "Upgrade result from Lord_of_Greed. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "425", quality: "g" },
            maxDamage: { value: "569", quality: "g" },
            critMod: { value: "675", quality: "g" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Legacy of the Xan", quality: "r" },
              "Title level": { value: "6", quality: "r" },
              Shotgun: { value: "2251", quality: "r" },
              "Fling shot": { value: "1126", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Psychological modifications": { value: "30", quality: "" },
              "Time and space": { value: "30", quality: "" },
            },
          },
          profs: ["Trader"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280725",
        },
        {
          name: "Greed of the Xan",
          min: 190,
          max: 220,
          type: "Shotgun",
          blurb:
            "Upgrade result from Lord_of_Greed. Upgrade drops during 3_different_raids. ",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "425", quality: "g" },
            maxDamage: { value: "569", quality: "g" },
            critMod: { value: "675", quality: "g" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              Shotgun: { value: "2251", quality: "r" },
              "Fling shot": { value: "1126", quality: "" },
            },
            mods: {
              "Max health": { value: "600", quality: "" },
              "Psychological modifications": { value: "30", quality: "" },
              "Time and space": { value: "30", quality: "" },
            },
          },
          profs: ["Trader"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280725",
        },
      ],
    },
    "Fine Smith Shattergun": {
      name: "Fine Smith Shattergun",
      min: 80,
      max: 200,
      type: "Shotgun",
      blurb:
        "Drops from sided mobs in the Shadowlands. Profession locked to Trader. Right hand only. Multi check ranges from 4 to 748 depending on QL.",
      stats: {
        ql: { value: "100-200", quality: "r" },
        dual: { value: "Yes", quality: "r" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "225", quality: "g" },
        maxDamage: { value: "300", quality: "g" },
        critMod: { value: "375", quality: "" },
        attackCap: { value: "1200", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "748", quality: "r" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Trader", quality: "r" },
          Shotgun: { value: "1001", quality: "" },
        },
        mods: { "Weapon smithing": { value: "40", quality: "" } },
      },
      profs: ["Trader"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=243771",
    },
    "Home Defender": {
      name: "Home Defender",
      min: 1,
      max: 200,
      type: "Shotgun",
      blurb:
        "Blitzable, shop buyable and part of common loot pools. Gets a little bit faster as the QL rises.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.3s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "16 m", quality: "" },
        minDamage: { value: "2", quality: "r" },
        maxDamage: { value: "438", quality: "g" },
        critMod: { value: "720", quality: "g" },
        attackCap: { value: "1800", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "949", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: { Shotgun: { value: "917", quality: "" } },
        mods: {
          "Max health": { value: "80", quality: "" },
          Perception: { value: "25", quality: "" },
          "Evade close": { value: "20", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=124240",
    },
    "Inamorata Shotgun": {
      name: "Inamorata Shotgun",
      min: 80,
      max: 200,
      type: "Shotgun",
      blurb:
        "Drops from Redeemed mobs in the Shadowlands. Can be upgraded to a turn_spirit_weapon. Effectively an omni Sacrosanct_Shotgun.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Faction Unredeemed": { value: "35001", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Shotgun: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212260",
    },
    "Ithaca Ki-8": {
      name: "Ithaca Ki-8",
      min: 60,
      max: 200,
      type: "Shotgun",
      blurb: "Blitzable, shop buyable and part of common loot pools.",
      stats: {
        ql: { value: "1-199", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1.5s", quality: "g" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "4", quality: "r" },
        maxDamage: { value: "211", quality: "r" },
        critMod: { value: "717", quality: "g" },
        attackCap: { value: "1592", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
        reqs: {
          Shotgun: { value: "873", quality: "" },
          "Fling shot": { value: "437", quality: "" },
          "Aimed shot": { value: "437", quality: "r" },
        },
        mods: {
          "Duck explosives": { value: "30", quality: "" },
          "Dodge ranged": { value: "30", quality: "" },
          "Evade close": { value: "30", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=124327",
    },
    "Krutt Assault 219": {
      name: "Krutt Assault 219",
      min: 60,
      max: 200,
      type: "Shotgun",
      auno: "https://auno.org/ao/db.php?id=124284",
      blurb: "Blitzable, shop buyable and part of common loot pools.",
      stats: {
        ql: { value: "1-184", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.13s", quality: "" },
        rSpeed: { value: "2.5s", quality: "" },
        range: { value: "22 m", quality: "" },
        minDamage: { value: "29", quality: "r" },
        maxDamage: { value: "178", quality: "r" },
        critMod: { value: "1143", quality: "g" },
        attackCap: { value: "2301", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Shotgun: { value: "794", quality: "" },
          "Fling shot": { value: "398", quality: "" },
        },
        mods: {
          Stamina: { value: "24", quality: "" },
          Intelligence: { value: "24", quality: "" },
          "Computer literacy": { value: "20", quality: "" },
        },
      },
      profs: ["Trader"],
      diff: 1,
    },
    "Kyr'Ozch Shotgun": {
      name: "Kyr'Ozch Shotgun",
      min: 1,
      max: 220,
      type: "Shotgun",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks. ",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "200", quality: "g" },
        maxDamage: { value: "500", quality: "" },
        critMod: { value: "500", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Shotgun: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Trader"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254583",
    },
    "Lord of Greed": {
      name: "Lord of Greed",
      min: 190,
      max: 220,
      type: "Shotgun",
      blurb: "Drops during The_Beast_raid. Upgrades to Greed_of_the_Xan.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "225", quality: "g" },
        maxDamage: { value: "450", quality: "g" },
        critMod: { value: "675", quality: "g" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Title level": { value: "6", quality: "r" },
          Shotgun: { value: "2251", quality: "r" },
        },
        mods: {
          "Max health": { value: "500", quality: "" },
          "Duck explosives": { value: "100", quality: "" },
          "NCU memory": { value: "50", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=244862",
    },
    "Maw of the Abyss": {
      name: "Maw of the Abyss",
      min: 175,
      max: 200,
      type: "Shotgun",
      blurb: "Drops in IS.",
      stats: {
        ql: { value: "1", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.75s", quality: "r" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "16 m", quality: "" },
        minDamage: { value: "184", quality: "g" },
        maxDamage: { value: "503", quality: "g" },
        critMod: { value: "2", quality: "r" },
        attackCap: { value: "1100", quality: "r" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Shotgun: { value: "937", quality: "" },
          "Fling shot": { value: "699", quality: "" },
        },
        mods: {},
      },
      profs: ["Trader"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=206049",
    },
    "MTI G04U": {
      name: "MTI G04U",
      min: 80,
      max: 150,
      type: "Shotgun",
      blurb: "Drops from Dynas. Trader only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.75s", quality: "" },
        rSpeed: { value: "1.75s", quality: "" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "397", quality: "g" },
        critMod: { value: "298", quality: "" },
        attackCap: { value: "2080", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "712", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          Profession: { value: "Trader", quality: "r" },
          Shotgun: { value: "713", quality: "" },
        },
        mods: {
          "Computer literacy": { value: "5", quality: "" },
          "Max nano": { value: "20", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208011",
    },
    Mudurlugu: {
      versions: [
        {
          name: "Mudurlugu",
          min: 1,
          max: 200,
          type: "Shotgun",
          blurb: "Drops from Shadowlands common loot pools. Trader only. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3s", quality: "r" },
            rSpeed: { value: "3s", quality: "r" },
            range: { value: "20 m", quality: "" },
            minDamage: { value: "350", quality: "g" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "500", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "" },
            reqs: {
              "Expansion sets": { value: "Shadowlands", quality: "r" },
              Profession: { value: "Trader", quality: "r" },
              Shotgun: { value: "1001", quality: "" },
            },
            mods: {
              "Electrical engineering": { value: "22", quality: "" },
              "Quantum physics": { value: "22", quality: "" },
              "Nano programming": { value: "22", quality: "" },
            },
          },
          profs: ["Trader"],
          prk: false,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=243747",
        },
        {
          name: "Mudurlugu",
          min: 1,
          max: 200,
          type: "Shotgun",
          blurb:
            "Drops from Shadowlands common loot pools. Trader only. NODROP flagged.",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "3s", quality: "r" },
            rSpeed: { value: "3s", quality: "r" },
            range: { value: "20 m", quality: "" },
            minDamage: { value: "350", quality: "g" },
            maxDamage: { value: "500", quality: "g" },
            critMod: { value: "500", quality: "" },
            attackCap: { value: "1500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "" },
            reqs: {
              Profession: { value: "Trader", quality: "r" },
              Shotgun: { value: "1001", quality: "" },
            },
            mods: {
              "Electrical engineering": { value: "22", quality: "" },
              "Quantum physics": { value: "22", quality: "" },
              "Nano programming": { value: "22", quality: "" },
            },
          },
          profs: ["Trader"],
          prk: true,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=243747",
        },
      ],
    },
    "Ofab Silverback": {
      versions: [
        {
          name: "Ofab Silverback",
          min: 1,
          max: 220,
          type: "Shotgun",
          blurb:
            "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials.",
          stats: {
            ql: { value: "1-300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.6s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "230", quality: "g" },
            maxDamage: { value: "550", quality: "g" },
            critMod: { value: "600", quality: "" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Lost Eden", quality: "r" },
              Shotgun: { value: "2201", quality: "r" },
              "Fling shot": { value: "1101", quality: "" },
              "Aimed shot": { value: "1101", quality: "r" },
            },
            mods: {},
          },
          profs: ["Trader"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=264898",
        },
        {
          name: "Ofab Silverback",
          min: 220,
          max: 1,
          type: "Shotgun",
          blurb:
            "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials. Trader only.",
          stats: {
            ql: { value: "1-300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "230", quality: "g" },
            maxDamage: { value: "550", quality: "g" },
            critMod: { value: "600", quality: "" },
            attackCap: { value: "2600", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot, Aimed Shot", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Lost Eden", quality: "r" },
              Profession: { value: "Trader", quality: "r" },
              Shotgun: { value: "2201", quality: "" },
              "Fling shot": { value: "1101", quality: "" },
              "Aimed shot": { value: "1101", quality: "r" },
            },
            mods: {},
          },
          profs: ["Trader"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=264898&patch=17010000",
        },
      ],
    },
    Pump: {
      name: "Pump",
      min: 15,
      max: 60,
      type: "Shotgun",
      blurb: "Drops from Dynas. Trader only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "r" },
        rSpeed: { value: "3.5s", quality: "r" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "330", quality: "g" },
        critMod: { value: "130", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Profession: { value: "Trader", quality: "r" },
          Shotgun: { value: "203", quality: "g" },
          "Fling shot": { value: "102", quality: "" },
        },
        mods: {
          "Duck explosives": { value: "24", quality: "" },
          "Vehicle ground": { value: "12", quality: "" },
          "Max nano": { value: "36", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208055",
    },
    "Sacrosanct Shotgun": {
      name: "Sacrosanct Shotgun",
      min: 80,
      max: 200,
      type: "Shotgun",
      blurb:
        "Drops from Unredeemed mobs in the Shadowlands. Can be upgraded to a turn_spirit_weapon. Effectively a clan Inamorata_Shotgun.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "600", quality: "g" },
        critMod: { value: "200", quality: "" },
        attackCap: { value: "2000", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Faction Redeemed": { value: "35001", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Shotgun: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212272",
    },
    "Salabim Shotgun": {
      name: "Salabim Shotgun",
      min: 1,
      max: 220,
      type: "Shotgun",
      blurb:
        "Tradeskilled_from_alien_parts dropped from alien_generals. Trader only. Gets faster as the QL rises.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "300", quality: "g" },
        maxDamage: { value: "475", quality: "" },
        critMod: { value: "410", quality: "" },
        attackCap: { value: "2300", quality: "r" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Profession: { value: "Trader", quality: "r" },
          Shotgun: { value: "2201", quality: "" },
          "Fling shot": { value: "1101", quality: "" },
        },
        mods: { "Max health": { value: "100", quality: "" } },
      },
      profs: ["Trader"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=253236",
    },
    "SOL SG-7X Robust": {
      name: "SOL SG-7X Robust",
      min: 20,
      max: 50,
      type: "Shotgun",
      blurb: "Drops from Dynas. Soldier only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "18 m", quality: "" },
        minDamage: { value: "20", quality: "" },
        maxDamage: { value: "120", quality: "g" },
        critMod: { value: "60", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Fling Shot, Burst", quality: "g" },
        reqs: {
          Profession: { value: "Soldier", quality: "r" },
          Shotgun: { value: "219", quality: "" },
          Burst: { value: "165", quality: "r" },
          "Fling shot": { value: "110", quality: "" },
        },
        mods: {
          "Max health": { value: "60", quality: "" },
          "Duck explosives": { value: "20", quality: "" },
        },
      },
      profs: ["Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208033",
    },
    "Special Edition Kyr'Ozch Shotgun": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Shotgun",
          min: 151,
          max: 200,
          type: "Shotgun",
          blurb:
            "Drops from Sector_07_aliens. Trader only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "262", quality: "g" },
            maxDamage: { value: "380", quality: "g" },
            critMod: { value: "450", quality: "" },
            attackCap: { value: "1500", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Level: { value: "151", quality: "r" },
              Profession: { value: "Trader", quality: "r" },
              Shotgun: { value: "700", quality: "g" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader"],
          prk: false,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288289",
        },
        {
          name: "Special Edition Kyr'Ozch Shotgun",
          min: 151,
          max: 200,
          type: "Shotgun",
          blurb:
            "Drops from Sector_07_aliens. Trader only. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.5s", quality: "" },
            rSpeed: { value: "1.5s", quality: "" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "262", quality: "g" },
            maxDamage: { value: "380", quality: "g" },
            critMod: { value: "450", quality: "" },
            attackCap: { value: "1500", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Fling Shot", quality: "" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Trader", quality: "r" },
              Shotgun: { value: "700", quality: "g" },
              "Fling shot": { value: "350", quality: "" },
            },
            mods: {},
          },
          profs: ["Trader"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288289&patch=18041400",
        },
      ],
    },

    "Ultra-Light Missile Pistol Raid 9-X": {
      name: "Ultra-Light Missile Pistol Raid 9-X",
      min: 1,
      max: 200,
      type: "Shotgun",
      blurb:
        "Blitzable, shop buyable and part of common loot pools. Attack speed gets faster as QL gets higher.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "0.5s", quality: "r" },
        rSpeed: { value: "1.7s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "3", quality: "r" },
        maxDamage: { value: "142", quality: "r" },
        critMod: { value: "850", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1036", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          Shotgun: { value: "705", quality: "" },
          Pistol: { value: "470", quality: "r" },
          "Fling shot": { value: "392", quality: "" },
        },
        mods: {},
      },
      profs: ["Trader"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=123456",
    },
    "Uncle Bazzit Diplomatic": {
      name: "Uncle Bazzit Diplomatic",
      min: 1,
      max: 200,
      type: "Shotgun",
      blurb:
        "Drops from common loot pools, but not shop buyable or blitzable. Profession locked to Trader and Agent.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.1s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "16 m", quality: "" },
        minDamage: { value: "80", quality: "" },
        maxDamage: { value: "360", quality: "g" },
        critMod: { value: "360", quality: "" },
        attackCap: { value: "1800", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1100", quality: "" },
        specials: { value: "Fling Shot", quality: "" },
        reqs: {
          "Visual profession": { value: "Trader", quality: "r" },
          Shotgun: { value: "1101", quality: "" },
          "Fling shot": { value: "551", quality: "" },
        },
        mods: {
          "Computer literacy": { value: "8", quality: "" },
          "Max nano": { value: "150", quality: "" },
        },
      },
      profs: ["Trader"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=206672",
    },
    "Vektor ND Grand Wyrm": {
      versions: [
        {
          name: "Vektor ND Grand Wyrm",
          min: 201,
          max: 220,
          type: "Shotgun",
          blurb:
            "Weapon_tradeskilled_from_alien_parts. Base is in common loot pools and blitzable. Trader and level locked. Has a chance to proc an AAO debuff based on Alchemist and Distill Life perks.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.8s", quality: "" },
            rSpeed: { value: "1.8s", quality: "" },
            range: { value: "26 m", quality: "" },
            minDamage: { value: "250", quality: "g" },
            maxDamage: { value: "520", quality: "g" },
            critMod: { value: "900", quality: "g" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "r" },
            reqs: {
              Profession: { value: "Trader", quality: "r" },
              Level: { value: "201", quality: "r" },
              Shotgun: { value: "1800", quality: "" },
            },
            mods: {
              "Ranged init": { value: "20", quality: "" },
              "Duck explosives": { value: "20", quality: "" },
            },
          },
          profs: ["Trader"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=257123",
        },
        {
          name: "Vektor ND Grand Wyrm",
          min: 210,
          max: 220,
          type: "Shotgun",
          blurb:
            "Weapon_tradeskilled_from_alien_parts. Base is in common loot pools and blitzable. Trader and level locked. Has a chance to proc an AAO debuff based on Alchemist and Distill Life perks.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.75s", quality: "" },
            rSpeed: { value: "1.75s", quality: "" },
            range: { value: "26 m", quality: "" },
            minDamage: { value: "250", quality: "g" },
            maxDamage: { value: "520", quality: "g" },
            critMod: { value: "900", quality: "g" },
            attackCap: { value: "2500", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "", quality: "r" },
            reqs: {
              Profession: { value: "Trader", quality: "r" },
              Level: { value: "210", quality: "r" },
              Shotgun: { value: "1800", quality: "" },
            },
            mods: {
              "Ranged init": { value: "20", quality: "" },
              "Duck explosives": { value: "20", quality: "" },
            },
          },
          profs: ["Trader"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=257123&patch=15080000",
        },
      ],
    },
  },
  Smg: {
    "Beta Ejector": {
      name: "Beta Ejector",
      min: 25,
      max: 60,
      type: "Smg",
      blurb: "Drops from Figment of Imagination in Steps_of_Madness. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.25s", quality: "" },
        rSpeed: { value: "1.25s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "15", quality: "" },
        maxDamage: { value: "100", quality: "" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "160", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "201", quality: "" },
          Burst: { value: "151", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Fixer", "Soldier"],
      diff: 69,
      prk: true,
    },
    Blackbird: {
      name: "Blackbird",
      min: 80,
      max: 200,
      type: "Smg",
      blurb:
        "Drops from Cenobite Shadows in COH. Profession locked to Fixer and Soldier. Stats vary significantly across the 5 QLs.",
      stats: {
        ql: { value: "100-105", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "425", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "1250", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "750", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Profession: { value: "Fixer or Soldier", quality: "r" },
          Smg: { value: "1001", quality: "" },
          Burst: { value: "751", quality: "" },
        },
        mods: {
          "Nano pool": { value: "40", quality: "" },
          "Nano cost modifier": { value: "2", quality: "" },
        },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=246724",
    },
    "Envy of the Xan": {
      versions: [
        {
          name: "Envy of the Xan",
          min: 190,
          max: 220,
          type: "Smg",
          blurb:
            "Upgrade result from Lord_of_Envy. Upgrade drops during 3_different_raids. Check Rhat'Ata Gun for a version that replaces FA with fling shot.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "268", quality: "g" },
            maxDamage: { value: "408", quality: "g" },
            critMod: { value: "288", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: { value: "Burst, Full Auto", quality: "g" },
            reqs: {
              "Title level": { value: "6", quality: "r" },
              "Expansion sets": { value: "Legacy of the Xan?", quality: "r" },
              Smg: { value: "2251", quality: "" },
              Burst: { value: "1689", quality: "" },
              "Full auto": { value: "1689", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Fixer", "Soldier"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280724&patch=18085300",
        },
        {
          name: "Envy of the Xan",
          min: 190,
          max: 220,
          type: "Smg",
          blurb:
            "Upgrade result from Lord_of_Envy. Upgrade drops during 3_different_raids. Check Rhat'Ata Gun for a version that replaces FA with fling shot.",
          stats: {
            ql: { value: "300", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "268", quality: "g" },
            maxDamage: { value: "408", quality: "g" },
            critMod: { value: "288", quality: "" },
            attackCap: { value: "2750", quality: "" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "1750", quality: "" },
            specials: { value: "Burst, Full Auto", quality: "g" },
            reqs: {
              Smg: { value: "2251", quality: "" },
              Burst: { value: "1689", quality: "" },
              "Full auto": { value: "1689", quality: "" },
            },
            mods: {
              "Max health": { value: "300", quality: "" },
              "Offense modifier": { value: "15", quality: "" },
              "Defense modifier": { value: "15", quality: "" },
            },
          },
          profs: ["Fixer", "Soldier"],
          prk: true,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=280724&patch=18085300",
        },
      ],
    },
    "Fantaghiro BBI-Viral": {
      name: "Fantaghiro BBI-Viral",
      min: 1,
      max: 200,
      type: "Smg",
      blurb:
        "One of the viral_weapon_upgrades_tradeskills. Weapon base is blitzable and in common pools. Viral Weapon Upgrade drops from aliens. ",
      stats: {
        ql: { value: "1-184", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "398", quality: "g" },
        critMod: { value: "298", quality: "" },
        attackCap: { value: "1741", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Smg: { value: "1095", quality: "" },
          Burst: { value: "822", quality: "" },
          "Full auto": { value: "986", quality: "" },
        },
        mods: {
          Sense: { value: "16", quality: "" },
          "Defense modifier": { value: "5", quality: "" },
        },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=248587",
    },
    "Fusion Ejector": {
      name: "Fusion Ejector",
      min: 100,
      max: 170,
      type: "Smg",
      blurb: "Tradeskilled_from_2_ejectors. PRK only.",
      stats: {
        ql: { value: "SPECIAL", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.25s", quality: "" },
        rSpeed: { value: "1.25s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "55", quality: "" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "1100", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "718", quality: "" },
          Burst: { value: "527", quality: "" },
          "Fling shot": { value: "351", quality: "" },
        },
        mods: {},
      },
      auno: false,
      profs: ["Fixer", "Soldier"],
      diff: 69,
      prk: true,
    },
    "Gamma Ejector": {
      name: "Gamma Ejector",
      min: 41,
      max: 100,
      type: "Smg",
      blurb: "Drops from bodyguards in Foremans.",
      stats: {
        ql: { value: "68", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "3s", quality: "r" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "14", quality: "" },
        maxDamage: { value: "215", quality: "g" },
        critMod: { value: "78", quality: "" },
        attackCap: { value: "", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "495", quality: "r" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "278", quality: "" },
          Burst: { value: "210", quality: "" },
          Level: { value: "41", quality: "r" },
        },
        mods: {},
      },
      auno: "https://auno.org/ao/db.php?id=156770",
      profs: ["Fixer", "Soldier"],
      diff: 4,
    },
    "Illicit Laser Backup": {
      name: "Illicit Laser Backup",
      min: 1,
      max: 200,
      type: "Smg",
      blurb: "Blitzable and part of common loot pools. Fixer only.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "1.35s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "460", quality: "g" },
        critMod: { value: "300", quality: "g" },
        attackCap: { value: "1400", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "772", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Profession: { value: "Fixer", quality: "r" },
          Smg: { value: "811", quality: "g" },
          Pistol: { value: "541", quality: "r" },
          Burst: { value: "676", quality: "" },
        },
        mods: {
          Stamina: { value: "10", quality: "" },
          "Duck explosives": { value: "30", quality: "" },
          "Evade close": { value: "20", quality: "" },
        },
      },
      profs: ["Fixer"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=233798",
    },
    "Inamorata Blaster": {
      name: "Inamorata Blaster",
      min: 80,
      max: 220,
      type: "Smg",
      blurb:
        "Drops from Redeemed mobs in the Shadowlands. Can be upgraded to a turn_spirit_weapon. Effectively an omni Sacrosanct_Blaster.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "500", quality: "" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "1900", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Faction Unredeemed": { value: "35001", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Smg: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212242",
    },
    "Juggernaut Rear Mitrailleuse": {
      name: "Juggernaut Rear Mitrailleuse",
      min: 175,
      max: 200,
      type: "Smg",
      blurb: "Drops during the Juggernaut_raid. Clan only.",
      stats: {
        ql: { value: "200-225", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2.1s", quality: "" },
        rSpeed: { value: "2.1s", quality: "" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "42", quality: "" },
        maxDamage: { value: "420", quality: "g" },
        critMod: { value: "320", quality: "" },
        attackCap: { value: "1900", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Faction: { value: "Clan", quality: "r" },
          Smg: { value: "1167", quality: "" },
          Burst: { value: "875", quality: "" },
        },
        mods: {
          "Projectile AC": { value: "300", quality: "" },
          "Energy AC": { value: "300", quality: "" },
        },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=207252",
    },
    "Kyr'Ozch Machine Pistol": {
      name: "Kyr'Ozch Machine Pistol",
      min: 1,
      max: 220,
      type: "Smg",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "225", quality: "g" },
        maxDamage: { value: "325", quality: "r" },
        critMod: { value: "225", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1500", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Smg: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254653",
    },
    "Kyr'Ozch Submachine Gun": {
      name: "Kyr'Ozch Submachine Gun",
      min: 1,
      max: 220,
      type: "Smg",
      blurb:
        "Drops from aliens. Different sectors house different QLs. Can be upraded to different_special_attacks.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "245", quality: "g" },
        maxDamage: { value: "385", quality: "r" },
        critMod: { value: "245", quality: "" },
        attackCap: { value: "2400", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Expansion sets": { value: "Alien Invasion", quality: "r" },
          Smg: { value: "2001", quality: "" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=254520",
    },
    "Light Miasma Beamer": {
      name: "Light Miasma Beamer",
      min: 20,
      max: 60,
      type: "Smg",
      blurb: "Drops from Dynas. Fixer only.",
      stats: {
        ql: { value: "40-50", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.15s", quality: "g" },
        rSpeed: { value: "1.65s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "80", quality: "" },
        critMod: { value: "160", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "191", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Profession: { value: "Fixer", quality: "r" },
          Smg: { value: "192", quality: "g" },
          Burst: { value: "144", quality: "" },
        },
        mods: {
          "Dodge ranged": { value: "8", quality: "" },
          "Run speed": { value: "16", quality: "" },
          "Breaking and entry": { value: "12", quality: "" },
        },
      },
      profs: ["Fixer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=208042",
    },
    "Light Suppressor": {
      name: "Light Suppressor",
      min: 1,
      max: 200,
      type: "Smg",
      blurb: "Blitzable, drops from common loot pools, and shop buyable.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "410", quality: "" },
        critMod: { value: "410", quality: "g" },
        attackCap: { value: "1500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "949", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "847", quality: "" },
          "Ranged energy": { value: "565", quality: "r" },
          Burst: { value: "706", quality: "" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=160151",
    },
    "Lord of Envy": {
      name: "Lord of Envy",
      min: 190,
      max: 220,
      type: "Smg",
      blurb: "Drops during The_Beast_raid. Upgrades to Envy_of_the_Xan.",
      stats: {
        ql: { value: "300", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "2s", quality: "" },
        rSpeed: { value: "2s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "250", quality: "g" },
        maxDamage: { value: "275", quality: "" },
        critMod: { value: "275", quality: "g" },
        attackCap: { value: "2500", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Title level": { value: "6", quality: "r" },
          Smg: { value: "2251", quality: "r" },
          Burst: { value: "1689", quality: "" },
        },
        mods: {
          "Max health": { value: "350", quality: "" },
          "Matter metamorphosis": { value: "30", quality: "" },
          "Dodge ranged": { value: "90", quality: "" },
        },
      },
      profs: ["Fixer", "Solider"],
      prk: false,
      diff: 6,
      auno: "https://auno.org/ao/db.php?id=244843",
    },
    "Manex Catastrophe": {
      name: "Manex Catastrophe",
      min: 1,
      max: 200,
      type: "Smg",
      blurb: "Drops from Dynas.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3.5s", quality: "r" },
        rSpeed: { value: "3.5s", quality: "r" },
        range: { value: "14 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "750", quality: "g" },
        critMod: { value: "100", quality: "" },
        attackCap: { value: "1475", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "956", quality: "" },
          Burst: { value: "717", quality: "" },
        },
        mods: { Burst: { value: "10", quality: "" } },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=159034",
    },
    "Mausser Chemical Streamer": {
      name: "Mausser Chemical Streamer",
      min: 1,
      max: 200,
      type: "Smg",
      blurb: "Tradeskilled_from_Mausser_Particle_Streamer.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "3s", quality: "r" },
        rSpeed: { value: "1s", quality: "" },
        range: { value: "16 m", quality: "" },
        minDamage: { value: "1", quality: "r" },
        maxDamage: { value: "400", quality: "g" },
        critMod: { value: "350", quality: "g" },
        attackCap: { value: "2250", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "861", quality: "" },
          Burst: { value: "646", quality: "" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=157716",
    },
    "Mausser Particle Streamer": {
      name: "Mausser Particle Streamer",
      min: 1,
      max: 200,
      type: "Smg",
      blurb:
        "Part common loot pools, shops and is blitzable. Tradeskills into Mausser_Chemical_Streamer.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "" },
        rSpeed: { value: "3s", quality: "r" },
        range: { value: "30 m", quality: "" },
        minDamage: { value: "7", quality: "" },
        maxDamage: { value: "342", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "814", quality: "" },
          Burst: { value: "611", quality: "" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 1,
      auno: "https://auno.org/ao/db.php?id=122443",
    },
    "Mortiig Beamer": {
      name: "Mortiig Beamer",
      min: 80,
      max: 200,
      type: "Smg",
      blurb:
        "Drops from Mortiig bosses in Elysium, Shadowlands. Fixer only. Notable locations include Spade Beach and Eastfang. ",
      stats: {
        ql: { value: "100-125", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "350", quality: "g" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "750", quality: "r" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "625", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Fixer", quality: "" },
          Smg: { value: "626", quality: "g" },
          Burst: { value: "470", quality: "" },
        },
        mods: { "Dodge ranged": { value: "40", quality: "" } },
      },
      profs: ["Fixer"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=246333",
    },
    "MTI - Russian Good Day": {
      versions: [
        {
          name: "MTI - Russian Good Day",
          min: 1,
          max: 200,
          type: "Smg",
          blurb: "Blitzable, drops from common loot pools, and shop buyable. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "1s", quality: "g" },
            range: { value: "22 m", quality: "" },
            minDamage: { value: "1", quality: "" },
            maxDamage: { value: "280", quality: "" },
            critMod: { value: "280", quality: "" },
            attackCap: { value: "2500", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "788", quality: "" },
            specials: { value: "Burst", quality: "" },
            reqs: {
              Smg: { value: "951", quality: "" },
              Burst: { value: "713", quality: "" },
            },
            mods: { "Dodge ranged": { value: "15", quality: "" } },
          },
          profs: ["Fixer", "Soldier"],
          prk: false,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159115",
        },
        {
          name: "MTI - Russian Good Day",
          min: 1,
          max: 200,
          type: "Smg",
          blurb:
            "Blitzable, drops from common loot pools, and shop buyable from trader shops. ",
          stats: {
            ql: { value: "1-200", quality: "" },
            dual: { value: "Yes", quality: "" },
            aSpeed: { value: "2s", quality: "" },
            rSpeed: { value: "1s", quality: "g" },
            range: { value: "22 m", quality: "" },
            minDamage: { value: "1", quality: "" },
            maxDamage: { value: "280", quality: "" },
            critMod: { value: "280", quality: "" },
            attackCap: { value: "2500", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "788", quality: "" },
            specials: { value: "Burst", quality: "" },
            reqs: {
              Smg: { value: "951", quality: "" },
              Burst: { value: "713", quality: "" },
            },
            mods: { "Dodge ranged": { value: "15", quality: "" } },
          },
          profs: ["Fixer", "Soldier"],
          prk: true,
          diff: 2,
          auno: "https://auno.org/ao/db.php?id=159115",
        },
      ],
    },
    "Ofab Hawk Mk 5": {
      name: "Ofab Hawk Mk 5",
      min: 1,
      max: 220,
      type: "Smg",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials. The next version, Mk_6, is two handed.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "258", quality: "g" },
        maxDamage: { value: "405", quality: "" },
        critMod: { value: "284", quality: "" },
        attackCap: { value: "2600", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "1474", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Smg: { value: "2101", quality: "" },
          Burst: { value: "1576", quality: "" },
          "Full auto": { value: "1891", quality: "r" },
        },
        mods: {},
      },
      profs: [],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=265187",
    },
    "Ofab Hawk Mk 6": {
      name: "Ofab Hawk Mk 6",
      min: 1,
      max: 220,
      type: "Smg",
      blurb:
        "Weapon base is buyable from battlestation vendors with victory points. Upgraded to higher marks with_alien_materials. The previous version, Mk_5, is one handed.",
      stats: {
        ql: { value: "1-300", quality: "" },
        dual: { value: "No", quality: "r" },
        aSpeed: { value: "1.2s", quality: "g" },
        rSpeed: { value: "1.2s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "325", quality: "g" },
        maxDamage: { value: "475", quality: "g" },
        critMod: { value: "350", quality: "" },
        attackCap: { value: "2600", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst, Full Auto", quality: "g" },
        reqs: {
          "Expansion sets": { value: "Lost Eden", quality: "r" },
          Smg: { value: "2101", quality: "" },
          Burst: { value: "1576", quality: "" },
          "Full auto": { value: "1891", quality: "r" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=265194",
    },
    "OT Kerans Automatic Grinner": {
      name: "OT Kerans Automatic Grinner",
      min: 1,
      max: 200,
      type: "Smg",
      blurb: "Blitzable, drops from common loot pools, and shop buyable.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.45s", quality: "" },
        range: { value: "27 m", quality: "" },
        minDamage: { value: "1", quality: "" },
        maxDamage: { value: "295", quality: "" },
        critMod: { value: "295", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "946", quality: "" },
          Burst: { value: "710", quality: "" },
        },
        mods: { Sense: { value: "6", quality: "" } },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=160480",
    },
    "Perennium Beamer": {
      name: "Perennium Beamer",
      min: 30,
      max: 200,
      type: "Smg",
      blurb:
        "Crafted from a Nano-Charged_weapon_and_a_bunch_of_SL_parts. Fixer only. ",
      stats: {
        ql: { value: "50-200", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "20 m", quality: "" },
        minDamage: { value: "175", quality: "" },
        maxDamage: { value: "425", quality: "g" },
        critMod: { value: "150", quality: "" },
        attackCap: { value: "1500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Profession: { value: "Fixer", quality: "r" },
          Smg: { value: "1001", quality: "" },
          Burst: { value: "751", quality: "" },
        },
        mods: { "Experience modifier": { value: "4", quality: "" } },
      },
      profs: ["Fixer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=246421",
    },
    "Sacrosanct Blaster": {
      name: "Sacrosanct Blaster",
      min: 80,
      max: 200,
      type: "Smg",
      blurb:
        "Drops from Unredeemed mobs in the Shadowlands. Can be upgraded to a turn_spirit_weapon. Effectively a clan Inamorata_Blaster.",
      stats: {
        ql: { value: "100-300", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1.5s", quality: "" },
        rSpeed: { value: "1.5s", quality: "" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "75", quality: "" },
        maxDamage: { value: "500", quality: "" },
        critMod: { value: "75", quality: "" },
        attackCap: { value: "1900", quality: "" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "", quality: "r" },
        reqs: {
          "Faction Redeemed": { value: "35001", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Smg: { value: "1601", quality: "" },
        },
        mods: {
          "Max health": { value: "200", quality: "" },
          "Max nano": { value: "100", quality: "" },
        },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=212252",
    },
    "Sleekmaster Classic": {
      name: "Sleekmaster Classic",
      min: 1,
      max: 200,
      type: "Smg",
      blurb: "Blitzable, drops from common loot pools, and shop buyable.",
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "21 m", quality: "" },
        minDamage: { value: "25", quality: "" },
        maxDamage: { value: "310", quality: "" },
        critMod: { value: "295", quality: "g" },
        attackCap: { value: "2000", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "727", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Smg: { value: "595", quality: "g" },
          "Ranged energy": { value: "397", quality: "r" },
          Burst: { value: "496", quality: "g" },
        },
        mods: { Perception: { value: "16", quality: "" } },
      },
      profs: ["Fixer", "Soldier"],
      prk: false,
      diff: 2,
      auno: "https://auno.org/ao/db.php?id=160499",
    },
    "Special Edition Kyr'Ozch Submachine Gun": {
      versions: [
        {
          name: "Special Edition Kyr'Ozch Submachine Gun",
          min: 151,
          max: 200,
          type: "Smg",
          blurb:
            "Drops from Sector_07_aliens. Fixer and Soldier only. Level locked to 151. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "180", quality: "g" },
            maxDamage: { value: "272", quality: "" },
            critMod: { value: "190", quality: "" },
            attackCap: { value: "1500", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Burst, Full Auto", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Fixer or Soldier", quality: "r" },
              Level: { value: "151", quality: "r" },
              Smg: { value: "700", quality: "" },
              Burst: { value: "500", quality: "" },
              "Full auto": { value: "400", quality: "" },
            },
            mods: {},
          },
          profs: ["Fixer", "Soldier"],
          prk: false,
          diff: 6,
          auno: "https://auno.org/ao/db.php?id=288295",
        },
        {
          name: "Special Edition Kyr'Ozch Submachine Gun",
          min: 151,
          max: 200,
          type: "Smg",
          blurb:
            "Drops from Sector_07_aliens. Fixer and Soldier only. Hits have a 5% chance to proc a AAO buff.",
          stats: {
            ql: { value: "150", quality: "" },
            dual: { value: "No", quality: "" },
            aSpeed: { value: "1.2s", quality: "g" },
            rSpeed: { value: "1.2s", quality: "g" },
            range: { value: "25 m", quality: "" },
            minDamage: { value: "180", quality: "g" },
            maxDamage: { value: "272", quality: "" },
            critMod: { value: "190", quality: "" },
            attackCap: { value: "1500", quality: "g" },
            init: { value: "Ranged", quality: "" },
            multi: { value: "", quality: "" },
            specials: { value: "Burst, Full Auto", quality: "g" },
            reqs: {
              "Expansion sets": { value: "Alien Invasion", quality: "r" },
              Profession: { value: "Fixer or Soldier", quality: "r" },
              Smg: { value: "700", quality: "" },
              Burst: { value: "500", quality: "" },
              "Full auto": { value: "400", quality: "" },
            },
            mods: {},
          },
          profs: ["Fixer", "Soldier"],
          prk: true,
          diff: 5,
          auno: "https://auno.org/ao/db.php?id=288295",
        },
      ],
    },
    "Summer Shells SMP": {
      name: "Summer Shells SMP",
      min: 1,
      max: 200,
      type: "Smg",
      blurb:
        'Crafted from sealed_weapon_receptacles. Comes in 4 different flavors, but the "Shells" version is the most competitive. Checks against duck explosions.',
      stats: {
        ql: { value: "1-200", quality: "" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "1.8s", quality: "" },
        rSpeed: { value: "1.8s", quality: "" },
        range: { value: "15 m", quality: "" },
        minDamage: { value: "30", quality: "" },
        maxDamage: { value: "320", quality: "" },
        critMod: { value: "470", quality: "g" },
        attackCap: { value: "2500", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "856", quality: "" },
        specials: { value: "", quality: "" },
        reqs: {
          Smg: { value: "902", quality: "" },
          Shotgun: { value: "602", quality: "r" },
        },
        mods: {},
      },
      profs: ["Fixer", "Soldier", "Trader"],
      prk: false,
      diff: 4,
      auno: "https://auno.org/ao/db.php?id=157295",
    },
    Superjolt: {
      name: "Superjolt",
      min: 100,
      max: 200,
      type: "Smg",
      blurb: "Drops from Dynas. Fixer only.",
      stats: {
        ql: { value: "140-150", quality: "r" },
        dual: { value: "Yes", quality: "" },
        aSpeed: { value: "2.5s", quality: "r" },
        rSpeed: { value: "2.5s", quality: "r" },
        range: { value: "24 m", quality: "" },
        minDamage: { value: "50", quality: "" },
        maxDamage: { value: "300", quality: "" },
        critMod: { value: "250", quality: "" },
        attackCap: { value: "1900", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "712", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Profession: { value: "Fixer", quality: "r" },
          Smg: { value: "713", quality: "" },
          Burst: { value: "535", quality: "" },
        },
        mods: {
          "Max health": { value: "54", quality: "" },
          "Dodge ranged": { value: "18", quality: "" },
          "Computer literacy": { value: "6", quality: "" },
        },
      },
      profs: ["Fixer"],
      prk: false,
      diff: 3,
      auno: "https://auno.org/ao/db.php?id=207997",
    },
    // drop is vague, need more info
    "Syndicate Messenger Gun": {
      name: "Syndicate Messenger Gun",
      min: 175,
      max: 220,
      type: "Smg",
      blurb:
        "Drops from Spirits in Inferno, Shadowlands. Fixer only. Stats are fixed between QLs except MBS.",
      stats: {
        ql: { value: "240-260", quality: "r" },
        dual: { value: "No", quality: "" },
        aSpeed: { value: "1s", quality: "g" },
        rSpeed: { value: "1s", quality: "g" },
        range: { value: "25 m", quality: "" },
        minDamage: { value: "200", quality: "g" },
        maxDamage: { value: "325", quality: "" },
        critMod: { value: "550", quality: "g" },
        attackCap: { value: "2000", quality: "g" },
        init: { value: "Ranged", quality: "" },
        multi: { value: "", quality: "" },
        specials: { value: "Burst", quality: "" },
        reqs: {
          Profession: { value: "Fixer", quality: "r" },
          "Expansion sets": { value: "Shadowlands", quality: "r" },
          Smg: { value: "1601", quality: "" },
          Burst: { value: "1201", quality: "" },
        },
        mods: { "Run speed": { value: "100", quality: "" } },
      },
      profs: ["Fixer"],
      prk: false,
      diff: 5,
      auno: "https://auno.org/ao/db.php?id=245799",
    },
  },
};

export default db;
